/*! jQuery v3.5.1 | (c) JS Foundation and other contributors | jquery.org/license */ ! function(e, t) {
    "use strict";
    "object" == typeof module && "object" == typeof module.exports ? module.exports = e.document ? t(e, !0) : function(e) {
        if (!e.document) throw new Error("jQuery requires a window with a document");
        return t(e)
    } : t(e)
}("undefined" != typeof window ? window : this, (function(e, t) {
    "use strict";
    var n = [],
        a = Object.getPrototypeOf,
        i = n.slice,
        o = n.flat ? function(e) {
            return n.flat.call(e)
        } : function(e) {
            return n.concat.apply([], e)
        },
        r = n.push,
        s = n.indexOf,
        u = {},
        c = u.toString,
        l = u.hasOwnProperty,
        d = l.toString,
        p = d.call(Object),
        f = {},
        h = function(e) {
            return "function" == typeof e && "number" != typeof e.nodeType
        },
        m = function(e) {
            return null != e && e === e.window
        },
        g = e.document,
        v = {
            type: !0,
            src: !0,
            nonce: !0,
            noModule: !0
        };

    function y(e, t, n) {
        var a, i, o = (n = n || g).createElement("script");
        if (o.text = e, t)
            for (a in v)(i = t[a] || t.getAttribute && t.getAttribute(a)) && o.setAttribute(a, i);
        n.head.appendChild(o).parentNode.removeChild(o)
    }

    function b(e) {
        return null == e ? e + "" : "object" == typeof e || "function" == typeof e ? u[c.call(e)] || "object" : typeof e
    }
    var x = "3.5.1",
        _ = function(e, t) {
            return new _.fn.init(e, t)
        };

    function w(e) {
        var t = !!e && "length" in e && e.length,
            n = b(e);
        return !h(e) && !m(e) && ("array" === n || 0 === t || "number" == typeof t && 0 < t && t - 1 in e)
    }
    _.fn = _.prototype = {
        jquery: x,
        constructor: _,
        length: 0,
        toArray: function() {
            return i.call(this)
        },
        get: function(e) {
            return null == e ? i.call(this) : e < 0 ? this[e + this.length] : this[e]
        },
        pushStack: function(e) {
            var t = _.merge(this.constructor(), e);
            return t.prevObject = this, t
        },
        each: function(e) {
            return _.each(this, e)
        },
        map: function(e) {
            return this.pushStack(_.map(this, (function(t, n) {
                return e.call(t, n, t)
            })))
        },
        slice: function() {
            return this.pushStack(i.apply(this, arguments))
        },
        first: function() {
            return this.eq(0)
        },
        last: function() {
            return this.eq(-1)
        },
        even: function() {
            return this.pushStack(_.grep(this, (function(e, t) {
                return (t + 1) % 2
            })))
        },
        odd: function() {
            return this.pushStack(_.grep(this, (function(e, t) {
                return t % 2
            })))
        },
        eq: function(e) {
            var t = this.length,
                n = +e + (e < 0 ? t : 0);
            return this.pushStack(0 <= n && n < t ? [this[n]] : [])
        },
        end: function() {
            return this.prevObject || this.constructor()
        },
        push: r,
        sort: n.sort,
        splice: n.splice
    }, _.extend = _.fn.extend = function() {
        var e, t, n, a, i, o, r = arguments[0] || {},
            s = 1,
            u = arguments.length,
            c = !1;
        for ("boolean" == typeof r && (c = r, r = arguments[s] || {}, s++), "object" == typeof r || h(r) || (r = {}), s === u && (r = this, s--); s < u; s++)
            if (null != (e = arguments[s]))
                for (t in e) a = e[t], "__proto__" !== t && r !== a && (c && a && (_.isPlainObject(a) || (i = Array.isArray(a))) ? (n = r[t], o = i && !Array.isArray(n) ? [] : i || _.isPlainObject(n) ? n : {}, i = !1, r[t] = _.extend(c, o, a)) : void 0 !== a && (r[t] = a));
        return r
    }, _.extend({
        expando: "jQuery" + (x + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function(e) {
            throw new Error(e)
        },
        noop: function() {},
        isPlainObject: function(e) {
            var t, n;
            return !(!e || "[object Object]" !== c.call(e) || (t = a(e)) && ("function" != typeof(n = l.call(t, "constructor") && t.constructor) || d.call(n) !== p))
        },
        isEmptyObject: function(e) {
            var t;
            for (t in e) return !1;
            return !0
        },
        globalEval: function(e, t, n) {
            y(e, {
                nonce: t && t.nonce
            }, n)
        },
        each: function(e, t) {
            var n, a = 0;
            if (w(e))
                for (n = e.length; a < n && !1 !== t.call(e[a], a, e[a]); a++);
            else
                for (a in e)
                    if (!1 === t.call(e[a], a, e[a])) break;
            return e
        },
        makeArray: function(e, t) {
            var n = t || [];
            return null != e && (w(Object(e)) ? _.merge(n, "string" == typeof e ? [e] : e) : r.call(n, e)), n
        },
        inArray: function(e, t, n) {
            return null == t ? -1 : s.call(t, e, n)
        },
        merge: function(e, t) {
            for (var n = +t.length, a = 0, i = e.length; a < n; a++) e[i++] = t[a];
            return e.length = i, e
        },
        grep: function(e, t, n) {
            for (var a = [], i = 0, o = e.length, r = !n; i < o; i++) !t(e[i], i) !== r && a.push(e[i]);
            return a
        },
        map: function(e, t, n) {
            var a, i, r = 0,
                s = [];
            if (w(e))
                for (a = e.length; r < a; r++) null != (i = t(e[r], r, n)) && s.push(i);
            else
                for (r in e) null != (i = t(e[r], r, n)) && s.push(i);
            return o(s)
        },
        guid: 1,
        support: f
    }), "function" == typeof Symbol && (_.fn[Symbol.iterator] = n[Symbol.iterator]), _.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), (function(e, t) {
        u["[object " + t + "]"] = t.toLowerCase()
    }));
    var C = function(e) {
        var t, n, a, i, o, r, s, u, c, l, d, p, f, h, m, g, v, y, b, x = "sizzle" + 1 * new Date,
            _ = e.document,
            w = 0,
            C = 0,
            j = ue(),
            S = ue(),
            T = ue(),
            k = ue(),
            $ = function(e, t) {
                return e === t && (d = !0), 0
            },
            E = {}.hasOwnProperty,
            A = [],
            D = A.pop,
            L = A.push,
            P = A.push,
            N = A.slice,
            O = function(e, t) {
                for (var n = 0, a = e.length; n < a; n++)
                    if (e[n] === t) return n;
                return -1
            },
            q = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
            I = "[\\x20\\t\\r\\n\\f]",
            H = "(?:\\\\[\\da-fA-F]{1,6}" + I + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
            M = "\\[" + I + "*(" + H + ")(?:" + I + "*([*^$|!~]?=)" + I + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + H + "))|)" + I + "*\\]",
            B = ":(" + H + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + M + ")*)|.*)\\)|)",
            R = new RegExp(I + "+", "g"),
            z = new RegExp("^" + I + "+|((?:^|[^\\\\])(?:\\\\.)*)" + I + "+$", "g"),
            F = new RegExp("^" + I + "*," + I + "*"),
            W = new RegExp("^" + I + "*([>+~]|" + I + ")" + I + "*"),
            U = new RegExp(I + "|>"),
            Q = new RegExp(B),
            V = new RegExp("^" + H + "$"),
            J = {
                ID: new RegExp("^#(" + H + ")"),
                CLASS: new RegExp("^\\.(" + H + ")"),
                TAG: new RegExp("^(" + H + "|[*])"),
                ATTR: new RegExp("^" + M),
                PSEUDO: new RegExp("^" + B),
                CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + I + "*(even|odd|(([+-]|)(\\d*)n|)" + I + "*(?:([+-]|)" + I + "*(\\d+)|))" + I + "*\\)|)", "i"),
                bool: new RegExp("^(?:" + q + ")$", "i"),
                needsContext: new RegExp("^" + I + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + I + "*((?:-\\d)?\\d*)" + I + "*\\)|)(?=[^-]|$)", "i")
            },
            G = /HTML$/i,
            X = /^(?:input|select|textarea|button)$/i,
            Y = /^h\d$/i,
            K = /^[^{]+\{\s*\[native \w/,
            Z = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
            ee = /[+~]/,
            te = new RegExp("\\\\[\\da-fA-F]{1,6}" + I + "?|\\\\([^\\r\\n\\f])", "g"),
            ne = function(e, t) {
                var n = "0x" + e.slice(1) - 65536;
                return t || (n < 0 ? String.fromCharCode(n + 65536) : String.fromCharCode(n >> 10 | 55296, 1023 & n | 56320))
            },
            ae = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
            ie = function(e, t) {
                return t ? "\0" === e ? " " : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " " : "\\" + e
            },
            oe = function() {
                p()
            },
            re = xe((function(e) {
                return !0 === e.disabled && "fieldset" === e.nodeName.toLowerCase()
            }), {
                dir: "parentNode",
                next: "legend"
            });
        try {
            P.apply(A = N.call(_.childNodes), _.childNodes), A[_.childNodes.length].nodeType
        } catch (t) {
            P = {
                apply: A.length ? function(e, t) {
                    L.apply(e, N.call(t))
                } : function(e, t) {
                    for (var n = e.length, a = 0; e[n++] = t[a++];);
                    e.length = n - 1
                }
            }
        }

        function se(e, t, a, i) {
            var o, s, c, l, d, h, v, y = t && t.ownerDocument,
                _ = t ? t.nodeType : 9;
            if (a = a || [], "string" != typeof e || !e || 1 !== _ && 9 !== _ && 11 !== _) return a;
            if (!i && (p(t), t = t || f, m)) {
                if (11 !== _ && (d = Z.exec(e)))
                    if (o = d[1]) {
                        if (9 === _) {
                            if (!(c = t.getElementById(o))) return a;
                            if (c.id === o) return a.push(c), a
                        } else if (y && (c = y.getElementById(o)) && b(t, c) && c.id === o) return a.push(c), a
                    } else {
                        if (d[2]) return P.apply(a, t.getElementsByTagName(e)), a;
                        if ((o = d[3]) && n.getElementsByClassName && t.getElementsByClassName) return P.apply(a, t.getElementsByClassName(o)), a
                    } if (n.qsa && !k[e + " "] && (!g || !g.test(e)) && (1 !== _ || "object" !== t.nodeName.toLowerCase())) {
                    if (v = e, y = t, 1 === _ && (U.test(e) || W.test(e))) {
                        for ((y = ee.test(e) && ve(t.parentNode) || t) === t && n.scope || ((l = t.getAttribute("id")) ? l = l.replace(ae, ie) : t.setAttribute("id", l = x)), s = (h = r(e)).length; s--;) h[s] = (l ? "#" + l : ":scope") + " " + be(h[s]);
                        v = h.join(",")
                    }
                    try {
                        return P.apply(a, y.querySelectorAll(v)), a
                    } catch (t) {
                        k(e, !0)
                    } finally {
                        l === x && t.removeAttribute("id")
                    }
                }
            }
            return u(e.replace(z, "$1"), t, a, i)
        }

        function ue() {
            var e = [];
            return function t(n, i) {
                return e.push(n + " ") > a.cacheLength && delete t[e.shift()], t[n + " "] = i
            }
        }

        function ce(e) {
            return e[x] = !0, e
        }

        function le(e) {
            var t = f.createElement("fieldset");
            try {
                return !!e(t)
            } catch (e) {
                return !1
            } finally {
                t.parentNode && t.parentNode.removeChild(t), t = null
            }
        }

        function de(e, t) {
            for (var n = e.split("|"), i = n.length; i--;) a.attrHandle[n[i]] = t
        }

        function pe(e, t) {
            var n = t && e,
                a = n && 1 === e.nodeType && 1 === t.nodeType && e.sourceIndex - t.sourceIndex;
            if (a) return a;
            if (n)
                for (; n = n.nextSibling;)
                    if (n === t) return -1;
            return e ? 1 : -1
        }

        function fe(e) {
            return function(t) {
                return "input" === t.nodeName.toLowerCase() && t.type === e
            }
        }

        function he(e) {
            return function(t) {
                var n = t.nodeName.toLowerCase();
                return ("input" === n || "button" === n) && t.type === e
            }
        }

        function me(e) {
            return function(t) {
                return "form" in t ? t.parentNode && !1 === t.disabled ? "label" in t ? "label" in t.parentNode ? t.parentNode.disabled === e : t.disabled === e : t.isDisabled === e || t.isDisabled !== !e && re(t) === e : t.disabled === e : "label" in t && t.disabled === e
            }
        }

        function ge(e) {
            return ce((function(t) {
                return t = +t, ce((function(n, a) {
                    for (var i, o = e([], n.length, t), r = o.length; r--;) n[i = o[r]] && (n[i] = !(a[i] = n[i]))
                }))
            }))
        }

        function ve(e) {
            return e && void 0 !== e.getElementsByTagName && e
        }
        for (t in n = se.support = {}, o = se.isXML = function(e) {
                var t = e.namespaceURI,
                    n = (e.ownerDocument || e).documentElement;
                return !G.test(t || n && n.nodeName || "HTML")
            }, p = se.setDocument = function(e) {
                var t, i, r = e ? e.ownerDocument || e : _;
                return r != f && 9 === r.nodeType && r.documentElement && (h = (f = r).documentElement, m = !o(f), _ != f && (i = f.defaultView) && i.top !== i && (i.addEventListener ? i.addEventListener("unload", oe, !1) : i.attachEvent && i.attachEvent("onunload", oe)), n.scope = le((function(e) {
                    return h.appendChild(e).appendChild(f.createElement("div")), void 0 !== e.querySelectorAll && !e.querySelectorAll(":scope fieldset div").length
                })), n.attributes = le((function(e) {
                    return e.className = "i", !e.getAttribute("className")
                })), n.getElementsByTagName = le((function(e) {
                    return e.appendChild(f.createComment("")), !e.getElementsByTagName("*").length
                })), n.getElementsByClassName = K.test(f.getElementsByClassName), n.getById = le((function(e) {
                    return h.appendChild(e).id = x, !f.getElementsByName || !f.getElementsByName(x).length
                })), n.getById ? (a.filter.ID = function(e) {
                    var t = e.replace(te, ne);
                    return function(e) {
                        return e.getAttribute("id") === t
                    }
                }, a.find.ID = function(e, t) {
                    if (void 0 !== t.getElementById && m) {
                        var n = t.getElementById(e);
                        return n ? [n] : []
                    }
                }) : (a.filter.ID = function(e) {
                    var t = e.replace(te, ne);
                    return function(e) {
                        var n = void 0 !== e.getAttributeNode && e.getAttributeNode("id");
                        return n && n.value === t
                    }
                }, a.find.ID = function(e, t) {
                    if (void 0 !== t.getElementById && m) {
                        var n, a, i, o = t.getElementById(e);
                        if (o) {
                            if ((n = o.getAttributeNode("id")) && n.value === e) return [o];
                            for (i = t.getElementsByName(e), a = 0; o = i[a++];)
                                if ((n = o.getAttributeNode("id")) && n.value === e) return [o]
                        }
                        return []
                    }
                }), a.find.TAG = n.getElementsByTagName ? function(e, t) {
                    return void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e) : n.qsa ? t.querySelectorAll(e) : void 0
                } : function(e, t) {
                    var n, a = [],
                        i = 0,
                        o = t.getElementsByTagName(e);
                    if ("*" === e) {
                        for (; n = o[i++];) 1 === n.nodeType && a.push(n);
                        return a
                    }
                    return o
                }, a.find.CLASS = n.getElementsByClassName && function(e, t) {
                    if (void 0 !== t.getElementsByClassName && m) return t.getElementsByClassName(e)
                }, v = [], g = [], (n.qsa = K.test(f.querySelectorAll)) && (le((function(e) {
                    var t;
                    h.appendChild(e).innerHTML = "<a id='" + x + "'></a><select id='" + x + "-\r\\' msallowcapture=''><option selected=''></option></select>", e.querySelectorAll("[msallowcapture^='']").length && g.push("[*^$]=" + I + "*(?:''|\"\")"), e.querySelectorAll("[selected]").length || g.push("\\[" + I + "*(?:value|" + q + ")"), e.querySelectorAll("[id~=" + x + "-]").length || g.push("~="), (t = f.createElement("input")).setAttribute("name", ""), e.appendChild(t), e.querySelectorAll("[name='']").length || g.push("\\[" + I + "*name" + I + "*=" + I + "*(?:''|\"\")"), e.querySelectorAll(":checked").length || g.push(":checked"), e.querySelectorAll("a#" + x + "+*").length || g.push(".#.+[+~]"), e.querySelectorAll("\\\f"), g.push("[\\r\\n\\f]")
                })), le((function(e) {
                    e.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                    var t = f.createElement("input");
                    t.setAttribute("type", "hidden"), e.appendChild(t).setAttribute("name", "D"), e.querySelectorAll("[name=d]").length && g.push("name" + I + "*[*^$|!~]?="), 2 !== e.querySelectorAll(":enabled").length && g.push(":enabled", ":disabled"), h.appendChild(e).disabled = !0, 2 !== e.querySelectorAll(":disabled").length && g.push(":enabled", ":disabled"), e.querySelectorAll("*,:x"), g.push(",.*:")
                }))), (n.matchesSelector = K.test(y = h.matches || h.webkitMatchesSelector || h.mozMatchesSelector || h.oMatchesSelector || h.msMatchesSelector)) && le((function(e) {
                    n.disconnectedMatch = y.call(e, "*"), y.call(e, "[s!='']:x"), v.push("!=", B)
                })), g = g.length && new RegExp(g.join("|")), v = v.length && new RegExp(v.join("|")), t = K.test(h.compareDocumentPosition), b = t || K.test(h.contains) ? function(e, t) {
                    var n = 9 === e.nodeType ? e.documentElement : e,
                        a = t && t.parentNode;
                    return e === a || !(!a || 1 !== a.nodeType || !(n.contains ? n.contains(a) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(a)))
                } : function(e, t) {
                    if (t)
                        for (; t = t.parentNode;)
                            if (t === e) return !0;
                    return !1
                }, $ = t ? function(e, t) {
                    if (e === t) return d = !0, 0;
                    var a = !e.compareDocumentPosition - !t.compareDocumentPosition;
                    return a || (1 & (a = (e.ownerDocument || e) == (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || !n.sortDetached && t.compareDocumentPosition(e) === a ? e == f || e.ownerDocument == _ && b(_, e) ? -1 : t == f || t.ownerDocument == _ && b(_, t) ? 1 : l ? O(l, e) - O(l, t) : 0 : 4 & a ? -1 : 1)
                } : function(e, t) {
                    if (e === t) return d = !0, 0;
                    var n, a = 0,
                        i = e.parentNode,
                        o = t.parentNode,
                        r = [e],
                        s = [t];
                    if (!i || !o) return e == f ? -1 : t == f ? 1 : i ? -1 : o ? 1 : l ? O(l, e) - O(l, t) : 0;
                    if (i === o) return pe(e, t);
                    for (n = e; n = n.parentNode;) r.unshift(n);
                    for (n = t; n = n.parentNode;) s.unshift(n);
                    for (; r[a] === s[a];) a++;
                    return a ? pe(r[a], s[a]) : r[a] == _ ? -1 : s[a] == _ ? 1 : 0
                }), f
            }, se.matches = function(e, t) {
                return se(e, null, null, t)
            }, se.matchesSelector = function(e, t) {
                if (p(e), n.matchesSelector && m && !k[t + " "] && (!v || !v.test(t)) && (!g || !g.test(t))) try {
                    var a = y.call(e, t);
                    if (a || n.disconnectedMatch || e.document && 11 !== e.document.nodeType) return a
                } catch (e) {
                    k(t, !0)
                }
                return 0 < se(t, f, null, [e]).length
            }, se.contains = function(e, t) {
                return (e.ownerDocument || e) != f && p(e), b(e, t)
            }, se.attr = function(e, t) {
                (e.ownerDocument || e) != f && p(e);
                var i = a.attrHandle[t.toLowerCase()],
                    o = i && E.call(a.attrHandle, t.toLowerCase()) ? i(e, t, !m) : void 0;
                return void 0 !== o ? o : n.attributes || !m ? e.getAttribute(t) : (o = e.getAttributeNode(t)) && o.specified ? o.value : null
            }, se.escape = function(e) {
                return (e + "").replace(ae, ie)
            }, se.error = function(e) {
                throw new Error("Syntax error, unrecognized expression: " + e)
            }, se.uniqueSort = function(e) {
                var t, a = [],
                    i = 0,
                    o = 0;
                if (d = !n.detectDuplicates, l = !n.sortStable && e.slice(0), e.sort($), d) {
                    for (; t = e[o++];) t === e[o] && (i = a.push(o));
                    for (; i--;) e.splice(a[i], 1)
                }
                return l = null, e
            }, i = se.getText = function(e) {
                var t, n = "",
                    a = 0,
                    o = e.nodeType;
                if (o) {
                    if (1 === o || 9 === o || 11 === o) {
                        if ("string" == typeof e.textContent) return e.textContent;
                        for (e = e.firstChild; e; e = e.nextSibling) n += i(e)
                    } else if (3 === o || 4 === o) return e.nodeValue
                } else
                    for (; t = e[a++];) n += i(t);
                return n
            }, (a = se.selectors = {
                cacheLength: 50,
                createPseudo: ce,
                match: J,
                attrHandle: {},
                find: {},
                relative: {
                    ">": {
                        dir: "parentNode",
                        first: !0
                    },
                    " ": {
                        dir: "parentNode"
                    },
                    "+": {
                        dir: "previousSibling",
                        first: !0
                    },
                    "~": {
                        dir: "previousSibling"
                    }
                },
                preFilter: {
                    ATTR: function(e) {
                        return e[1] = e[1].replace(te, ne), e[3] = (e[3] || e[4] || e[5] || "").replace(te, ne), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4)
                    },
                    CHILD: function(e) {
                        return e[1] = e[1].toLowerCase(), "nth" === e[1].slice(0, 3) ? (e[3] || se.error(e[0]), e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])), e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && se.error(e[0]), e
                    },
                    PSEUDO: function(e) {
                        var t, n = !e[6] && e[2];
                        return J.CHILD.test(e[0]) ? null : (e[3] ? e[2] = e[4] || e[5] || "" : n && Q.test(n) && (t = r(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && (e[0] = e[0].slice(0, t), e[2] = n.slice(0, t)), e.slice(0, 3))
                    }
                },
                filter: {
                    TAG: function(e) {
                        var t = e.replace(te, ne).toLowerCase();
                        return "*" === e ? function() {
                            return !0
                        } : function(e) {
                            return e.nodeName && e.nodeName.toLowerCase() === t
                        }
                    },
                    CLASS: function(e) {
                        var t = j[e + " "];
                        return t || (t = new RegExp("(^|" + I + ")" + e + "(" + I + "|$)")) && j(e, (function(e) {
                            return t.test("string" == typeof e.className && e.className || void 0 !== e.getAttribute && e.getAttribute("class") || "")
                        }))
                    },
                    ATTR: function(e, t, n) {
                        return function(a) {
                            var i = se.attr(a, e);
                            return null == i ? "!=" === t : !t || (i += "", "=" === t ? i === n : "!=" === t ? i !== n : "^=" === t ? n && 0 === i.indexOf(n) : "*=" === t ? n && -1 < i.indexOf(n) : "$=" === t ? n && i.slice(-n.length) === n : "~=" === t ? -1 < (" " + i.replace(R, " ") + " ").indexOf(n) : "|=" === t && (i === n || i.slice(0, n.length + 1) === n + "-"))
                        }
                    },
                    CHILD: function(e, t, n, a, i) {
                        var o = "nth" !== e.slice(0, 3),
                            r = "last" !== e.slice(-4),
                            s = "of-type" === t;
                        return 1 === a && 0 === i ? function(e) {
                            return !!e.parentNode
                        } : function(t, n, u) {
                            var c, l, d, p, f, h, m = o !== r ? "nextSibling" : "previousSibling",
                                g = t.parentNode,
                                v = s && t.nodeName.toLowerCase(),
                                y = !u && !s,
                                b = !1;
                            if (g) {
                                if (o) {
                                    for (; m;) {
                                        for (p = t; p = p[m];)
                                            if (s ? p.nodeName.toLowerCase() === v : 1 === p.nodeType) return !1;
                                        h = m = "only" === e && !h && "nextSibling"
                                    }
                                    return !0
                                }
                                if (h = [r ? g.firstChild : g.lastChild], r && y) {
                                    for (b = (f = (c = (l = (d = (p = g)[x] || (p[x] = {}))[p.uniqueID] || (d[p.uniqueID] = {}))[e] || [])[0] === w && c[1]) && c[2], p = f && g.childNodes[f]; p = ++f && p && p[m] || (b = f = 0) || h.pop();)
                                        if (1 === p.nodeType && ++b && p === t) {
                                            l[e] = [w, f, b];
                                            break
                                        }
                                } else if (y && (b = f = (c = (l = (d = (p = t)[x] || (p[x] = {}))[p.uniqueID] || (d[p.uniqueID] = {}))[e] || [])[0] === w && c[1]), !1 === b)
                                    for (;
                                        (p = ++f && p && p[m] || (b = f = 0) || h.pop()) && ((s ? p.nodeName.toLowerCase() !== v : 1 !== p.nodeType) || !++b || (y && ((l = (d = p[x] || (p[x] = {}))[p.uniqueID] || (d[p.uniqueID] = {}))[e] = [w, b]), p !== t)););
                                return (b -= i) === a || b % a == 0 && 0 <= b / a
                            }
                        }
                    },
                    PSEUDO: function(e, t) {
                        var n, i = a.pseudos[e] || a.setFilters[e.toLowerCase()] || se.error("unsupported pseudo: " + e);
                        return i[x] ? i(t) : 1 < i.length ? (n = [e, e, "", t], a.setFilters.hasOwnProperty(e.toLowerCase()) ? ce((function(e, n) {
                            for (var a, o = i(e, t), r = o.length; r--;) e[a = O(e, o[r])] = !(n[a] = o[r])
                        })) : function(e) {
                            return i(e, 0, n)
                        }) : i
                    }
                },
                pseudos: {
                    not: ce((function(e) {
                        var t = [],
                            n = [],
                            a = s(e.replace(z, "$1"));
                        return a[x] ? ce((function(e, t, n, i) {
                            for (var o, r = a(e, null, i, []), s = e.length; s--;)(o = r[s]) && (e[s] = !(t[s] = o))
                        })) : function(e, i, o) {
                            return t[0] = e, a(t, null, o, n), t[0] = null, !n.pop()
                        }
                    })),
                    has: ce((function(e) {
                        return function(t) {
                            return 0 < se(e, t).length
                        }
                    })),
                    contains: ce((function(e) {
                        return e = e.replace(te, ne),
                            function(t) {
                                return -1 < (t.textContent || i(t)).indexOf(e)
                            }
                    })),
                    lang: ce((function(e) {
                        return V.test(e || "") || se.error("unsupported lang: " + e), e = e.replace(te, ne).toLowerCase(),
                            function(t) {
                                var n;
                                do {
                                    if (n = m ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang")) return (n = n.toLowerCase()) === e || 0 === n.indexOf(e + "-")
                                } while ((t = t.parentNode) && 1 === t.nodeType);
                                return !1
                            }
                    })),
                    target: function(t) {
                        var n = e.location && e.location.hash;
                        return n && n.slice(1) === t.id
                    },
                    root: function(e) {
                        return e === h
                    },
                    focus: function(e) {
                        return e === f.activeElement && (!f.hasFocus || f.hasFocus()) && !!(e.type || e.href || ~e.tabIndex)
                    },
                    enabled: me(!1),
                    disabled: me(!0),
                    checked: function(e) {
                        var t = e.nodeName.toLowerCase();
                        return "input" === t && !!e.checked || "option" === t && !!e.selected
                    },
                    selected: function(e) {
                        return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected
                    },
                    empty: function(e) {
                        for (e = e.firstChild; e; e = e.nextSibling)
                            if (e.nodeType < 6) return !1;
                        return !0
                    },
                    parent: function(e) {
                        return !a.pseudos.empty(e)
                    },
                    header: function(e) {
                        return Y.test(e.nodeName)
                    },
                    input: function(e) {
                        return X.test(e.nodeName)
                    },
                    button: function(e) {
                        var t = e.nodeName.toLowerCase();
                        return "input" === t && "button" === e.type || "button" === t
                    },
                    text: function(e) {
                        var t;
                        return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase())
                    },
                    first: ge((function() {
                        return [0]
                    })),
                    last: ge((function(e, t) {
                        return [t - 1]
                    })),
                    eq: ge((function(e, t, n) {
                        return [n < 0 ? n + t : n]
                    })),
                    even: ge((function(e, t) {
                        for (var n = 0; n < t; n += 2) e.push(n);
                        return e
                    })),
                    odd: ge((function(e, t) {
                        for (var n = 1; n < t; n += 2) e.push(n);
                        return e
                    })),
                    lt: ge((function(e, t, n) {
                        for (var a = n < 0 ? n + t : t < n ? t : n; 0 <= --a;) e.push(a);
                        return e
                    })),
                    gt: ge((function(e, t, n) {
                        for (var a = n < 0 ? n + t : n; ++a < t;) e.push(a);
                        return e
                    }))
                }
            }).pseudos.nth = a.pseudos.eq, {
                radio: !0,
                checkbox: !0,
                file: !0,
                password: !0,
                image: !0
            }) a.pseudos[t] = fe(t);
        for (t in {
                submit: !0,
                reset: !0
            }) a.pseudos[t] = he(t);

        function ye() {}

        function be(e) {
            for (var t = 0, n = e.length, a = ""; t < n; t++) a += e[t].value;
            return a
        }

        function xe(e, t, n) {
            var a = t.dir,
                i = t.next,
                o = i || a,
                r = n && "parentNode" === o,
                s = C++;
            return t.first ? function(t, n, i) {
                for (; t = t[a];)
                    if (1 === t.nodeType || r) return e(t, n, i);
                return !1
            } : function(t, n, u) {
                var c, l, d, p = [w, s];
                if (u) {
                    for (; t = t[a];)
                        if ((1 === t.nodeType || r) && e(t, n, u)) return !0
                } else
                    for (; t = t[a];)
                        if (1 === t.nodeType || r)
                            if (l = (d = t[x] || (t[x] = {}))[t.uniqueID] || (d[t.uniqueID] = {}), i && i === t.nodeName.toLowerCase()) t = t[a] || t;
                            else {
                                if ((c = l[o]) && c[0] === w && c[1] === s) return p[2] = c[2];
                                if ((l[o] = p)[2] = e(t, n, u)) return !0
                            } return !1
            }
        }

        function _e(e) {
            return 1 < e.length ? function(t, n, a) {
                for (var i = e.length; i--;)
                    if (!e[i](t, n, a)) return !1;
                return !0
            } : e[0]
        }

        function we(e, t, n, a, i) {
            for (var o, r = [], s = 0, u = e.length, c = null != t; s < u; s++)(o = e[s]) && (n && !n(o, a, i) || (r.push(o), c && t.push(s)));
            return r
        }

        function Ce(e, t, n, a, i, o) {
            return a && !a[x] && (a = Ce(a)), i && !i[x] && (i = Ce(i, o)), ce((function(o, r, s, u) {
                var c, l, d, p = [],
                    f = [],
                    h = r.length,
                    m = o || function(e, t, n) {
                        for (var a = 0, i = t.length; a < i; a++) se(e, t[a], n);
                        return n
                    }(t || "*", s.nodeType ? [s] : s, []),
                    g = !e || !o && t ? m : we(m, p, e, s, u),
                    v = n ? i || (o ? e : h || a) ? [] : r : g;
                if (n && n(g, v, s, u), a)
                    for (c = we(v, f), a(c, [], s, u), l = c.length; l--;)(d = c[l]) && (v[f[l]] = !(g[f[l]] = d));
                if (o) {
                    if (i || e) {
                        if (i) {
                            for (c = [], l = v.length; l--;)(d = v[l]) && c.push(g[l] = d);
                            i(null, v = [], c, u)
                        }
                        for (l = v.length; l--;)(d = v[l]) && -1 < (c = i ? O(o, d) : p[l]) && (o[c] = !(r[c] = d))
                    }
                } else v = we(v === r ? v.splice(h, v.length) : v), i ? i(null, r, v, u) : P.apply(r, v)
            }))
        }

        function je(e) {
            for (var t, n, i, o = e.length, r = a.relative[e[0].type], s = r || a.relative[" "], u = r ? 1 : 0, l = xe((function(e) {
                    return e === t
                }), s, !0), d = xe((function(e) {
                    return -1 < O(t, e)
                }), s, !0), p = [function(e, n, a) {
                    var i = !r && (a || n !== c) || ((t = n).nodeType ? l(e, n, a) : d(e, n, a));
                    return t = null, i
                }]; u < o; u++)
                if (n = a.relative[e[u].type]) p = [xe(_e(p), n)];
                else {
                    if ((n = a.filter[e[u].type].apply(null, e[u].matches))[x]) {
                        for (i = ++u; i < o && !a.relative[e[i].type]; i++);
                        return Ce(1 < u && _e(p), 1 < u && be(e.slice(0, u - 1).concat({
                            value: " " === e[u - 2].type ? "*" : ""
                        })).replace(z, "$1"), n, u < i && je(e.slice(u, i)), i < o && je(e = e.slice(i)), i < o && be(e))
                    }
                    p.push(n)
                } return _e(p)
        }
        return ye.prototype = a.filters = a.pseudos, a.setFilters = new ye, r = se.tokenize = function(e, t) {
            var n, i, o, r, s, u, c, l = S[e + " "];
            if (l) return t ? 0 : l.slice(0);
            for (s = e, u = [], c = a.preFilter; s;) {
                for (r in n && !(i = F.exec(s)) || (i && (s = s.slice(i[0].length) || s), u.push(o = [])), n = !1, (i = W.exec(s)) && (n = i.shift(), o.push({
                        value: n,
                        type: i[0].replace(z, " ")
                    }), s = s.slice(n.length)), a.filter) !(i = J[r].exec(s)) || c[r] && !(i = c[r](i)) || (n = i.shift(), o.push({
                    value: n,
                    type: r,
                    matches: i
                }), s = s.slice(n.length));
                if (!n) break
            }
            return t ? s.length : s ? se.error(e) : S(e, u).slice(0)
        }, s = se.compile = function(e, t) {
            var n, i, o, s, u, l, d = [],
                h = [],
                g = T[e + " "];
            if (!g) {
                for (t || (t = r(e)), n = t.length; n--;)(g = je(t[n]))[x] ? d.push(g) : h.push(g);
                (g = T(e, (i = h, s = 0 < (o = d).length, u = 0 < i.length, l = function(e, t, n, r, l) {
                    var d, h, g, v = 0,
                        y = "0",
                        b = e && [],
                        x = [],
                        _ = c,
                        C = e || u && a.find.TAG("*", l),
                        j = w += null == _ ? 1 : Math.random() || .1,
                        S = C.length;
                    for (l && (c = t == f || t || l); y !== S && null != (d = C[y]); y++) {
                        if (u && d) {
                            for (h = 0, t || d.ownerDocument == f || (p(d), n = !m); g = i[h++];)
                                if (g(d, t || f, n)) {
                                    r.push(d);
                                    break
                                } l && (w = j)
                        }
                        s && ((d = !g && d) && v--, e && b.push(d))
                    }
                    if (v += y, s && y !== v) {
                        for (h = 0; g = o[h++];) g(b, x, t, n);
                        if (e) {
                            if (0 < v)
                                for (; y--;) b[y] || x[y] || (x[y] = D.call(r));
                            x = we(x)
                        }
                        P.apply(r, x), l && !e && 0 < x.length && 1 < v + o.length && se.uniqueSort(r)
                    }
                    return l && (w = j, c = _), b
                }, s ? ce(l) : l))).selector = e
            }
            return g
        }, u = se.select = function(e, t, n, i) {
            var o, u, c, l, d, p = "function" == typeof e && e,
                f = !i && r(e = p.selector || e);
            if (n = n || [], 1 === f.length) {
                if (2 < (u = f[0] = f[0].slice(0)).length && "ID" === (c = u[0]).type && 9 === t.nodeType && m && a.relative[u[1].type]) {
                    if (!(t = (a.find.ID(c.matches[0].replace(te, ne), t) || [])[0])) return n;
                    p && (t = t.parentNode), e = e.slice(u.shift().value.length)
                }
                for (o = J.needsContext.test(e) ? 0 : u.length; o-- && (c = u[o], !a.relative[l = c.type]);)
                    if ((d = a.find[l]) && (i = d(c.matches[0].replace(te, ne), ee.test(u[0].type) && ve(t.parentNode) || t))) {
                        if (u.splice(o, 1), !(e = i.length && be(u))) return P.apply(n, i), n;
                        break
                    }
            }
            return (p || s(e, f))(i, t, !m, n, !t || ee.test(e) && ve(t.parentNode) || t), n
        }, n.sortStable = x.split("").sort($).join("") === x, n.detectDuplicates = !!d, p(), n.sortDetached = le((function(e) {
            return 1 & e.compareDocumentPosition(f.createElement("fieldset"))
        })), le((function(e) {
            return e.innerHTML = "<a href='#'></a>", "#" === e.firstChild.getAttribute("href")
        })) || de("type|href|height|width", (function(e, t, n) {
            if (!n) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2)
        })), n.attributes && le((function(e) {
            return e.innerHTML = "<input/>", e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value")
        })) || de("value", (function(e, t, n) {
            if (!n && "input" === e.nodeName.toLowerCase()) return e.defaultValue
        })), le((function(e) {
            return null == e.getAttribute("disabled")
        })) || de(q, (function(e, t, n) {
            var a;
            if (!n) return !0 === e[t] ? t.toLowerCase() : (a = e.getAttributeNode(t)) && a.specified ? a.value : null
        })), se
    }(e);
    _.find = C, _.expr = C.selectors, _.expr[":"] = _.expr.pseudos, _.uniqueSort = _.unique = C.uniqueSort, _.text = C.getText, _.isXMLDoc = C.isXML, _.contains = C.contains, _.escapeSelector = C.escape;
    var j = function(e, t, n) {
            for (var a = [], i = void 0 !== n;
                (e = e[t]) && 9 !== e.nodeType;)
                if (1 === e.nodeType) {
                    if (i && _(e).is(n)) break;
                    a.push(e)
                } return a
        },
        S = function(e, t) {
            for (var n = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && n.push(e);
            return n
        },
        T = _.expr.match.needsContext;

    function k(e, t) {
        return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase()
    }
    var $ = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;

    function E(e, t, n) {
        return h(t) ? _.grep(e, (function(e, a) {
            return !!t.call(e, a, e) !== n
        })) : t.nodeType ? _.grep(e, (function(e) {
            return e === t !== n
        })) : "string" != typeof t ? _.grep(e, (function(e) {
            return -1 < s.call(t, e) !== n
        })) : _.filter(t, e, n)
    }
    _.filter = function(e, t, n) {
        var a = t[0];
        return n && (e = ":not(" + e + ")"), 1 === t.length && 1 === a.nodeType ? _.find.matchesSelector(a, e) ? [a] : [] : _.find.matches(e, _.grep(t, (function(e) {
            return 1 === e.nodeType
        })))
    }, _.fn.extend({
        find: function(e) {
            var t, n, a = this.length,
                i = this;
            if ("string" != typeof e) return this.pushStack(_(e).filter((function() {
                for (t = 0; t < a; t++)
                    if (_.contains(i[t], this)) return !0
            })));
            for (n = this.pushStack([]), t = 0; t < a; t++) _.find(e, i[t], n);
            return 1 < a ? _.uniqueSort(n) : n
        },
        filter: function(e) {
            return this.pushStack(E(this, e || [], !1))
        },
        not: function(e) {
            return this.pushStack(E(this, e || [], !0))
        },
        is: function(e) {
            return !!E(this, "string" == typeof e && T.test(e) ? _(e) : e || [], !1).length
        }
    });
    var A, D = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
    (_.fn.init = function(e, t, n) {
        var a, i;
        if (!e) return this;
        if (n = n || A, "string" == typeof e) {
            if (!(a = "<" === e[0] && ">" === e[e.length - 1] && 3 <= e.length ? [null, e, null] : D.exec(e)) || !a[1] && t) return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);
            if (a[1]) {
                if (t = t instanceof _ ? t[0] : t, _.merge(this, _.parseHTML(a[1], t && t.nodeType ? t.ownerDocument || t : g, !0)), $.test(a[1]) && _.isPlainObject(t))
                    for (a in t) h(this[a]) ? this[a](t[a]) : this.attr(a, t[a]);
                return this
            }
            return (i = g.getElementById(a[2])) && (this[0] = i, this.length = 1), this
        }
        return e.nodeType ? (this[0] = e, this.length = 1, this) : h(e) ? void 0 !== n.ready ? n.ready(e) : e(_) : _.makeArray(e, this)
    }).prototype = _.fn, A = _(g);
    var L = /^(?:parents|prev(?:Until|All))/,
        P = {
            children: !0,
            contents: !0,
            next: !0,
            prev: !0
        };

    function N(e, t) {
        for (;
            (e = e[t]) && 1 !== e.nodeType;);
        return e
    }
    _.fn.extend({
        has: function(e) {
            var t = _(e, this),
                n = t.length;
            return this.filter((function() {
                for (var e = 0; e < n; e++)
                    if (_.contains(this, t[e])) return !0
            }))
        },
        closest: function(e, t) {
            var n, a = 0,
                i = this.length,
                o = [],
                r = "string" != typeof e && _(e);
            if (!T.test(e))
                for (; a < i; a++)
                    for (n = this[a]; n && n !== t; n = n.parentNode)
                        if (n.nodeType < 11 && (r ? -1 < r.index(n) : 1 === n.nodeType && _.find.matchesSelector(n, e))) {
                            o.push(n);
                            break
                        } return this.pushStack(1 < o.length ? _.uniqueSort(o) : o)
        },
        index: function(e) {
            return e ? "string" == typeof e ? s.call(_(e), this[0]) : s.call(this, e.jquery ? e[0] : e) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
        },
        add: function(e, t) {
            return this.pushStack(_.uniqueSort(_.merge(this.get(), _(e, t))))
        },
        addBack: function(e) {
            return this.add(null == e ? this.prevObject : this.prevObject.filter(e))
        }
    }), _.each({
        parent: function(e) {
            var t = e.parentNode;
            return t && 11 !== t.nodeType ? t : null
        },
        parents: function(e) {
            return j(e, "parentNode")
        },
        parentsUntil: function(e, t, n) {
            return j(e, "parentNode", n)
        },
        next: function(e) {
            return N(e, "nextSibling")
        },
        prev: function(e) {
            return N(e, "previousSibling")
        },
        nextAll: function(e) {
            return j(e, "nextSibling")
        },
        prevAll: function(e) {
            return j(e, "previousSibling")
        },
        nextUntil: function(e, t, n) {
            return j(e, "nextSibling", n)
        },
        prevUntil: function(e, t, n) {
            return j(e, "previousSibling", n)
        },
        siblings: function(e) {
            return S((e.parentNode || {}).firstChild, e)
        },
        children: function(e) {
            return S(e.firstChild)
        },
        contents: function(e) {
            return null != e.contentDocument && a(e.contentDocument) ? e.contentDocument : (k(e, "template") && (e = e.content || e), _.merge([], e.childNodes))
        }
    }, (function(e, t) {
        _.fn[e] = function(n, a) {
            var i = _.map(this, t, n);
            return "Until" !== e.slice(-5) && (a = n), a && "string" == typeof a && (i = _.filter(a, i)), 1 < this.length && (P[e] || _.uniqueSort(i), L.test(e) && i.reverse()), this.pushStack(i)
        }
    }));
    var O = /[^\x20\t\r\n\f]+/g;

    function q(e) {
        return e
    }

    function I(e) {
        throw e
    }

    function H(e, t, n, a) {
        var i;
        try {
            e && h(i = e.promise) ? i.call(e).done(t).fail(n) : e && h(i = e.then) ? i.call(e, t, n) : t.apply(void 0, [e].slice(a))
        } catch (e) {
            n.apply(void 0, [e])
        }
    }
    _.Callbacks = function(e) {
        var t, n;
        e = "string" == typeof e ? (t = e, n = {}, _.each(t.match(O) || [], (function(e, t) {
            n[t] = !0
        })), n) : _.extend({}, e);
        var a, i, o, r, s = [],
            u = [],
            c = -1,
            l = function() {
                for (r = r || e.once, o = a = !0; u.length; c = -1)
                    for (i = u.shift(); ++c < s.length;) !1 === s[c].apply(i[0], i[1]) && e.stopOnFalse && (c = s.length, i = !1);
                e.memory || (i = !1), a = !1, r && (s = i ? [] : "")
            },
            d = {
                add: function() {
                    return s && (i && !a && (c = s.length - 1, u.push(i)), function t(n) {
                        _.each(n, (function(n, a) {
                            h(a) ? e.unique && d.has(a) || s.push(a) : a && a.length && "string" !== b(a) && t(a)
                        }))
                    }(arguments), i && !a && l()), this
                },
                remove: function() {
                    return _.each(arguments, (function(e, t) {
                        for (var n; - 1 < (n = _.inArray(t, s, n));) s.splice(n, 1), n <= c && c--
                    })), this
                },
                has: function(e) {
                    return e ? -1 < _.inArray(e, s) : 0 < s.length
                },
                empty: function() {
                    return s && (s = []), this
                },
                disable: function() {
                    return r = u = [], s = i = "", this
                },
                disabled: function() {
                    return !s
                },
                lock: function() {
                    return r = u = [], i || a || (s = i = ""), this
                },
                locked: function() {
                    return !!r
                },
                fireWith: function(e, t) {
                    return r || (t = [e, (t = t || []).slice ? t.slice() : t], u.push(t), a || l()), this
                },
                fire: function() {
                    return d.fireWith(this, arguments), this
                },
                fired: function() {
                    return !!o
                }
            };
        return d
    }, _.extend({
        Deferred: function(t) {
            var n = [
                    ["notify", "progress", _.Callbacks("memory"), _.Callbacks("memory"), 2],
                    ["resolve", "done", _.Callbacks("once memory"), _.Callbacks("once memory"), 0, "resolved"],
                    ["reject", "fail", _.Callbacks("once memory"), _.Callbacks("once memory"), 1, "rejected"]
                ],
                a = "pending",
                i = {
                    state: function() {
                        return a
                    },
                    always: function() {
                        return o.done(arguments).fail(arguments), this
                    },
                    catch: function(e) {
                        return i.then(null, e)
                    },
                    pipe: function() {
                        var e = arguments;
                        return _.Deferred((function(t) {
                            _.each(n, (function(n, a) {
                                var i = h(e[a[4]]) && e[a[4]];
                                o[a[1]]((function() {
                                    var e = i && i.apply(this, arguments);
                                    e && h(e.promise) ? e.promise().progress(t.notify).done(t.resolve).fail(t.reject) : t[a[0] + "With"](this, i ? [e] : arguments)
                                }))
                            })), e = null
                        })).promise()
                    },
                    then: function(t, a, i) {
                        var o = 0;

                        function r(t, n, a, i) {
                            return function() {
                                var s = this,
                                    u = arguments,
                                    c = function() {
                                        var e, c;
                                        if (!(t < o)) {
                                            if ((e = a.apply(s, u)) === n.promise()) throw new TypeError("Thenable self-resolution");
                                            c = e && ("object" == typeof e || "function" == typeof e) && e.then, h(c) ? i ? c.call(e, r(o, n, q, i), r(o, n, I, i)) : (o++, c.call(e, r(o, n, q, i), r(o, n, I, i), r(o, n, q, n.notifyWith))) : (a !== q && (s = void 0, u = [e]), (i || n.resolveWith)(s, u))
                                        }
                                    },
                                    l = i ? c : function() {
                                        try {
                                            c()
                                        } catch (e) {
                                            _.Deferred.exceptionHook && _.Deferred.exceptionHook(e, l.stackTrace), o <= t + 1 && (a !== I && (s = void 0, u = [e]), n.rejectWith(s, u))
                                        }
                                    };
                                t ? l() : (_.Deferred.getStackHook && (l.stackTrace = _.Deferred.getStackHook()), e.setTimeout(l))
                            }
                        }
                        return _.Deferred((function(e) {
                            n[0][3].add(r(0, e, h(i) ? i : q, e.notifyWith)), n[1][3].add(r(0, e, h(t) ? t : q)), n[2][3].add(r(0, e, h(a) ? a : I))
                        })).promise()
                    },
                    promise: function(e) {
                        return null != e ? _.extend(e, i) : i
                    }
                },
                o = {};
            return _.each(n, (function(e, t) {
                var r = t[2],
                    s = t[5];
                i[t[1]] = r.add, s && r.add((function() {
                    a = s
                }), n[3 - e][2].disable, n[3 - e][3].disable, n[0][2].lock, n[0][3].lock), r.add(t[3].fire), o[t[0]] = function() {
                    return o[t[0] + "With"](this === o ? void 0 : this, arguments), this
                }, o[t[0] + "With"] = r.fireWith
            })), i.promise(o), t && t.call(o, o), o
        },
        when: function(e) {
            var t = arguments.length,
                n = t,
                a = Array(n),
                o = i.call(arguments),
                r = _.Deferred(),
                s = function(e) {
                    return function(n) {
                        a[e] = this, o[e] = 1 < arguments.length ? i.call(arguments) : n, --t || r.resolveWith(a, o)
                    }
                };
            if (t <= 1 && (H(e, r.done(s(n)).resolve, r.reject, !t), "pending" === r.state() || h(o[n] && o[n].then))) return r.then();
            for (; n--;) H(o[n], s(n), r.reject);
            return r.promise()
        }
    });
    var M = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    _.Deferred.exceptionHook = function(t, n) {
        e.console && e.console.warn && t && M.test(t.name) && e.console.warn("jQuery.Deferred exception: " + t.message, t.stack, n)
    }, _.readyException = function(t) {
        e.setTimeout((function() {
            throw t
        }))
    };
    var B = _.Deferred();

    function R() {
        g.removeEventListener("DOMContentLoaded", R), e.removeEventListener("load", R), _.ready()
    }
    _.fn.ready = function(e) {
        return B.then(e).catch((function(e) {
            _.readyException(e)
        })), this
    }, _.extend({
        isReady: !1,
        readyWait: 1,
        ready: function(e) {
            (!0 === e ? --_.readyWait : _.isReady) || (_.isReady = !0) !== e && 0 < --_.readyWait || B.resolveWith(g, [_])
        }
    }), _.ready.then = B.then, "complete" === g.readyState || "loading" !== g.readyState && !g.documentElement.doScroll ? e.setTimeout(_.ready) : (g.addEventListener("DOMContentLoaded", R), e.addEventListener("load", R));
    var z = function(e, t, n, a, i, o, r) {
            var s = 0,
                u = e.length,
                c = null == n;
            if ("object" === b(n))
                for (s in i = !0, n) z(e, t, s, n[s], !0, o, r);
            else if (void 0 !== a && (i = !0, h(a) || (r = !0), c && (r ? (t.call(e, a), t = null) : (c = t, t = function(e, t, n) {
                    return c.call(_(e), n)
                })), t))
                for (; s < u; s++) t(e[s], n, r ? a : a.call(e[s], s, t(e[s], n)));
            return i ? e : c ? t.call(e) : u ? t(e[0], n) : o
        },
        F = /^-ms-/,
        W = /-([a-z])/g;

    function U(e, t) {
        return t.toUpperCase()
    }

    function Q(e) {
        return e.replace(F, "ms-").replace(W, U)
    }
    var V = function(e) {
        return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType
    };

    function J() {
        this.expando = _.expando + J.uid++
    }
    J.uid = 1, J.prototype = {
        cache: function(e) {
            var t = e[this.expando];
            return t || (t = {}, V(e) && (e.nodeType ? e[this.expando] = t : Object.defineProperty(e, this.expando, {
                value: t,
                configurable: !0
            }))), t
        },
        set: function(e, t, n) {
            var a, i = this.cache(e);
            if ("string" == typeof t) i[Q(t)] = n;
            else
                for (a in t) i[Q(a)] = t[a];
            return i
        },
        get: function(e, t) {
            return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][Q(t)]
        },
        access: function(e, t, n) {
            return void 0 === t || t && "string" == typeof t && void 0 === n ? this.get(e, t) : (this.set(e, t, n), void 0 !== n ? n : t)
        },
        remove: function(e, t) {
            var n, a = e[this.expando];
            if (void 0 !== a) {
                if (void 0 !== t) {
                    n = (t = Array.isArray(t) ? t.map(Q) : (t = Q(t)) in a ? [t] : t.match(O) || []).length;
                    for (; n--;) delete a[t[n]]
                }(void 0 === t || _.isEmptyObject(a)) && (e.nodeType ? e[this.expando] = void 0 : delete e[this.expando])
            }
        },
        hasData: function(e) {
            var t = e[this.expando];
            return void 0 !== t && !_.isEmptyObject(t)
        }
    };
    var G = new J,
        X = new J,
        Y = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
        K = /[A-Z]/g;

    function Z(e, t, n) {
        var a, i;
        if (void 0 === n && 1 === e.nodeType)
            if (a = "data-" + t.replace(K, "-$&").toLowerCase(), "string" == typeof(n = e.getAttribute(a))) {
                try {
                    n = "true" === (i = n) || "false" !== i && ("null" === i ? null : i === +i + "" ? +i : Y.test(i) ? JSON.parse(i) : i)
                } catch (e) {}
                X.set(e, t, n)
            } else n = void 0;
        return n
    }
    _.extend({
        hasData: function(e) {
            return X.hasData(e) || G.hasData(e)
        },
        data: function(e, t, n) {
            return X.access(e, t, n)
        },
        removeData: function(e, t) {
            X.remove(e, t)
        },
        _data: function(e, t, n) {
            return G.access(e, t, n)
        },
        _removeData: function(e, t) {
            G.remove(e, t)
        }
    }), _.fn.extend({
        data: function(e, t) {
            var n, a, i, o = this[0],
                r = o && o.attributes;
            if (void 0 === e) {
                if (this.length && (i = X.get(o), 1 === o.nodeType && !G.get(o, "hasDataAttrs"))) {
                    for (n = r.length; n--;) r[n] && 0 === (a = r[n].name).indexOf("data-") && (a = Q(a.slice(5)), Z(o, a, i[a]));
                    G.set(o, "hasDataAttrs", !0)
                }
                return i
            }
            return "object" == typeof e ? this.each((function() {
                X.set(this, e)
            })) : z(this, (function(t) {
                var n;
                if (o && void 0 === t) return void 0 !== (n = X.get(o, e)) || void 0 !== (n = Z(o, e)) ? n : void 0;
                this.each((function() {
                    X.set(this, e, t)
                }))
            }), null, t, 1 < arguments.length, null, !0)
        },
        removeData: function(e) {
            return this.each((function() {
                X.remove(this, e)
            }))
        }
    }), _.extend({
        queue: function(e, t, n) {
            var a;
            if (e) return t = (t || "fx") + "queue", a = G.get(e, t), n && (!a || Array.isArray(n) ? a = G.access(e, t, _.makeArray(n)) : a.push(n)), a || []
        },
        dequeue: function(e, t) {
            t = t || "fx";
            var n = _.queue(e, t),
                a = n.length,
                i = n.shift(),
                o = _._queueHooks(e, t);
            "inprogress" === i && (i = n.shift(), a--), i && ("fx" === t && n.unshift("inprogress"), delete o.stop, i.call(e, (function() {
                _.dequeue(e, t)
            }), o)), !a && o && o.empty.fire()
        },
        _queueHooks: function(e, t) {
            var n = t + "queueHooks";
            return G.get(e, n) || G.access(e, n, {
                empty: _.Callbacks("once memory").add((function() {
                    G.remove(e, [t + "queue", n])
                }))
            })
        }
    }), _.fn.extend({
        queue: function(e, t) {
            var n = 2;
            return "string" != typeof e && (t = e, e = "fx", n--), arguments.length < n ? _.queue(this[0], e) : void 0 === t ? this : this.each((function() {
                var n = _.queue(this, e, t);
                _._queueHooks(this, e), "fx" === e && "inprogress" !== n[0] && _.dequeue(this, e)
            }))
        },
        dequeue: function(e) {
            return this.each((function() {
                _.dequeue(this, e)
            }))
        },
        clearQueue: function(e) {
            return this.queue(e || "fx", [])
        },
        promise: function(e, t) {
            var n, a = 1,
                i = _.Deferred(),
                o = this,
                r = this.length,
                s = function() {
                    --a || i.resolveWith(o, [o])
                };
            for ("string" != typeof e && (t = e, e = void 0), e = e || "fx"; r--;)(n = G.get(o[r], e + "queueHooks")) && n.empty && (a++, n.empty.add(s));
            return s(), i.promise(t)
        }
    });
    var ee = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
        te = new RegExp("^(?:([+-])=|)(" + ee + ")([a-z%]*)$", "i"),
        ne = ["Top", "Right", "Bottom", "Left"],
        ae = g.documentElement,
        ie = function(e) {
            return _.contains(e.ownerDocument, e)
        },
        oe = {
            composed: !0
        };
    ae.getRootNode && (ie = function(e) {
        return _.contains(e.ownerDocument, e) || e.getRootNode(oe) === e.ownerDocument
    });
    var re = function(e, t) {
        return "none" === (e = t || e).style.display || "" === e.style.display && ie(e) && "none" === _.css(e, "display")
    };

    function se(e, t, n, a) {
        var i, o, r = 20,
            s = a ? function() {
                return a.cur()
            } : function() {
                return _.css(e, t, "")
            },
            u = s(),
            c = n && n[3] || (_.cssNumber[t] ? "" : "px"),
            l = e.nodeType && (_.cssNumber[t] || "px" !== c && +u) && te.exec(_.css(e, t));
        if (l && l[3] !== c) {
            for (u /= 2, c = c || l[3], l = +u || 1; r--;) _.style(e, t, l + c), (1 - o) * (1 - (o = s() / u || .5)) <= 0 && (r = 0), l /= o;
            l *= 2, _.style(e, t, l + c), n = n || []
        }
        return n && (l = +l || +u || 0, i = n[1] ? l + (n[1] + 1) * n[2] : +n[2], a && (a.unit = c, a.start = l, a.end = i)), i
    }
    var ue = {};

    function ce(e, t) {
        for (var n, a, i, o, r, s, u, c = [], l = 0, d = e.length; l < d; l++)(a = e[l]).style && (n = a.style.display, t ? ("none" === n && (c[l] = G.get(a, "display") || null, c[l] || (a.style.display = "")), "" === a.style.display && re(a) && (c[l] = (u = r = o = void 0, r = (i = a).ownerDocument, s = i.nodeName, (u = ue[s]) || (o = r.body.appendChild(r.createElement(s)), u = _.css(o, "display"), o.parentNode.removeChild(o), "none" === u && (u = "block"), ue[s] = u)))) : "none" !== n && (c[l] = "none", G.set(a, "display", n)));
        for (l = 0; l < d; l++) null != c[l] && (e[l].style.display = c[l]);
        return e
    }
    _.fn.extend({
        show: function() {
            return ce(this, !0)
        },
        hide: function() {
            return ce(this)
        },
        toggle: function(e) {
            return "boolean" == typeof e ? e ? this.show() : this.hide() : this.each((function() {
                re(this) ? _(this).show() : _(this).hide()
            }))
        }
    });
    var le, de, pe = /^(?:checkbox|radio)$/i,
        fe = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
        he = /^$|^module$|\/(?:java|ecma)script/i;
    le = g.createDocumentFragment().appendChild(g.createElement("div")), (de = g.createElement("input")).setAttribute("type", "radio"), de.setAttribute("checked", "checked"), de.setAttribute("name", "t"), le.appendChild(de), f.checkClone = le.cloneNode(!0).cloneNode(!0).lastChild.checked, le.innerHTML = "<textarea>x</textarea>", f.noCloneChecked = !!le.cloneNode(!0).lastChild.defaultValue, le.innerHTML = "<option></option>", f.option = !!le.lastChild;
    var me = {
        thead: [1, "<table>", "</table>"],
        col: [2, "<table><colgroup>", "</colgroup></table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        _default: [0, "", ""]
    };

    function ge(e, t) {
        var n;
        return n = void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t || "*") : void 0 !== e.querySelectorAll ? e.querySelectorAll(t || "*") : [], void 0 === t || t && k(e, t) ? _.merge([e], n) : n
    }

    function ve(e, t) {
        for (var n = 0, a = e.length; n < a; n++) G.set(e[n], "globalEval", !t || G.get(t[n], "globalEval"))
    }
    me.tbody = me.tfoot = me.colgroup = me.caption = me.thead, me.th = me.td, f.option || (me.optgroup = me.option = [1, "<select multiple='multiple'>", "</select>"]);
    var ye = /<|&#?\w+;/;

    function be(e, t, n, a, i) {
        for (var o, r, s, u, c, l, d = t.createDocumentFragment(), p = [], f = 0, h = e.length; f < h; f++)
            if ((o = e[f]) || 0 === o)
                if ("object" === b(o)) _.merge(p, o.nodeType ? [o] : o);
                else if (ye.test(o)) {
            for (r = r || d.appendChild(t.createElement("div")), s = (fe.exec(o) || ["", ""])[1].toLowerCase(), u = me[s] || me._default, r.innerHTML = u[1] + _.htmlPrefilter(o) + u[2], l = u[0]; l--;) r = r.lastChild;
            _.merge(p, r.childNodes), (r = d.firstChild).textContent = ""
        } else p.push(t.createTextNode(o));
        for (d.textContent = "", f = 0; o = p[f++];)
            if (a && -1 < _.inArray(o, a)) i && i.push(o);
            else if (c = ie(o), r = ge(d.appendChild(o), "script"), c && ve(r), n)
            for (l = 0; o = r[l++];) he.test(o.type || "") && n.push(o);
        return d
    }
    var xe = /^key/,
        _e = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
        we = /^([^.]*)(?:\.(.+)|)/;

    function Ce() {
        return !0
    }

    function je() {
        return !1
    }

    function Se(e, t) {
        return e === function() {
            try {
                return g.activeElement
            } catch (e) {}
        }() == ("focus" === t)
    }

    function Te(e, t, n, a, i, o) {
        var r, s;
        if ("object" == typeof t) {
            for (s in "string" != typeof n && (a = a || n, n = void 0), t) Te(e, s, n, a, t[s], o);
            return e
        }
        if (null == a && null == i ? (i = n, a = n = void 0) : null == i && ("string" == typeof n ? (i = a, a = void 0) : (i = a, a = n, n = void 0)), !1 === i) i = je;
        else if (!i) return e;
        return 1 === o && (r = i, (i = function(e) {
            return _().off(e), r.apply(this, arguments)
        }).guid = r.guid || (r.guid = _.guid++)), e.each((function() {
            _.event.add(this, t, i, a, n)
        }))
    }

    function ke(e, t, n) {
        n ? (G.set(e, t, !1), _.event.add(e, t, {
            namespace: !1,
            handler: function(e) {
                var a, o, r = G.get(this, t);
                if (1 & e.isTrigger && this[t]) {
                    if (r.length)(_.event.special[t] || {}).delegateType && e.stopPropagation();
                    else if (r = i.call(arguments), G.set(this, t, r), a = n(this, t), this[t](), r !== (o = G.get(this, t)) || a ? G.set(this, t, !1) : o = {}, r !== o) return e.stopImmediatePropagation(), e.preventDefault(), o.value
                } else r.length && (G.set(this, t, {
                    value: _.event.trigger(_.extend(r[0], _.Event.prototype), r.slice(1), this)
                }), e.stopImmediatePropagation())
            }
        })) : void 0 === G.get(e, t) && _.event.add(e, t, Ce)
    }
    _.event = {
        global: {},
        add: function(e, t, n, a, i) {
            var o, r, s, u, c, l, d, p, f, h, m, g = G.get(e);
            if (V(e))
                for (n.handler && (n = (o = n).handler, i = o.selector), i && _.find.matchesSelector(ae, i), n.guid || (n.guid = _.guid++), (u = g.events) || (u = g.events = Object.create(null)), (r = g.handle) || (r = g.handle = function(t) {
                        return void 0 !== _ && _.event.triggered !== t.type ? _.event.dispatch.apply(e, arguments) : void 0
                    }), c = (t = (t || "").match(O) || [""]).length; c--;) f = m = (s = we.exec(t[c]) || [])[1], h = (s[2] || "").split(".").sort(), f && (d = _.event.special[f] || {}, f = (i ? d.delegateType : d.bindType) || f, d = _.event.special[f] || {}, l = _.extend({
                    type: f,
                    origType: m,
                    data: a,
                    handler: n,
                    guid: n.guid,
                    selector: i,
                    needsContext: i && _.expr.match.needsContext.test(i),
                    namespace: h.join(".")
                }, o), (p = u[f]) || ((p = u[f] = []).delegateCount = 0, d.setup && !1 !== d.setup.call(e, a, h, r) || e.addEventListener && e.addEventListener(f, r)), d.add && (d.add.call(e, l), l.handler.guid || (l.handler.guid = n.guid)), i ? p.splice(p.delegateCount++, 0, l) : p.push(l), _.event.global[f] = !0)
        },
        remove: function(e, t, n, a, i) {
            var o, r, s, u, c, l, d, p, f, h, m, g = G.hasData(e) && G.get(e);
            if (g && (u = g.events)) {
                for (c = (t = (t || "").match(O) || [""]).length; c--;)
                    if (f = m = (s = we.exec(t[c]) || [])[1], h = (s[2] || "").split(".").sort(), f) {
                        for (d = _.event.special[f] || {}, p = u[f = (a ? d.delegateType : d.bindType) || f] || [], s = s[2] && new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"), r = o = p.length; o--;) l = p[o], !i && m !== l.origType || n && n.guid !== l.guid || s && !s.test(l.namespace) || a && a !== l.selector && ("**" !== a || !l.selector) || (p.splice(o, 1), l.selector && p.delegateCount--, d.remove && d.remove.call(e, l));
                        r && !p.length && (d.teardown && !1 !== d.teardown.call(e, h, g.handle) || _.removeEvent(e, f, g.handle), delete u[f])
                    } else
                        for (f in u) _.event.remove(e, f + t[c], n, a, !0);
                _.isEmptyObject(u) && G.remove(e, "handle events")
            }
        },
        dispatch: function(e) {
            var t, n, a, i, o, r, s = new Array(arguments.length),
                u = _.event.fix(e),
                c = (G.get(this, "events") || Object.create(null))[u.type] || [],
                l = _.event.special[u.type] || {};
            for (s[0] = u, t = 1; t < arguments.length; t++) s[t] = arguments[t];
            if (u.delegateTarget = this, !l.preDispatch || !1 !== l.preDispatch.call(this, u)) {
                for (r = _.event.handlers.call(this, u, c), t = 0;
                    (i = r[t++]) && !u.isPropagationStopped();)
                    for (u.currentTarget = i.elem, n = 0;
                        (o = i.handlers[n++]) && !u.isImmediatePropagationStopped();) u.rnamespace && !1 !== o.namespace && !u.rnamespace.test(o.namespace) || (u.handleObj = o, u.data = o.data, void 0 !== (a = ((_.event.special[o.origType] || {}).handle || o.handler).apply(i.elem, s)) && !1 === (u.result = a) && (u.preventDefault(), u.stopPropagation()));
                return l.postDispatch && l.postDispatch.call(this, u), u.result
            }
        },
        handlers: function(e, t) {
            var n, a, i, o, r, s = [],
                u = t.delegateCount,
                c = e.target;
            if (u && c.nodeType && !("click" === e.type && 1 <= e.button))
                for (; c !== this; c = c.parentNode || this)
                    if (1 === c.nodeType && ("click" !== e.type || !0 !== c.disabled)) {
                        for (o = [], r = {}, n = 0; n < u; n++) void 0 === r[i = (a = t[n]).selector + " "] && (r[i] = a.needsContext ? -1 < _(i, this).index(c) : _.find(i, this, null, [c]).length), r[i] && o.push(a);
                        o.length && s.push({
                            elem: c,
                            handlers: o
                        })
                    } return c = this, u < t.length && s.push({
                elem: c,
                handlers: t.slice(u)
            }), s
        },
        addProp: function(e, t) {
            Object.defineProperty(_.Event.prototype, e, {
                enumerable: !0,
                configurable: !0,
                get: h(t) ? function() {
                    if (this.originalEvent) return t(this.originalEvent)
                } : function() {
                    if (this.originalEvent) return this.originalEvent[e]
                },
                set: function(t) {
                    Object.defineProperty(this, e, {
                        enumerable: !0,
                        configurable: !0,
                        writable: !0,
                        value: t
                    })
                }
            })
        },
        fix: function(e) {
            return e[_.expando] ? e : new _.Event(e)
        },
        special: {
            load: {
                noBubble: !0
            },
            click: {
                setup: function(e) {
                    var t = this || e;
                    return pe.test(t.type) && t.click && k(t, "input") && ke(t, "click", Ce), !1
                },
                trigger: function(e) {
                    var t = this || e;
                    return pe.test(t.type) && t.click && k(t, "input") && ke(t, "click"), !0
                },
                _default: function(e) {
                    var t = e.target;
                    return pe.test(t.type) && t.click && k(t, "input") && G.get(t, "click") || k(t, "a")
                }
            },
            beforeunload: {
                postDispatch: function(e) {
                    void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result)
                }
            }
        }
    }, _.removeEvent = function(e, t, n) {
        e.removeEventListener && e.removeEventListener(t, n)
    }, _.Event = function(e, t) {
        if (!(this instanceof _.Event)) return new _.Event(e, t);
        e && e.type ? (this.originalEvent = e, this.type = e.type, this.isDefaultPrevented = e.defaultPrevented || void 0 === e.defaultPrevented && !1 === e.returnValue ? Ce : je, this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target, this.currentTarget = e.currentTarget, this.relatedTarget = e.relatedTarget) : this.type = e, t && _.extend(this, t), this.timeStamp = e && e.timeStamp || Date.now(), this[_.expando] = !0
    }, _.Event.prototype = {
        constructor: _.Event,
        isDefaultPrevented: je,
        isPropagationStopped: je,
        isImmediatePropagationStopped: je,
        isSimulated: !1,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = Ce, e && !this.isSimulated && e.preventDefault()
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = Ce, e && !this.isSimulated && e.stopPropagation()
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = Ce, e && !this.isSimulated && e.stopImmediatePropagation(), this.stopPropagation()
        }
    }, _.each({
        altKey: !0,
        bubbles: !0,
        cancelable: !0,
        changedTouches: !0,
        ctrlKey: !0,
        detail: !0,
        eventPhase: !0,
        metaKey: !0,
        pageX: !0,
        pageY: !0,
        shiftKey: !0,
        view: !0,
        char: !0,
        code: !0,
        charCode: !0,
        key: !0,
        keyCode: !0,
        button: !0,
        buttons: !0,
        clientX: !0,
        clientY: !0,
        offsetX: !0,
        offsetY: !0,
        pointerId: !0,
        pointerType: !0,
        screenX: !0,
        screenY: !0,
        targetTouches: !0,
        toElement: !0,
        touches: !0,
        which: function(e) {
            var t = e.button;
            return null == e.which && xe.test(e.type) ? null != e.charCode ? e.charCode : e.keyCode : !e.which && void 0 !== t && _e.test(e.type) ? 1 & t ? 1 : 2 & t ? 3 : 4 & t ? 2 : 0 : e.which
        }
    }, _.event.addProp), _.each({
        focus: "focusin",
        blur: "focusout"
    }, (function(e, t) {
        _.event.special[e] = {
            setup: function() {
                return ke(this, e, Se), !1
            },
            trigger: function() {
                return ke(this, e), !0
            },
            delegateType: t
        }
    })), _.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, (function(e, t) {
        _.event.special[e] = {
            delegateType: t,
            bindType: t,
            handle: function(e) {
                var n, a = e.relatedTarget,
                    i = e.handleObj;
                return a && (a === this || _.contains(this, a)) || (e.type = i.origType, n = i.handler.apply(this, arguments), e.type = t), n
            }
        }
    })), _.fn.extend({
        on: function(e, t, n, a) {
            return Te(this, e, t, n, a)
        },
        one: function(e, t, n, a) {
            return Te(this, e, t, n, a, 1)
        },
        off: function(e, t, n) {
            var a, i;
            if (e && e.preventDefault && e.handleObj) return a = e.handleObj, _(e.delegateTarget).off(a.namespace ? a.origType + "." + a.namespace : a.origType, a.selector, a.handler), this;
            if ("object" == typeof e) {
                for (i in e) this.off(i, t, e[i]);
                return this
            }
            return !1 !== t && "function" != typeof t || (n = t, t = void 0), !1 === n && (n = je), this.each((function() {
                _.event.remove(this, e, n, t)
            }))
        }
    });
    var $e = /<script|<style|<link/i,
        Ee = /checked\s*(?:[^=]|=\s*.checked.)/i,
        Ae = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

    function De(e, t) {
        return k(e, "table") && k(11 !== t.nodeType ? t : t.firstChild, "tr") && _(e).children("tbody")[0] || e
    }

    function Le(e) {
        return e.type = (null !== e.getAttribute("type")) + "/" + e.type, e
    }

    function Pe(e) {
        return "true/" === (e.type || "").slice(0, 5) ? e.type = e.type.slice(5) : e.removeAttribute("type"), e
    }

    function Ne(e, t) {
        var n, a, i, o, r, s;
        if (1 === t.nodeType) {
            if (G.hasData(e) && (s = G.get(e).events))
                for (i in G.remove(t, "handle events"), s)
                    for (n = 0, a = s[i].length; n < a; n++) _.event.add(t, i, s[i][n]);
            X.hasData(e) && (o = X.access(e), r = _.extend({}, o), X.set(t, r))
        }
    }

    function Oe(e, t, n, a) {
        t = o(t);
        var i, r, s, u, c, l, d = 0,
            p = e.length,
            m = p - 1,
            g = t[0],
            v = h(g);
        if (v || 1 < p && "string" == typeof g && !f.checkClone && Ee.test(g)) return e.each((function(i) {
            var o = e.eq(i);
            v && (t[0] = g.call(this, i, o.html())), Oe(o, t, n, a)
        }));
        if (p && (r = (i = be(t, e[0].ownerDocument, !1, e, a)).firstChild, 1 === i.childNodes.length && (i = r), r || a)) {
            for (u = (s = _.map(ge(i, "script"), Le)).length; d < p; d++) c = i, d !== m && (c = _.clone(c, !0, !0), u && _.merge(s, ge(c, "script"))), n.call(e[d], c, d);
            if (u)
                for (l = s[s.length - 1].ownerDocument, _.map(s, Pe), d = 0; d < u; d++) c = s[d], he.test(c.type || "") && !G.access(c, "globalEval") && _.contains(l, c) && (c.src && "module" !== (c.type || "").toLowerCase() ? _._evalUrl && !c.noModule && _._evalUrl(c.src, {
                    nonce: c.nonce || c.getAttribute("nonce")
                }, l) : y(c.textContent.replace(Ae, ""), c, l))
        }
        return e
    }

    function qe(e, t, n) {
        for (var a, i = t ? _.filter(t, e) : e, o = 0; null != (a = i[o]); o++) n || 1 !== a.nodeType || _.cleanData(ge(a)), a.parentNode && (n && ie(a) && ve(ge(a, "script")), a.parentNode.removeChild(a));
        return e
    }
    _.extend({
        htmlPrefilter: function(e) {
            return e
        },
        clone: function(e, t, n) {
            var a, i, o, r, s, u, c, l = e.cloneNode(!0),
                d = ie(e);
            if (!(f.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || _.isXMLDoc(e)))
                for (r = ge(l), a = 0, i = (o = ge(e)).length; a < i; a++) s = o[a], "input" === (c = (u = r[a]).nodeName.toLowerCase()) && pe.test(s.type) ? u.checked = s.checked : "input" !== c && "textarea" !== c || (u.defaultValue = s.defaultValue);
            if (t)
                if (n)
                    for (o = o || ge(e), r = r || ge(l), a = 0, i = o.length; a < i; a++) Ne(o[a], r[a]);
                else Ne(e, l);
            return 0 < (r = ge(l, "script")).length && ve(r, !d && ge(e, "script")), l
        },
        cleanData: function(e) {
            for (var t, n, a, i = _.event.special, o = 0; void 0 !== (n = e[o]); o++)
                if (V(n)) {
                    if (t = n[G.expando]) {
                        if (t.events)
                            for (a in t.events) i[a] ? _.event.remove(n, a) : _.removeEvent(n, a, t.handle);
                        n[G.expando] = void 0
                    }
                    n[X.expando] && (n[X.expando] = void 0)
                }
        }
    }), _.fn.extend({
        detach: function(e) {
            return qe(this, e, !0)
        },
        remove: function(e) {
            return qe(this, e)
        },
        text: function(e) {
            return z(this, (function(e) {
                return void 0 === e ? _.text(this) : this.empty().each((function() {
                    1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = e)
                }))
            }), null, e, arguments.length)
        },
        append: function() {
            return Oe(this, arguments, (function(e) {
                1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || De(this, e).appendChild(e)
            }))
        },
        prepend: function() {
            return Oe(this, arguments, (function(e) {
                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                    var t = De(this, e);
                    t.insertBefore(e, t.firstChild)
                }
            }))
        },
        before: function() {
            return Oe(this, arguments, (function(e) {
                this.parentNode && this.parentNode.insertBefore(e, this)
            }))
        },
        after: function() {
            return Oe(this, arguments, (function(e) {
                this.parentNode && this.parentNode.insertBefore(e, this.nextSibling)
            }))
        },
        empty: function() {
            for (var e, t = 0; null != (e = this[t]); t++) 1 === e.nodeType && (_.cleanData(ge(e, !1)), e.textContent = "");
            return this
        },
        clone: function(e, t) {
            return e = null != e && e, t = null == t ? e : t, this.map((function() {
                return _.clone(this, e, t)
            }))
        },
        html: function(e) {
            return z(this, (function(e) {
                var t = this[0] || {},
                    n = 0,
                    a = this.length;
                if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
                if ("string" == typeof e && !$e.test(e) && !me[(fe.exec(e) || ["", ""])[1].toLowerCase()]) {
                    e = _.htmlPrefilter(e);
                    try {
                        for (; n < a; n++) 1 === (t = this[n] || {}).nodeType && (_.cleanData(ge(t, !1)), t.innerHTML = e);
                        t = 0
                    } catch (e) {}
                }
                t && this.empty().append(e)
            }), null, e, arguments.length)
        },
        replaceWith: function() {
            var e = [];
            return Oe(this, arguments, (function(t) {
                var n = this.parentNode;
                _.inArray(this, e) < 0 && (_.cleanData(ge(this)), n && n.replaceChild(t, this))
            }), e)
        }
    }), _.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, (function(e, t) {
        _.fn[e] = function(e) {
            for (var n, a = [], i = _(e), o = i.length - 1, s = 0; s <= o; s++) n = s === o ? this : this.clone(!0), _(i[s])[t](n), r.apply(a, n.get());
            return this.pushStack(a)
        }
    }));
    var Ie = new RegExp("^(" + ee + ")(?!px)[a-z%]+$", "i"),
        He = function(t) {
            var n = t.ownerDocument.defaultView;
            return n && n.opener || (n = e), n.getComputedStyle(t)
        },
        Me = function(e, t, n) {
            var a, i, o = {};
            for (i in t) o[i] = e.style[i], e.style[i] = t[i];
            for (i in a = n.call(e), t) e.style[i] = o[i];
            return a
        },
        Be = new RegExp(ne.join("|"), "i");

    function Re(e, t, n) {
        var a, i, o, r, s = e.style;
        return (n = n || He(e)) && ("" !== (r = n.getPropertyValue(t) || n[t]) || ie(e) || (r = _.style(e, t)), !f.pixelBoxStyles() && Ie.test(r) && Be.test(t) && (a = s.width, i = s.minWidth, o = s.maxWidth, s.minWidth = s.maxWidth = s.width = r, r = n.width, s.width = a, s.minWidth = i, s.maxWidth = o)), void 0 !== r ? r + "" : r
    }

    function ze(e, t) {
        return {
            get: function() {
                if (!e()) return (this.get = t).apply(this, arguments);
                delete this.get
            }
        }
    }! function() {
        function t() {
            if (l) {
                c.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0", l.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%", ae.appendChild(c).appendChild(l);
                var t = e.getComputedStyle(l);
                a = "1%" !== t.top, u = 12 === n(t.marginLeft), l.style.right = "60%", r = 36 === n(t.right), i = 36 === n(t.width), l.style.position = "absolute", o = 12 === n(l.offsetWidth / 3), ae.removeChild(c), l = null
            }
        }

        function n(e) {
            return Math.round(parseFloat(e))
        }
        var a, i, o, r, s, u, c = g.createElement("div"),
            l = g.createElement("div");
        l.style && (l.style.backgroundClip = "content-box", l.cloneNode(!0).style.backgroundClip = "", f.clearCloneStyle = "content-box" === l.style.backgroundClip, _.extend(f, {
            boxSizingReliable: function() {
                return t(), i
            },
            pixelBoxStyles: function() {
                return t(), r
            },
            pixelPosition: function() {
                return t(), a
            },
            reliableMarginLeft: function() {
                return t(), u
            },
            scrollboxSize: function() {
                return t(), o
            },
            reliableTrDimensions: function() {
                var t, n, a, i;
                return null == s && (t = g.createElement("table"), n = g.createElement("tr"), a = g.createElement("div"), t.style.cssText = "position:absolute;left:-11111px", n.style.height = "1px", a.style.height = "9px", ae.appendChild(t).appendChild(n).appendChild(a), i = e.getComputedStyle(n), s = 3 < parseInt(i.height), ae.removeChild(t)), s
            }
        }))
    }();
    var Fe = ["Webkit", "Moz", "ms"],
        We = g.createElement("div").style,
        Ue = {};

    function Qe(e) {
        return _.cssProps[e] || Ue[e] || (e in We ? e : Ue[e] = function(e) {
            for (var t = e[0].toUpperCase() + e.slice(1), n = Fe.length; n--;)
                if ((e = Fe[n] + t) in We) return e
        }(e) || e)
    }
    var Ve = /^(none|table(?!-c[ea]).+)/,
        Je = /^--/,
        Ge = {
            position: "absolute",
            visibility: "hidden",
            display: "block"
        },
        Xe = {
            letterSpacing: "0",
            fontWeight: "400"
        };

    function Ye(e, t, n) {
        var a = te.exec(t);
        return a ? Math.max(0, a[2] - (n || 0)) + (a[3] || "px") : t
    }

    function Ke(e, t, n, a, i, o) {
        var r = "width" === t ? 1 : 0,
            s = 0,
            u = 0;
        if (n === (a ? "border" : "content")) return 0;
        for (; r < 4; r += 2) "margin" === n && (u += _.css(e, n + ne[r], !0, i)), a ? ("content" === n && (u -= _.css(e, "padding" + ne[r], !0, i)), "margin" !== n && (u -= _.css(e, "border" + ne[r] + "Width", !0, i))) : (u += _.css(e, "padding" + ne[r], !0, i), "padding" !== n ? u += _.css(e, "border" + ne[r] + "Width", !0, i) : s += _.css(e, "border" + ne[r] + "Width", !0, i));
        return !a && 0 <= o && (u += Math.max(0, Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - o - u - s - .5)) || 0), u
    }

    function Ze(e, t, n) {
        var a = He(e),
            i = (!f.boxSizingReliable() || n) && "border-box" === _.css(e, "boxSizing", !1, a),
            o = i,
            r = Re(e, t, a),
            s = "offset" + t[0].toUpperCase() + t.slice(1);
        if (Ie.test(r)) {
            if (!n) return r;
            r = "auto"
        }
        return (!f.boxSizingReliable() && i || !f.reliableTrDimensions() && k(e, "tr") || "auto" === r || !parseFloat(r) && "inline" === _.css(e, "display", !1, a)) && e.getClientRects().length && (i = "border-box" === _.css(e, "boxSizing", !1, a), (o = s in e) && (r = e[s])), (r = parseFloat(r) || 0) + Ke(e, t, n || (i ? "border" : "content"), o, a, r) + "px"
    }

    function et(e, t, n, a, i) {
        return new et.prototype.init(e, t, n, a, i)
    }
    _.extend({
        cssHooks: {
            opacity: {
                get: function(e, t) {
                    if (t) {
                        var n = Re(e, "opacity");
                        return "" === n ? "1" : n
                    }
                }
            }
        },
        cssNumber: {
            animationIterationCount: !0,
            columnCount: !0,
            fillOpacity: !0,
            flexGrow: !0,
            flexShrink: !0,
            fontWeight: !0,
            gridArea: !0,
            gridColumn: !0,
            gridColumnEnd: !0,
            gridColumnStart: !0,
            gridRow: !0,
            gridRowEnd: !0,
            gridRowStart: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0
        },
        cssProps: {},
        style: function(e, t, n, a) {
            if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                var i, o, r, s = Q(t),
                    u = Je.test(t),
                    c = e.style;
                if (u || (t = Qe(s)), r = _.cssHooks[t] || _.cssHooks[s], void 0 === n) return r && "get" in r && void 0 !== (i = r.get(e, !1, a)) ? i : c[t];
                "string" == (o = typeof n) && (i = te.exec(n)) && i[1] && (n = se(e, t, i), o = "number"), null != n && n == n && ("number" !== o || u || (n += i && i[3] || (_.cssNumber[s] ? "" : "px")), f.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (c[t] = "inherit"), r && "set" in r && void 0 === (n = r.set(e, n, a)) || (u ? c.setProperty(t, n) : c[t] = n))
            }
        },
        css: function(e, t, n, a) {
            var i, o, r, s = Q(t);
            return Je.test(t) || (t = Qe(s)), (r = _.cssHooks[t] || _.cssHooks[s]) && "get" in r && (i = r.get(e, !0, n)), void 0 === i && (i = Re(e, t, a)), "normal" === i && t in Xe && (i = Xe[t]), "" === n || n ? (o = parseFloat(i), !0 === n || isFinite(o) ? o || 0 : i) : i
        }
    }), _.each(["height", "width"], (function(e, t) {
        _.cssHooks[t] = {
            get: function(e, n, a) {
                if (n) return !Ve.test(_.css(e, "display")) || e.getClientRects().length && e.getBoundingClientRect().width ? Ze(e, t, a) : Me(e, Ge, (function() {
                    return Ze(e, t, a)
                }))
            },
            set: function(e, n, a) {
                var i, o = He(e),
                    r = !f.scrollboxSize() && "absolute" === o.position,
                    s = (r || a) && "border-box" === _.css(e, "boxSizing", !1, o),
                    u = a ? Ke(e, t, a, s, o) : 0;
                return s && r && (u -= Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - parseFloat(o[t]) - Ke(e, t, "border", !1, o) - .5)), u && (i = te.exec(n)) && "px" !== (i[3] || "px") && (e.style[t] = n, n = _.css(e, t)), Ye(0, n, u)
            }
        }
    })), _.cssHooks.marginLeft = ze(f.reliableMarginLeft, (function(e, t) {
        if (t) return (parseFloat(Re(e, "marginLeft")) || e.getBoundingClientRect().left - Me(e, {
            marginLeft: 0
        }, (function() {
            return e.getBoundingClientRect().left
        }))) + "px"
    })), _.each({
        margin: "",
        padding: "",
        border: "Width"
    }, (function(e, t) {
        _.cssHooks[e + t] = {
            expand: function(n) {
                for (var a = 0, i = {}, o = "string" == typeof n ? n.split(" ") : [n]; a < 4; a++) i[e + ne[a] + t] = o[a] || o[a - 2] || o[0];
                return i
            }
        }, "margin" !== e && (_.cssHooks[e + t].set = Ye)
    })), _.fn.extend({
        css: function(e, t) {
            return z(this, (function(e, t, n) {
                var a, i, o = {},
                    r = 0;
                if (Array.isArray(t)) {
                    for (a = He(e), i = t.length; r < i; r++) o[t[r]] = _.css(e, t[r], !1, a);
                    return o
                }
                return void 0 !== n ? _.style(e, t, n) : _.css(e, t)
            }), e, t, 1 < arguments.length)
        }
    }), ((_.Tween = et).prototype = {
        constructor: et,
        init: function(e, t, n, a, i, o) {
            this.elem = e, this.prop = n, this.easing = i || _.easing._default, this.options = t, this.start = this.now = this.cur(), this.end = a, this.unit = o || (_.cssNumber[n] ? "" : "px")
        },
        cur: function() {
            var e = et.propHooks[this.prop];
            return e && e.get ? e.get(this) : et.propHooks._default.get(this)
        },
        run: function(e) {
            var t, n = et.propHooks[this.prop];
            return this.options.duration ? this.pos = t = _.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : this.pos = t = e, this.now = (this.end - this.start) * t + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), n && n.set ? n.set(this) : et.propHooks._default.set(this), this
        }
    }).init.prototype = et.prototype, (et.propHooks = {
        _default: {
            get: function(e) {
                var t;
                return 1 !== e.elem.nodeType || null != e.elem[e.prop] && null == e.elem.style[e.prop] ? e.elem[e.prop] : (t = _.css(e.elem, e.prop, "")) && "auto" !== t ? t : 0
            },
            set: function(e) {
                _.fx.step[e.prop] ? _.fx.step[e.prop](e) : 1 !== e.elem.nodeType || !_.cssHooks[e.prop] && null == e.elem.style[Qe(e.prop)] ? e.elem[e.prop] = e.now : _.style(e.elem, e.prop, e.now + e.unit)
            }
        }
    }).scrollTop = et.propHooks.scrollLeft = {
        set: function(e) {
            e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now)
        }
    }, _.easing = {
        linear: function(e) {
            return e
        },
        swing: function(e) {
            return .5 - Math.cos(e * Math.PI) / 2
        },
        _default: "swing"
    }, _.fx = et.prototype.init, _.fx.step = {};
    var tt, nt, at, it, ot = /^(?:toggle|show|hide)$/,
        rt = /queueHooks$/;

    function st() {
        nt && (!1 === g.hidden && e.requestAnimationFrame ? e.requestAnimationFrame(st) : e.setTimeout(st, _.fx.interval), _.fx.tick())
    }

    function ut() {
        return e.setTimeout((function() {
            tt = void 0
        })), tt = Date.now()
    }

    function ct(e, t) {
        var n, a = 0,
            i = {
                height: e
            };
        for (t = t ? 1 : 0; a < 4; a += 2 - t) i["margin" + (n = ne[a])] = i["padding" + n] = e;
        return t && (i.opacity = i.width = e), i
    }

    function lt(e, t, n) {
        for (var a, i = (dt.tweeners[t] || []).concat(dt.tweeners["*"]), o = 0, r = i.length; o < r; o++)
            if (a = i[o].call(n, t, e)) return a
    }

    function dt(e, t, n) {
        var a, i, o = 0,
            r = dt.prefilters.length,
            s = _.Deferred().always((function() {
                delete u.elem
            })),
            u = function() {
                if (i) return !1;
                for (var t = tt || ut(), n = Math.max(0, c.startTime + c.duration - t), a = 1 - (n / c.duration || 0), o = 0, r = c.tweens.length; o < r; o++) c.tweens[o].run(a);
                return s.notifyWith(e, [c, a, n]), a < 1 && r ? n : (r || s.notifyWith(e, [c, 1, 0]), s.resolveWith(e, [c]), !1)
            },
            c = s.promise({
                elem: e,
                props: _.extend({}, t),
                opts: _.extend(!0, {
                    specialEasing: {},
                    easing: _.easing._default
                }, n),
                originalProperties: t,
                originalOptions: n,
                startTime: tt || ut(),
                duration: n.duration,
                tweens: [],
                createTween: function(t, n) {
                    var a = _.Tween(e, c.opts, t, n, c.opts.specialEasing[t] || c.opts.easing);
                    return c.tweens.push(a), a
                },
                stop: function(t) {
                    var n = 0,
                        a = t ? c.tweens.length : 0;
                    if (i) return this;
                    for (i = !0; n < a; n++) c.tweens[n].run(1);
                    return t ? (s.notifyWith(e, [c, 1, 0]), s.resolveWith(e, [c, t])) : s.rejectWith(e, [c, t]), this
                }
            }),
            l = c.props;
        for (function(e, t) {
                var n, a, i, o, r;
                for (n in e)
                    if (i = t[a = Q(n)], o = e[n], Array.isArray(o) && (i = o[1], o = e[n] = o[0]), n !== a && (e[a] = o, delete e[n]), (r = _.cssHooks[a]) && "expand" in r)
                        for (n in o = r.expand(o), delete e[a], o) n in e || (e[n] = o[n], t[n] = i);
                    else t[a] = i
            }(l, c.opts.specialEasing); o < r; o++)
            if (a = dt.prefilters[o].call(c, e, l, c.opts)) return h(a.stop) && (_._queueHooks(c.elem, c.opts.queue).stop = a.stop.bind(a)), a;
        return _.map(l, lt, c), h(c.opts.start) && c.opts.start.call(e, c), c.progress(c.opts.progress).done(c.opts.done, c.opts.complete).fail(c.opts.fail).always(c.opts.always), _.fx.timer(_.extend(u, {
            elem: e,
            anim: c,
            queue: c.opts.queue
        })), c
    }
    _.Animation = _.extend(dt, {
        tweeners: {
            "*": [function(e, t) {
                var n = this.createTween(e, t);
                return se(n.elem, e, te.exec(t), n), n
            }]
        },
        tweener: function(e, t) {
            h(e) ? (t = e, e = ["*"]) : e = e.match(O);
            for (var n, a = 0, i = e.length; a < i; a++) n = e[a], dt.tweeners[n] = dt.tweeners[n] || [], dt.tweeners[n].unshift(t)
        },
        prefilters: [function(e, t, n) {
            var a, i, o, r, s, u, c, l, d = "width" in t || "height" in t,
                p = this,
                f = {},
                h = e.style,
                m = e.nodeType && re(e),
                g = G.get(e, "fxshow");
            for (a in n.queue || (null == (r = _._queueHooks(e, "fx")).unqueued && (r.unqueued = 0, s = r.empty.fire, r.empty.fire = function() {
                    r.unqueued || s()
                }), r.unqueued++, p.always((function() {
                    p.always((function() {
                        r.unqueued--, _.queue(e, "fx").length || r.empty.fire()
                    }))
                }))), t)
                if (i = t[a], ot.test(i)) {
                    if (delete t[a], o = o || "toggle" === i, i === (m ? "hide" : "show")) {
                        if ("show" !== i || !g || void 0 === g[a]) continue;
                        m = !0
                    }
                    f[a] = g && g[a] || _.style(e, a)
                } if ((u = !_.isEmptyObject(t)) || !_.isEmptyObject(f))
                for (a in d && 1 === e.nodeType && (n.overflow = [h.overflow, h.overflowX, h.overflowY], null == (c = g && g.display) && (c = G.get(e, "display")), "none" === (l = _.css(e, "display")) && (c ? l = c : (ce([e], !0), c = e.style.display || c, l = _.css(e, "display"), ce([e]))), ("inline" === l || "inline-block" === l && null != c) && "none" === _.css(e, "float") && (u || (p.done((function() {
                        h.display = c
                    })), null == c && (l = h.display, c = "none" === l ? "" : l)), h.display = "inline-block")), n.overflow && (h.overflow = "hidden", p.always((function() {
                        h.overflow = n.overflow[0], h.overflowX = n.overflow[1], h.overflowY = n.overflow[2]
                    }))), u = !1, f) u || (g ? "hidden" in g && (m = g.hidden) : g = G.access(e, "fxshow", {
                    display: c
                }), o && (g.hidden = !m), m && ce([e], !0), p.done((function() {
                    for (a in m || ce([e]), G.remove(e, "fxshow"), f) _.style(e, a, f[a])
                }))), u = lt(m ? g[a] : 0, a, p), a in g || (g[a] = u.start, m && (u.end = u.start, u.start = 0))
        }],
        prefilter: function(e, t) {
            t ? dt.prefilters.unshift(e) : dt.prefilters.push(e)
        }
    }), _.speed = function(e, t, n) {
        var a = e && "object" == typeof e ? _.extend({}, e) : {
            complete: n || !n && t || h(e) && e,
            duration: e,
            easing: n && t || t && !h(t) && t
        };
        return _.fx.off ? a.duration = 0 : "number" != typeof a.duration && (a.duration in _.fx.speeds ? a.duration = _.fx.speeds[a.duration] : a.duration = _.fx.speeds._default), null != a.queue && !0 !== a.queue || (a.queue = "fx"), a.old = a.complete, a.complete = function() {
            h(a.old) && a.old.call(this), a.queue && _.dequeue(this, a.queue)
        }, a
    }, _.fn.extend({
        fadeTo: function(e, t, n, a) {
            return this.filter(re).css("opacity", 0).show().end().animate({
                opacity: t
            }, e, n, a)
        },
        animate: function(e, t, n, a) {
            var i = _.isEmptyObject(e),
                o = _.speed(t, n, a),
                r = function() {
                    var t = dt(this, _.extend({}, e), o);
                    (i || G.get(this, "finish")) && t.stop(!0)
                };
            return r.finish = r, i || !1 === o.queue ? this.each(r) : this.queue(o.queue, r)
        },
        stop: function(e, t, n) {
            var a = function(e) {
                var t = e.stop;
                delete e.stop, t(n)
            };
            return "string" != typeof e && (n = t, t = e, e = void 0), t && this.queue(e || "fx", []), this.each((function() {
                var t = !0,
                    i = null != e && e + "queueHooks",
                    o = _.timers,
                    r = G.get(this);
                if (i) r[i] && r[i].stop && a(r[i]);
                else
                    for (i in r) r[i] && r[i].stop && rt.test(i) && a(r[i]);
                for (i = o.length; i--;) o[i].elem !== this || null != e && o[i].queue !== e || (o[i].anim.stop(n), t = !1, o.splice(i, 1));
                !t && n || _.dequeue(this, e)
            }))
        },
        finish: function(e) {
            return !1 !== e && (e = e || "fx"), this.each((function() {
                var t, n = G.get(this),
                    a = n[e + "queue"],
                    i = n[e + "queueHooks"],
                    o = _.timers,
                    r = a ? a.length : 0;
                for (n.finish = !0, _.queue(this, e, []), i && i.stop && i.stop.call(this, !0), t = o.length; t--;) o[t].elem === this && o[t].queue === e && (o[t].anim.stop(!0), o.splice(t, 1));
                for (t = 0; t < r; t++) a[t] && a[t].finish && a[t].finish.call(this);
                delete n.finish
            }))
        }
    }), _.each(["toggle", "show", "hide"], (function(e, t) {
        var n = _.fn[t];
        _.fn[t] = function(e, a, i) {
            return null == e || "boolean" == typeof e ? n.apply(this, arguments) : this.animate(ct(t, !0), e, a, i)
        }
    })), _.each({
        slideDown: ct("show"),
        slideUp: ct("hide"),
        slideToggle: ct("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, (function(e, t) {
        _.fn[e] = function(e, n, a) {
            return this.animate(t, e, n, a)
        }
    })), _.timers = [], _.fx.tick = function() {
        var e, t = 0,
            n = _.timers;
        for (tt = Date.now(); t < n.length; t++)(e = n[t])() || n[t] !== e || n.splice(t--, 1);
        n.length || _.fx.stop(), tt = void 0
    }, _.fx.timer = function(e) {
        _.timers.push(e), _.fx.start()
    }, _.fx.interval = 13, _.fx.start = function() {
        nt || (nt = !0, st())
    }, _.fx.stop = function() {
        nt = null
    }, _.fx.speeds = {
        slow: 600,
        fast: 200,
        _default: 400
    }, _.fn.delay = function(t, n) {
        return t = _.fx && _.fx.speeds[t] || t, n = n || "fx", this.queue(n, (function(n, a) {
            var i = e.setTimeout(n, t);
            a.stop = function() {
                e.clearTimeout(i)
            }
        }))
    }, at = g.createElement("input"), it = g.createElement("select").appendChild(g.createElement("option")), at.type = "checkbox", f.checkOn = "" !== at.value, f.optSelected = it.selected, (at = g.createElement("input")).value = "t", at.type = "radio", f.radioValue = "t" === at.value;
    var pt, ft = _.expr.attrHandle;
    _.fn.extend({
        attr: function(e, t) {
            return z(this, _.attr, e, t, 1 < arguments.length)
        },
        removeAttr: function(e) {
            return this.each((function() {
                _.removeAttr(this, e)
            }))
        }
    }), _.extend({
        attr: function(e, t, n) {
            var a, i, o = e.nodeType;
            if (3 !== o && 8 !== o && 2 !== o) return void 0 === e.getAttribute ? _.prop(e, t, n) : (1 === o && _.isXMLDoc(e) || (i = _.attrHooks[t.toLowerCase()] || (_.expr.match.bool.test(t) ? pt : void 0)), void 0 !== n ? null === n ? void _.removeAttr(e, t) : i && "set" in i && void 0 !== (a = i.set(e, n, t)) ? a : (e.setAttribute(t, n + ""), n) : i && "get" in i && null !== (a = i.get(e, t)) ? a : null == (a = _.find.attr(e, t)) ? void 0 : a)
        },
        attrHooks: {
            type: {
                set: function(e, t) {
                    if (!f.radioValue && "radio" === t && k(e, "input")) {
                        var n = e.value;
                        return e.setAttribute("type", t), n && (e.value = n), t
                    }
                }
            }
        },
        removeAttr: function(e, t) {
            var n, a = 0,
                i = t && t.match(O);
            if (i && 1 === e.nodeType)
                for (; n = i[a++];) e.removeAttribute(n)
        }
    }), pt = {
        set: function(e, t, n) {
            return !1 === t ? _.removeAttr(e, n) : e.setAttribute(n, n), n
        }
    }, _.each(_.expr.match.bool.source.match(/\w+/g), (function(e, t) {
        var n = ft[t] || _.find.attr;
        ft[t] = function(e, t, a) {
            var i, o, r = t.toLowerCase();
            return a || (o = ft[r], ft[r] = i, i = null != n(e, t, a) ? r : null, ft[r] = o), i
        }
    }));
    var ht = /^(?:input|select|textarea|button)$/i,
        mt = /^(?:a|area)$/i;

    function gt(e) {
        return (e.match(O) || []).join(" ")
    }

    function vt(e) {
        return e.getAttribute && e.getAttribute("class") || ""
    }

    function yt(e) {
        return Array.isArray(e) ? e : "string" == typeof e && e.match(O) || []
    }
    _.fn.extend({
        prop: function(e, t) {
            return z(this, _.prop, e, t, 1 < arguments.length)
        },
        removeProp: function(e) {
            return this.each((function() {
                delete this[_.propFix[e] || e]
            }))
        }
    }), _.extend({
        prop: function(e, t, n) {
            var a, i, o = e.nodeType;
            if (3 !== o && 8 !== o && 2 !== o) return 1 === o && _.isXMLDoc(e) || (t = _.propFix[t] || t, i = _.propHooks[t]), void 0 !== n ? i && "set" in i && void 0 !== (a = i.set(e, n, t)) ? a : e[t] = n : i && "get" in i && null !== (a = i.get(e, t)) ? a : e[t]
        },
        propHooks: {
            tabIndex: {
                get: function(e) {
                    var t = _.find.attr(e, "tabindex");
                    return t ? parseInt(t, 10) : ht.test(e.nodeName) || mt.test(e.nodeName) && e.href ? 0 : -1
                }
            }
        },
        propFix: {
            for: "htmlFor",
            class: "className"
        }
    }), f.optSelected || (_.propHooks.selected = {
        get: function(e) {
            var t = e.parentNode;
            return t && t.parentNode && t.parentNode.selectedIndex, null
        },
        set: function(e) {
            var t = e.parentNode;
            t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex)
        }
    }), _.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], (function() {
        _.propFix[this.toLowerCase()] = this
    })), _.fn.extend({
        addClass: function(e) {
            var t, n, a, i, o, r, s, u = 0;
            if (h(e)) return this.each((function(t) {
                _(this).addClass(e.call(this, t, vt(this)))
            }));
            if ((t = yt(e)).length)
                for (; n = this[u++];)
                    if (i = vt(n), a = 1 === n.nodeType && " " + gt(i) + " ") {
                        for (r = 0; o = t[r++];) a.indexOf(" " + o + " ") < 0 && (a += o + " ");
                        i !== (s = gt(a)) && n.setAttribute("class", s)
                    } return this
        },
        removeClass: function(e) {
            var t, n, a, i, o, r, s, u = 0;
            if (h(e)) return this.each((function(t) {
                _(this).removeClass(e.call(this, t, vt(this)))
            }));
            if (!arguments.length) return this.attr("class", "");
            if ((t = yt(e)).length)
                for (; n = this[u++];)
                    if (i = vt(n), a = 1 === n.nodeType && " " + gt(i) + " ") {
                        for (r = 0; o = t[r++];)
                            for (; - 1 < a.indexOf(" " + o + " ");) a = a.replace(" " + o + " ", " ");
                        i !== (s = gt(a)) && n.setAttribute("class", s)
                    } return this
        },
        toggleClass: function(e, t) {
            var n = typeof e,
                a = "string" === n || Array.isArray(e);
            return "boolean" == typeof t && a ? t ? this.addClass(e) : this.removeClass(e) : h(e) ? this.each((function(n) {
                _(this).toggleClass(e.call(this, n, vt(this), t), t)
            })) : this.each((function() {
                var t, i, o, r;
                if (a)
                    for (i = 0, o = _(this), r = yt(e); t = r[i++];) o.hasClass(t) ? o.removeClass(t) : o.addClass(t);
                else void 0 !== e && "boolean" !== n || ((t = vt(this)) && G.set(this, "__className__", t), this.setAttribute && this.setAttribute("class", t || !1 === e ? "" : G.get(this, "__className__") || ""))
            }))
        },
        hasClass: function(e) {
            var t, n, a = 0;
            for (t = " " + e + " "; n = this[a++];)
                if (1 === n.nodeType && -1 < (" " + gt(vt(n)) + " ").indexOf(t)) return !0;
            return !1
        }
    });
    var bt = /\r/g;
    _.fn.extend({
        val: function(e) {
            var t, n, a, i = this[0];
            return arguments.length ? (a = h(e), this.each((function(n) {
                var i;
                1 === this.nodeType && (null == (i = a ? e.call(this, n, _(this).val()) : e) ? i = "" : "number" == typeof i ? i += "" : Array.isArray(i) && (i = _.map(i, (function(e) {
                    return null == e ? "" : e + ""
                }))), (t = _.valHooks[this.type] || _.valHooks[this.nodeName.toLowerCase()]) && "set" in t && void 0 !== t.set(this, i, "value") || (this.value = i))
            }))) : i ? (t = _.valHooks[i.type] || _.valHooks[i.nodeName.toLowerCase()]) && "get" in t && void 0 !== (n = t.get(i, "value")) ? n : "string" == typeof(n = i.value) ? n.replace(bt, "") : null == n ? "" : n : void 0
        }
    }), _.extend({
        valHooks: {
            option: {
                get: function(e) {
                    var t = _.find.attr(e, "value");
                    return null != t ? t : gt(_.text(e))
                }
            },
            select: {
                get: function(e) {
                    var t, n, a, i = e.options,
                        o = e.selectedIndex,
                        r = "select-one" === e.type,
                        s = r ? null : [],
                        u = r ? o + 1 : i.length;
                    for (a = o < 0 ? u : r ? o : 0; a < u; a++)
                        if (((n = i[a]).selected || a === o) && !n.disabled && (!n.parentNode.disabled || !k(n.parentNode, "optgroup"))) {
                            if (t = _(n).val(), r) return t;
                            s.push(t)
                        } return s
                },
                set: function(e, t) {
                    for (var n, a, i = e.options, o = _.makeArray(t), r = i.length; r--;)((a = i[r]).selected = -1 < _.inArray(_.valHooks.option.get(a), o)) && (n = !0);
                    return n || (e.selectedIndex = -1), o
                }
            }
        }
    }), _.each(["radio", "checkbox"], (function() {
        _.valHooks[this] = {
            set: function(e, t) {
                if (Array.isArray(t)) return e.checked = -1 < _.inArray(_(e).val(), t)
            }
        }, f.checkOn || (_.valHooks[this].get = function(e) {
            return null === e.getAttribute("value") ? "on" : e.value
        })
    })), f.focusin = "onfocusin" in e;
    var xt = /^(?:focusinfocus|focusoutblur)$/,
        _t = function(e) {
            e.stopPropagation()
        };
    _.extend(_.event, {
        trigger: function(t, n, a, i) {
            var o, r, s, u, c, d, p, f, v = [a || g],
                y = l.call(t, "type") ? t.type : t,
                b = l.call(t, "namespace") ? t.namespace.split(".") : [];
            if (r = f = s = a = a || g, 3 !== a.nodeType && 8 !== a.nodeType && !xt.test(y + _.event.triggered) && (-1 < y.indexOf(".") && (y = (b = y.split(".")).shift(), b.sort()), c = y.indexOf(":") < 0 && "on" + y, (t = t[_.expando] ? t : new _.Event(y, "object" == typeof t && t)).isTrigger = i ? 2 : 3, t.namespace = b.join("."), t.rnamespace = t.namespace ? new RegExp("(^|\\.)" + b.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, t.result = void 0, t.target || (t.target = a), n = null == n ? [t] : _.makeArray(n, [t]), p = _.event.special[y] || {}, i || !p.trigger || !1 !== p.trigger.apply(a, n))) {
                if (!i && !p.noBubble && !m(a)) {
                    for (u = p.delegateType || y, xt.test(u + y) || (r = r.parentNode); r; r = r.parentNode) v.push(r), s = r;
                    s === (a.ownerDocument || g) && v.push(s.defaultView || s.parentWindow || e)
                }
                for (o = 0;
                    (r = v[o++]) && !t.isPropagationStopped();) f = r, t.type = 1 < o ? u : p.bindType || y, (d = (G.get(r, "events") || Object.create(null))[t.type] && G.get(r, "handle")) && d.apply(r, n), (d = c && r[c]) && d.apply && V(r) && (t.result = d.apply(r, n), !1 === t.result && t.preventDefault());
                return t.type = y, i || t.isDefaultPrevented() || p._default && !1 !== p._default.apply(v.pop(), n) || !V(a) || c && h(a[y]) && !m(a) && ((s = a[c]) && (a[c] = null), _.event.triggered = y, t.isPropagationStopped() && f.addEventListener(y, _t), a[y](), t.isPropagationStopped() && f.removeEventListener(y, _t), _.event.triggered = void 0, s && (a[c] = s)), t.result
            }
        },
        simulate: function(e, t, n) {
            var a = _.extend(new _.Event, n, {
                type: e,
                isSimulated: !0
            });
            _.event.trigger(a, null, t)
        }
    }), _.fn.extend({
        trigger: function(e, t) {
            return this.each((function() {
                _.event.trigger(e, t, this)
            }))
        },
        triggerHandler: function(e, t) {
            var n = this[0];
            if (n) return _.event.trigger(e, t, n, !0)
        }
    }), f.focusin || _.each({
        focus: "focusin",
        blur: "focusout"
    }, (function(e, t) {
        var n = function(e) {
            _.event.simulate(t, e.target, _.event.fix(e))
        };
        _.event.special[t] = {
            setup: function() {
                var a = this.ownerDocument || this.document || this,
                    i = G.access(a, t);
                i || a.addEventListener(e, n, !0), G.access(a, t, (i || 0) + 1)
            },
            teardown: function() {
                var a = this.ownerDocument || this.document || this,
                    i = G.access(a, t) - 1;
                i ? G.access(a, t, i) : (a.removeEventListener(e, n, !0), G.remove(a, t))
            }
        }
    }));
    var wt = e.location,
        Ct = {
            guid: Date.now()
        },
        jt = /\?/;
    _.parseXML = function(t) {
        var n;
        if (!t || "string" != typeof t) return null;
        try {
            n = (new e.DOMParser).parseFromString(t, "text/xml")
        } catch (t) {
            n = void 0
        }
        return n && !n.getElementsByTagName("parsererror").length || _.error("Invalid XML: " + t), n
    };
    var St = /\[\]$/,
        Tt = /\r?\n/g,
        kt = /^(?:submit|button|image|reset|file)$/i,
        $t = /^(?:input|select|textarea|keygen)/i;

    function Et(e, t, n, a) {
        var i;
        if (Array.isArray(t)) _.each(t, (function(t, i) {
            n || St.test(e) ? a(e, i) : Et(e + "[" + ("object" == typeof i && null != i ? t : "") + "]", i, n, a)
        }));
        else if (n || "object" !== b(t)) a(e, t);
        else
            for (i in t) Et(e + "[" + i + "]", t[i], n, a)
    }
    _.param = function(e, t) {
        var n, a = [],
            i = function(e, t) {
                var n = h(t) ? t() : t;
                a[a.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null == n ? "" : n)
            };
        if (null == e) return "";
        if (Array.isArray(e) || e.jquery && !_.isPlainObject(e)) _.each(e, (function() {
            i(this.name, this.value)
        }));
        else
            for (n in e) Et(n, e[n], t, i);
        return a.join("&")
    }, _.fn.extend({
        serialize: function() {
            return _.param(this.serializeArray())
        },
        serializeArray: function() {
            return this.map((function() {
                var e = _.prop(this, "elements");
                return e ? _.makeArray(e) : this
            })).filter((function() {
                var e = this.type;
                return this.name && !_(this).is(":disabled") && $t.test(this.nodeName) && !kt.test(e) && (this.checked || !pe.test(e))
            })).map((function(e, t) {
                var n = _(this).val();
                return null == n ? null : Array.isArray(n) ? _.map(n, (function(e) {
                    return {
                        name: t.name,
                        value: e.replace(Tt, "\r\n")
                    }
                })) : {
                    name: t.name,
                    value: n.replace(Tt, "\r\n")
                }
            })).get()
        }
    });
    var At = /%20/g,
        Dt = /#.*$/,
        Lt = /([?&])_=[^&]*/,
        Pt = /^(.*?):[ \t]*([^\r\n]*)$/gm,
        Nt = /^(?:GET|HEAD)$/,
        Ot = /^\/\//,
        qt = {},
        It = {},
        Ht = "*/".concat("*"),
        Mt = g.createElement("a");

    function Bt(e) {
        return function(t, n) {
            "string" != typeof t && (n = t, t = "*");
            var a, i = 0,
                o = t.toLowerCase().match(O) || [];
            if (h(n))
                for (; a = o[i++];) "+" === a[0] ? (a = a.slice(1) || "*", (e[a] = e[a] || []).unshift(n)) : (e[a] = e[a] || []).push(n)
        }
    }

    function Rt(e, t, n, a) {
        var i = {},
            o = e === It;

        function r(s) {
            var u;
            return i[s] = !0, _.each(e[s] || [], (function(e, s) {
                var c = s(t, n, a);
                return "string" != typeof c || o || i[c] ? o ? !(u = c) : void 0 : (t.dataTypes.unshift(c), r(c), !1)
            })), u
        }
        return r(t.dataTypes[0]) || !i["*"] && r("*")
    }

    function zt(e, t) {
        var n, a, i = _.ajaxSettings.flatOptions || {};
        for (n in t) void 0 !== t[n] && ((i[n] ? e : a || (a = {}))[n] = t[n]);
        return a && _.extend(!0, e, a), e
    }
    Mt.href = wt.href, _.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: wt.href,
            type: "GET",
            isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(wt.protocol),
            global: !0,
            processData: !0,
            async: !0,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            accepts: {
                "*": Ht,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            converters: {
                "* text": String,
                "text html": !0,
                "text json": JSON.parse,
                "text xml": _.parseXML
            },
            flatOptions: {
                url: !0,
                context: !0
            }
        },
        ajaxSetup: function(e, t) {
            return t ? zt(zt(e, _.ajaxSettings), t) : zt(_.ajaxSettings, e)
        },
        ajaxPrefilter: Bt(qt),
        ajaxTransport: Bt(It),
        ajax: function(t, n) {
            "object" == typeof t && (n = t, t = void 0), n = n || {};
            var a, i, o, r, s, u, c, l, d, p, f = _.ajaxSetup({}, n),
                h = f.context || f,
                m = f.context && (h.nodeType || h.jquery) ? _(h) : _.event,
                v = _.Deferred(),
                y = _.Callbacks("once memory"),
                b = f.statusCode || {},
                x = {},
                w = {},
                C = "canceled",
                j = {
                    readyState: 0,
                    getResponseHeader: function(e) {
                        var t;
                        if (c) {
                            if (!r)
                                for (r = {}; t = Pt.exec(o);) r[t[1].toLowerCase() + " "] = (r[t[1].toLowerCase() + " "] || []).concat(t[2]);
                            t = r[e.toLowerCase() + " "]
                        }
                        return null == t ? null : t.join(", ")
                    },
                    getAllResponseHeaders: function() {
                        return c ? o : null
                    },
                    setRequestHeader: function(e, t) {
                        return null == c && (e = w[e.toLowerCase()] = w[e.toLowerCase()] || e, x[e] = t), this
                    },
                    overrideMimeType: function(e) {
                        return null == c && (f.mimeType = e), this
                    },
                    statusCode: function(e) {
                        var t;
                        if (e)
                            if (c) j.always(e[j.status]);
                            else
                                for (t in e) b[t] = [b[t], e[t]];
                        return this
                    },
                    abort: function(e) {
                        var t = e || C;
                        return a && a.abort(t), S(0, t), this
                    }
                };
            if (v.promise(j), f.url = ((t || f.url || wt.href) + "").replace(Ot, wt.protocol + "//"), f.type = n.method || n.type || f.method || f.type, f.dataTypes = (f.dataType || "*").toLowerCase().match(O) || [""], null == f.crossDomain) {
                u = g.createElement("a");
                try {
                    u.href = f.url, u.href = u.href, f.crossDomain = Mt.protocol + "//" + Mt.host != u.protocol + "//" + u.host
                } catch (t) {
                    f.crossDomain = !0
                }
            }
            if (f.data && f.processData && "string" != typeof f.data && (f.data = _.param(f.data, f.traditional)), Rt(qt, f, n, j), c) return j;
            for (d in (l = _.event && f.global) && 0 == _.active++ && _.event.trigger("ajaxStart"), f.type = f.type.toUpperCase(), f.hasContent = !Nt.test(f.type), i = f.url.replace(Dt, ""), f.hasContent ? f.data && f.processData && 0 === (f.contentType || "").indexOf("application/x-www-form-urlencoded") && (f.data = f.data.replace(At, "+")) : (p = f.url.slice(i.length), f.data && (f.processData || "string" == typeof f.data) && (i += (jt.test(i) ? "&" : "?") + f.data, delete f.data), !1 === f.cache && (i = i.replace(Lt, "$1"), p = (jt.test(i) ? "&" : "?") + "_=" + Ct.guid++ + p), f.url = i + p), f.ifModified && (_.lastModified[i] && j.setRequestHeader("If-Modified-Since", _.lastModified[i]), _.etag[i] && j.setRequestHeader("If-None-Match", _.etag[i])), (f.data && f.hasContent && !1 !== f.contentType || n.contentType) && j.setRequestHeader("Content-Type", f.contentType), j.setRequestHeader("Accept", f.dataTypes[0] && f.accepts[f.dataTypes[0]] ? f.accepts[f.dataTypes[0]] + ("*" !== f.dataTypes[0] ? ", " + Ht + "; q=0.01" : "") : f.accepts["*"]), f.headers) j.setRequestHeader(d, f.headers[d]);
            if (f.beforeSend && (!1 === f.beforeSend.call(h, j, f) || c)) return j.abort();
            if (C = "abort", y.add(f.complete), j.done(f.success), j.fail(f.error), a = Rt(It, f, n, j)) {
                if (j.readyState = 1, l && m.trigger("ajaxSend", [j, f]), c) return j;
                f.async && 0 < f.timeout && (s = e.setTimeout((function() {
                    j.abort("timeout")
                }), f.timeout));
                try {
                    c = !1, a.send(x, S)
                } catch (t) {
                    if (c) throw t;
                    S(-1, t)
                }
            } else S(-1, "No Transport");

            function S(t, n, r, u) {
                var d, p, g, x, w, C = n;
                c || (c = !0, s && e.clearTimeout(s), a = void 0, o = u || "", j.readyState = 0 < t ? 4 : 0, d = 200 <= t && t < 300 || 304 === t, r && (x = function(e, t, n) {
                    for (var a, i, o, r, s = e.contents, u = e.dataTypes;
                        "*" === u[0];) u.shift(), void 0 === a && (a = e.mimeType || t.getResponseHeader("Content-Type"));
                    if (a)
                        for (i in s)
                            if (s[i] && s[i].test(a)) {
                                u.unshift(i);
                                break
                            } if (u[0] in n) o = u[0];
                    else {
                        for (i in n) {
                            if (!u[0] || e.converters[i + " " + u[0]]) {
                                o = i;
                                break
                            }
                            r || (r = i)
                        }
                        o = o || r
                    }
                    if (o) return o !== u[0] && u.unshift(o), n[o]
                }(f, j, r)), !d && -1 < _.inArray("script", f.dataTypes) && (f.converters["text script"] = function() {}), x = function(e, t, n, a) {
                    var i, o, r, s, u, c = {},
                        l = e.dataTypes.slice();
                    if (l[1])
                        for (r in e.converters) c[r.toLowerCase()] = e.converters[r];
                    for (o = l.shift(); o;)
                        if (e.responseFields[o] && (n[e.responseFields[o]] = t), !u && a && e.dataFilter && (t = e.dataFilter(t, e.dataType)), u = o, o = l.shift())
                            if ("*" === o) o = u;
                            else if ("*" !== u && u !== o) {
                        if (!(r = c[u + " " + o] || c["* " + o]))
                            for (i in c)
                                if ((s = i.split(" "))[1] === o && (r = c[u + " " + s[0]] || c["* " + s[0]])) {
                                    !0 === r ? r = c[i] : !0 !== c[i] && (o = s[0], l.unshift(s[1]));
                                    break
                                } if (!0 !== r)
                            if (r && e.throws) t = r(t);
                            else try {
                                t = r(t)
                            } catch (e) {
                                return {
                                    state: "parsererror",
                                    error: r ? e : "No conversion from " + u + " to " + o
                                }
                            }
                    }
                    return {
                        state: "success",
                        data: t
                    }
                }(f, x, j, d), d ? (f.ifModified && ((w = j.getResponseHeader("Last-Modified")) && (_.lastModified[i] = w), (w = j.getResponseHeader("etag")) && (_.etag[i] = w)), 204 === t || "HEAD" === f.type ? C = "nocontent" : 304 === t ? C = "notmodified" : (C = x.state, p = x.data, d = !(g = x.error))) : (g = C, !t && C || (C = "error", t < 0 && (t = 0))), j.status = t, j.statusText = (n || C) + "", d ? v.resolveWith(h, [p, C, j]) : v.rejectWith(h, [j, C, g]), j.statusCode(b), b = void 0, l && m.trigger(d ? "ajaxSuccess" : "ajaxError", [j, f, d ? p : g]), y.fireWith(h, [j, C]), l && (m.trigger("ajaxComplete", [j, f]), --_.active || _.event.trigger("ajaxStop")))
            }
            return j
        },
        getJSON: function(e, t, n) {
            return _.get(e, t, n, "json")
        },
        getScript: function(e, t) {
            return _.get(e, void 0, t, "script")
        }
    }), _.each(["get", "post"], (function(e, t) {
        _[t] = function(e, n, a, i) {
            return h(n) && (i = i || a, a = n, n = void 0), _.ajax(_.extend({
                url: e,
                type: t,
                dataType: i,
                data: n,
                success: a
            }, _.isPlainObject(e) && e))
        }
    })), _.ajaxPrefilter((function(e) {
        var t;
        for (t in e.headers) "content-type" === t.toLowerCase() && (e.contentType = e.headers[t] || "")
    })), _._evalUrl = function(e, t, n) {
        return _.ajax({
            url: e,
            type: "GET",
            dataType: "script",
            cache: !0,
            async: !1,
            global: !1,
            converters: {
                "text script": function() {}
            },
            dataFilter: function(e) {
                _.globalEval(e, t, n)
            }
        })
    }, _.fn.extend({
        wrapAll: function(e) {
            var t;
            return this[0] && (h(e) && (e = e.call(this[0])), t = _(e, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && t.insertBefore(this[0]), t.map((function() {
                for (var e = this; e.firstElementChild;) e = e.firstElementChild;
                return e
            })).append(this)), this
        },
        wrapInner: function(e) {
            return h(e) ? this.each((function(t) {
                _(this).wrapInner(e.call(this, t))
            })) : this.each((function() {
                var t = _(this),
                    n = t.contents();
                n.length ? n.wrapAll(e) : t.append(e)
            }))
        },
        wrap: function(e) {
            var t = h(e);
            return this.each((function(n) {
                _(this).wrapAll(t ? e.call(this, n) : e)
            }))
        },
        unwrap: function(e) {
            return this.parent(e).not("body").each((function() {
                _(this).replaceWith(this.childNodes)
            })), this
        }
    }), _.expr.pseudos.hidden = function(e) {
        return !_.expr.pseudos.visible(e)
    }, _.expr.pseudos.visible = function(e) {
        return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length)
    }, _.ajaxSettings.xhr = function() {
        try {
            return new e.XMLHttpRequest
        } catch (e) {}
    };
    var Ft = {
            0: 200,
            1223: 204
        },
        Wt = _.ajaxSettings.xhr();
    f.cors = !!Wt && "withCredentials" in Wt, f.ajax = Wt = !!Wt, _.ajaxTransport((function(t) {
        var n, a;
        if (f.cors || Wt && !t.crossDomain) return {
            send: function(i, o) {
                var r, s = t.xhr();
                if (s.open(t.type, t.url, t.async, t.username, t.password), t.xhrFields)
                    for (r in t.xhrFields) s[r] = t.xhrFields[r];
                for (r in t.mimeType && s.overrideMimeType && s.overrideMimeType(t.mimeType), t.crossDomain || i["X-Requested-With"] || (i["X-Requested-With"] = "XMLHttpRequest"), i) s.setRequestHeader(r, i[r]);
                n = function(e) {
                    return function() {
                        n && (n = a = s.onload = s.onerror = s.onabort = s.ontimeout = s.onreadystatechange = null, "abort" === e ? s.abort() : "error" === e ? "number" != typeof s.status ? o(0, "error") : o(s.status, s.statusText) : o(Ft[s.status] || s.status, s.statusText, "text" !== (s.responseType || "text") || "string" != typeof s.responseText ? {
                            binary: s.response
                        } : {
                            text: s.responseText
                        }, s.getAllResponseHeaders()))
                    }
                }, s.onload = n(), a = s.onerror = s.ontimeout = n("error"), void 0 !== s.onabort ? s.onabort = a : s.onreadystatechange = function() {
                    4 === s.readyState && e.setTimeout((function() {
                        n && a()
                    }))
                }, n = n("abort");
                try {
                    s.send(t.hasContent && t.data || null)
                } catch (i) {
                    if (n) throw i
                }
            },
            abort: function() {
                n && n()
            }
        }
    })), _.ajaxPrefilter((function(e) {
        e.crossDomain && (e.contents.script = !1)
    })), _.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(e) {
                return _.globalEval(e), e
            }
        }
    }), _.ajaxPrefilter("script", (function(e) {
        void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET")
    })), _.ajaxTransport("script", (function(e) {
        var t, n;
        if (e.crossDomain || e.scriptAttrs) return {
            send: function(a, i) {
                t = _("<script>").attr(e.scriptAttrs || {}).prop({
                    charset: e.scriptCharset,
                    src: e.url
                }).on("load error", n = function(e) {
                    t.remove(), n = null, e && i("error" === e.type ? 404 : 200, e.type)
                }), g.head.appendChild(t[0])
            },
            abort: function() {
                n && n()
            }
        }
    }));
    var Ut, Qt = [],
        Vt = /(=)\?(?=&|$)|\?\?/;
    _.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var e = Qt.pop() || _.expando + "_" + Ct.guid++;
            return this[e] = !0, e
        }
    }), _.ajaxPrefilter("json jsonp", (function(t, n, a) {
        var i, o, r, s = !1 !== t.jsonp && (Vt.test(t.url) ? "url" : "string" == typeof t.data && 0 === (t.contentType || "").indexOf("application/x-www-form-urlencoded") && Vt.test(t.data) && "data");
        if (s || "jsonp" === t.dataTypes[0]) return i = t.jsonpCallback = h(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback, s ? t[s] = t[s].replace(Vt, "$1" + i) : !1 !== t.jsonp && (t.url += (jt.test(t.url) ? "&" : "?") + t.jsonp + "=" + i), t.converters["script json"] = function() {
            return r || _.error(i + " was not called"), r[0]
        }, t.dataTypes[0] = "json", o = e[i], e[i] = function() {
            r = arguments
        }, a.always((function() {
            void 0 === o ? _(e).removeProp(i) : e[i] = o, t[i] && (t.jsonpCallback = n.jsonpCallback, Qt.push(i)), r && h(o) && o(r[0]), r = o = void 0
        })), "script"
    })), f.createHTMLDocument = ((Ut = g.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>", 2 === Ut.childNodes.length), _.parseHTML = function(e, t, n) {
        return "string" != typeof e ? [] : ("boolean" == typeof t && (n = t, t = !1), t || (f.createHTMLDocument ? ((a = (t = g.implementation.createHTMLDocument("")).createElement("base")).href = g.location.href, t.head.appendChild(a)) : t = g), o = !n && [], (i = $.exec(e)) ? [t.createElement(i[1])] : (i = be([e], t, o), o && o.length && _(o).remove(), _.merge([], i.childNodes)));
        var a, i, o
    }, _.fn.load = function(e, t, n) {
        var a, i, o, r = this,
            s = e.indexOf(" ");
        return -1 < s && (a = gt(e.slice(s)), e = e.slice(0, s)), h(t) ? (n = t, t = void 0) : t && "object" == typeof t && (i = "POST"), 0 < r.length && _.ajax({
            url: e,
            type: i || "GET",
            dataType: "html",
            data: t
        }).done((function(e) {
            o = arguments, r.html(a ? _("<div>").append(_.parseHTML(e)).find(a) : e)
        })).always(n && function(e, t) {
            r.each((function() {
                n.apply(this, o || [e.responseText, t, e])
            }))
        }), this
    }, _.expr.pseudos.animated = function(e) {
        return _.grep(_.timers, (function(t) {
            return e === t.elem
        })).length
    }, _.offset = {
        setOffset: function(e, t, n) {
            var a, i, o, r, s, u, c = _.css(e, "position"),
                l = _(e),
                d = {};
            "static" === c && (e.style.position = "relative"), s = l.offset(), o = _.css(e, "top"), u = _.css(e, "left"), ("absolute" === c || "fixed" === c) && -1 < (o + u).indexOf("auto") ? (r = (a = l.position()).top, i = a.left) : (r = parseFloat(o) || 0, i = parseFloat(u) || 0), h(t) && (t = t.call(e, n, _.extend({}, s))), null != t.top && (d.top = t.top - s.top + r), null != t.left && (d.left = t.left - s.left + i), "using" in t ? t.using.call(e, d) : ("number" == typeof d.top && (d.top += "px"), "number" == typeof d.left && (d.left += "px"), l.css(d))
        }
    }, _.fn.extend({
        offset: function(e) {
            if (arguments.length) return void 0 === e ? this : this.each((function(t) {
                _.offset.setOffset(this, e, t)
            }));
            var t, n, a = this[0];
            return a ? a.getClientRects().length ? (t = a.getBoundingClientRect(), n = a.ownerDocument.defaultView, {
                top: t.top + n.pageYOffset,
                left: t.left + n.pageXOffset
            }) : {
                top: 0,
                left: 0
            } : void 0
        },
        position: function() {
            if (this[0]) {
                var e, t, n, a = this[0],
                    i = {
                        top: 0,
                        left: 0
                    };
                if ("fixed" === _.css(a, "position")) t = a.getBoundingClientRect();
                else {
                    for (t = this.offset(), n = a.ownerDocument, e = a.offsetParent || n.documentElement; e && (e === n.body || e === n.documentElement) && "static" === _.css(e, "position");) e = e.parentNode;
                    e && e !== a && 1 === e.nodeType && ((i = _(e).offset()).top += _.css(e, "borderTopWidth", !0), i.left += _.css(e, "borderLeftWidth", !0))
                }
                return {
                    top: t.top - i.top - _.css(a, "marginTop", !0),
                    left: t.left - i.left - _.css(a, "marginLeft", !0)
                }
            }
        },
        offsetParent: function() {
            return this.map((function() {
                for (var e = this.offsetParent; e && "static" === _.css(e, "position");) e = e.offsetParent;
                return e || ae
            }))
        }
    }), _.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, (function(e, t) {
        var n = "pageYOffset" === t;
        _.fn[e] = function(a) {
            return z(this, (function(e, a, i) {
                var o;
                if (m(e) ? o = e : 9 === e.nodeType && (o = e.defaultView), void 0 === i) return o ? o[t] : e[a];
                o ? o.scrollTo(n ? o.pageXOffset : i, n ? i : o.pageYOffset) : e[a] = i
            }), e, a, arguments.length)
        }
    })), _.each(["top", "left"], (function(e, t) {
        _.cssHooks[t] = ze(f.pixelPosition, (function(e, n) {
            if (n) return n = Re(e, t), Ie.test(n) ? _(e).position()[t] + "px" : n
        }))
    })), _.each({
        Height: "height",
        Width: "width"
    }, (function(e, t) {
        _.each({
            padding: "inner" + e,
            content: t,
            "": "outer" + e
        }, (function(n, a) {
            _.fn[a] = function(i, o) {
                var r = arguments.length && (n || "boolean" != typeof i),
                    s = n || (!0 === i || !0 === o ? "margin" : "border");
                return z(this, (function(t, n, i) {
                    var o;
                    return m(t) ? 0 === a.indexOf("outer") ? t["inner" + e] : t.document.documentElement["client" + e] : 9 === t.nodeType ? (o = t.documentElement, Math.max(t.body["scroll" + e], o["scroll" + e], t.body["offset" + e], o["offset" + e], o["client" + e])) : void 0 === i ? _.css(t, n, s) : _.style(t, n, i, s)
                }), t, r ? i : void 0, r)
            }
        }))
    })), _.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], (function(e, t) {
        _.fn[t] = function(e) {
            return this.on(t, e)
        }
    })), _.fn.extend({
        bind: function(e, t, n) {
            return this.on(e, null, t, n)
        },
        unbind: function(e, t) {
            return this.off(e, null, t)
        },
        delegate: function(e, t, n, a) {
            return this.on(t, e, n, a)
        },
        undelegate: function(e, t, n) {
            return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n)
        },
        hover: function(e, t) {
            return this.mouseenter(e).mouseleave(t || e)
        }
    }), _.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), (function(e, t) {
        _.fn[t] = function(e, n) {
            return 0 < arguments.length ? this.on(t, null, e, n) : this.trigger(t)
        }
    }));
    var Jt = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
    _.proxy = function(e, t) {
        var n, a, o;
        if ("string" == typeof t && (n = e[t], t = e, e = n), h(e)) return a = i.call(arguments, 2), (o = function() {
            return e.apply(t || this, a.concat(i.call(arguments)))
        }).guid = e.guid = e.guid || _.guid++, o
    }, _.holdReady = function(e) {
        e ? _.readyWait++ : _.ready(!0)
    }, _.isArray = Array.isArray, _.parseJSON = JSON.parse, _.nodeName = k, _.isFunction = h, _.isWindow = m, _.camelCase = Q, _.type = b, _.now = Date.now, _.isNumeric = function(e) {
        var t = _.type(e);
        return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e))
    }, _.trim = function(e) {
        return null == e ? "" : (e + "").replace(Jt, "")
    }, "function" == typeof define && define.amd && define("jquery", [], (function() {
        return _
    }));
    var Gt = e.jQuery,
        Xt = e.$;
    return _.noConflict = function(t) {
        return e.$ === _ && (e.$ = Xt), t && e.jQuery === _ && (e.jQuery = Gt), _
    }, void 0 === t && (e.jQuery = e.$ = _), _
})),
function(e) {
    e.ajaX = e.ajax, e.fn.is_theme_jquery = !0
}(jQuery), window.jQueryTheme = jQuery.noConflict(),
    function($) {
        "use strict";

        function Global() {
            this.settings = {
                set_offset_with_fixed_body: {
                    padding: [".header__content--sticky", ".header--transparent", ".fixed-sidebar", ".footbar", "#admin_bar_iframe", "#preview-bar-iframe"],
                    margin: [".footer--fixed"]
                }
            }, this.dom = {
                $icons: $("#theme-icons")
            }, window.$window = $(window), window.$document = $(document), window.$html = $(html), window.$body = $html.find("body"), jQuery.cookie = () => {}, theme.AssetsLoader.onPageLoaded((function() {
                $(".js-slider-tracking").one("init", (function() {
                    window.dispatchEvent(new CustomEvent("slider-initialized", {
                        detail: {
                            slider: $(this)[0]
                        }
                    }))
                }))
            }))
        }

        function floatToString(e, t) {
            var n = e.toFixed(t).toString();
            return n.match(/^\.\d+/) ? "0" + n : n
        }

        function attributeToString(e) {
            return "string" != typeof e && ("undefined" === (e += "") && (e = "")), jQuery.trim(e)
        }

        function Position() {
            this.settings = {
                name: "data-js-position-name",
                desktop: "data-js-position-desktop",
                mobile: "data-js-position-mobile",
                all: "data-js-position-all"
            }, this.selectors = {
                elements: ".js-position"
            }, this.load()
        }
        Global.prototype = $.extend({}, Global.prototype, {
            load: function() {},
            bodyHasScroll: function(e) {
                var t = document,
                    n = t.documentElement,
                    a = t.body,
                    i = "client" + e,
                    o = "scroll" + e;
                return /CSS/.test(t.compatMode) ? n[i] < n[o] : a[i] < a[o]
            },
            fixBody: function() {
                if (this.bodyHasScroll("Height")) {
                    $body.addClass("offset-scrollHOLD offset-scroll-padding fixed-elem");
                    for (var e = 0; e < this.settings.set_offset_with_fixed_body.padding.length; e++) $(this.settings.set_offset_with_fixed_body.padding[e]).addClass("offset-scroll-padding fixed-elem");
                    for (e = 0; e < this.settings.set_offset_with_fixed_body.margin.length; e++) $(this.settings.set_offset_with_fixed_body.margin[e]).addClass("offset-scroll-margin fixed-elem")
                }
                this._fixed_scroll_top = pageYOffset, $body.css({
                    top: -1 * pageYOffset
                }), $body.addClass("overflow-hiddenHOLD position-fixed left-0 w-100")
            },
            unfixBody: function() {
                $body.removeClass("offset-scrollHOLD overflow-hiddenHOLD offset-scroll-padding fixed-elem position-fixed left-0 w-100"), $body.add($html).scrollTop(this._fixed_scroll_top), this._fixed_scroll_top = null, $body.css({
                    top: ""
                });
                for (var e = 0; e < this.settings.set_offset_with_fixed_body.padding.length; e++) $(this.settings.set_offset_with_fixed_body.padding[e]).removeClass("offset-scroll-padding fixed-elem");
                for (e = 0; e < this.settings.set_offset_with_fixed_body.margin.length; e++) $(this.settings.set_offset_with_fixed_body.margin[e]).removeClass("offset-scroll-margin fixed-elem")
            },
            responsiveHandler: function(e) {
                var t, n = e.namespace ? e.namespace : ".widthHandler",
                    a = e.is_mobile_prop || "is_mobile",
                    i = e.is_desktop_prop || "is_desktop";

                function o() {
                    $.each(e.events, (function(t) {
                        $.each(t.split(" "), (function(t, a) {
                            $(e.element).unbind(a + n)
                        }))
                    })), e.was_added_events && e.onunbind_func && e.onunbind_func(), e.was_first_load = !1
                }

                function r() {
                    theme.current[a] !== t && (t = theme.current[a], e.on_desktop && theme.current[i] || e.on_mobile && theme.current[a] ? ($.each(e.events, (function(t, a) {
                        $.each(t.split(" "), (function(t, i) {
                            e.delegate ? $(e.element).on(i + n, e.delegate, a) : $(e.element).on(i + n, a)
                        })), e.onbindload && a()
                    })), e.was_added_events = !0, setTimeout((function() {
                        e.onbindtrigger && (e.was_first_load || ($.each(e.events, (function() {
                            $(e.element).trigger(e.onbindtrigger)
                        })), e.was_first_load = !0))
                    }), 0)) : o())
                }
                return $window.on("theme.resize.responsiveHandler" + n, (function() {
                    r()
                })), r(), {
                    unbind: function() {
                        $window.unbind("theme.resize.responsiveHandler" + n), o()
                    }
                }
            },
            getIcon: function(e, t) {
                var n = this.dom.$icons.find(".icon-theme-" + e);
                return t ? n.parent().html() : n.clone()
            }
        }), theme.AssetsLoader.onPageLoaded((function() {
            theme.Global = new Global
        })), window.slate = window.slate || {}, slate.rte = {
            wrapIframe: function(e) {
                var t = void 0 === e.iframeWrapperClass ? "" : e.iframeWrapperClass;
                e.$iframes.each((function() {
                    $(this).wrap('<div class="' + t + '"></div>'), this.src = this.src
                }))
            }
        }, theme.AssetsLoader.onPageLoaded((function() {
            slate.rte.wrapIframe({
                $iframes: $('.rte iframe[src*="youtube.com/embed"]:not(.not-responsive),.rte iframe[src*="player.vimeo"]:not(.not-responsive)'),
                iframeWrapperClass: "rte__video-wrapper"
            })
        })), void 0 === window.Shopify && (window.Shopify = {}), Shopify.money_format = "${{amount}}", Shopify.onError = function(e, t) {
            var n = eval("(" + e.responseText + ")");
            n.message ? alert(n.message + "(" + n.status + "): " + n.description) : alert("Error : " + Shopify.fullMessagesFromErrors(n).join("; ") + ".")
        }, Shopify.fullMessagesFromErrors = function(e) {
            var t = [];
            return jQuery.each(e, (function(e, n) {
                jQuery.each(n, (function(n, a) {
                    t.push(e + " " + a)
                }))
            })), t
        }, Shopify.onCartUpdate = function(e) {
            alert("There are now " + e.item_count + " items in the cart.")
        }, Shopify.onCartShippingRatesUpdate = function(e, t) {
            var n = "";
            t.zip && (n += t.zip + ", "), t.province && (n += t.province + ", "), n += t.country, alert("There are " + e.length + " shipping rates available for " + n + ", starting at " + Shopify.formatMoney(e[0].price) + ".")
        }, Shopify.onItemAdded = function(e) {
            alert(e.title + " was added to your shopping cart.")
        }, Shopify.onProduct = function(e) {
            alert("Received everything we ever wanted to know about " + e.title)
        }, Shopify.formatMoney = function(e, t) {
            function n(e, t) {
                return void 0 === e ? t : e
            }

            function a(e, t, a, i) {
                if (t = n(t, 2), a = n(a, ","), i = n(i, "."), isNaN(e) || null == e) return 0;
                var o = (e = (e / 100).toFixed(t)).split(".");
                return o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a) + (o[1] ? i + o[1] : "")
            }
            "string" == typeof e && (e = e.replace(".", ""));
            var i = "",
                o = /\{\{\s*(\w+)\s*\}\}/,
                r = t || this.money_format;
            switch (r.match(o)[1]) {
                case "amount":
                    i = a(e, 2);
                    break;
                case "amount_no_decimals":
                    i = a(e, 0);
                    break;
                case "amount_with_comma_separator":
                    i = a(e, 2, ".", ",");
                    break;
                case "amount_no_decimals_with_comma_separator":
                    i = a(e, 0, ".", ",")
            }
            return r.replace(o, i)
        }, Shopify.resizeImage = function(e, t) {
            try {
                if ("original" == t) return e;
                var n = e.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);
                return n[1] + "_" + t + "." + n[2]
            } catch (t) {
                return e
            }
        }, Shopify.addItem = function(e, t, n) {
            var a = {
                type: "POST",
                url: "/cart/add.js",
                data: "quantity=" + (t = t || 1) + "&id=" + e,
                dataType: "json",
                success: function(e) {
                    "function" == typeof n ? n(e) : Shopify.onItemAdded(e)
                },
                error: function(e, t) {
                    Shopify.onError(e, t)
                }
            };
            jQuery.ajax(a)
        }, Shopify.addItemFromForm = function(e, t) {
            var n = {
                type: "POST",
                url: "/cart/add.js",
                data: jQuery("#" + e).serialize(),
                dataType: "json",
                success: function(e) {
                    "function" == typeof t ? t(e) : Shopify.onItemAdded(e)
                },
                error: function(e, t) {
                    Shopify.onError(e, t)
                }
            };
            jQuery.ajax(n)
        }, Shopify.getCart = function(e) {
            jQuery.getJSON("/cart.js", (function(t, n) {
                "function" == typeof e ? e(t) : Shopify.onCartUpdate(t)
            }))
        }, Shopify.pollForCartShippingRatesForDestination = function(e, t, n) {
            n = n || Shopify.onError;
            var a = function() {
                jQuery.ajax("/cart/async_shipping_rates", {
                    dataType: "json",
                    success: function(n, i, o) {
                        200 === o.status ? "function" == typeof t ? t(n.shipping_rates, e) : Shopify.onCartShippingRatesUpdate(n.shipping_rates, e) : setTimeout(a, 500)
                    },
                    error: n
                })
            };
            return a
        }, Shopify.getCartShippingRatesForDestination = function(e, t, n) {
            n = n || Shopify.onError;
            var a = {
                type: "POST",
                url: "/cart/prepare_shipping_rates",
                data: Shopify.param({
                    shipping_address: e
                }),
                success: Shopify.pollForCartShippingRatesForDestination(e, t, n),
                error: n
            };
            jQuery.ajax(a)
        }, Shopify.getProduct = function(e, t) {
            jQuery.getJSON("/products/" + e + ".js", (function(e, n) {
                "function" == typeof t ? t(e) : Shopify.onProduct(e)
            }))
        }, Shopify.changeItem = function(e, t, n) {
            var a = {
                type: "POST",
                url: "/cart/change.js",
                data: "quantity=" + t + "&id=" + e,
                dataType: "json",
                success: function(e) {
                    "function" == typeof n ? n(e) : Shopify.onCartUpdate(e)
                },
                error: function(e, t) {
                    Shopify.onError(e, t)
                }
            };
            jQuery.ajax(a)
        }, Shopify.removeItem = function(e, t) {
            var n = {
                type: "POST",
                url: "/cart/change.js",
                data: "quantity=0&id=" + e,
                dataType: "json",
                success: function(e) {
                    "function" == typeof t ? t(e) : Shopify.onCartUpdate(e)
                },
                error: function(e, t) {
                    Shopify.onError(e, t)
                }
            };
            jQuery.ajax(n)
        }, Shopify.clear = function(e) {
            var t = {
                type: "POST",
                url: "/cart/clear.js",
                data: "",
                dataType: "json",
                success: function(t) {
                    "function" == typeof e ? e(t) : Shopify.onCartUpdate(t)
                },
                error: function(e, t) {
                    Shopify.onError(e, t)
                }
            };
            jQuery.ajax(t)
        }, Shopify.updateCartFromForm = function(e, t) {
            var n = {
                type: "POST",
                url: "/cart/update.js",
                data: jQuery("#" + e).serialize(),
                dataType: "json",
                success: function(e) {
                    "function" == typeof t ? t(e) : Shopify.onCartUpdate(e)
                },
                error: function(e, t) {
                    Shopify.onError(e, t)
                }
            };
            jQuery.ajax(n)
        }, Shopify.updateCartAttributes = function(e, t) {
            var n = "";
            jQuery.isArray(e) ? jQuery.each(e, (function(e, t) {
                var a = attributeToString(t.key);
                "" !== a && (n += "attributes[" + a + "]=" + attributeToString(t.value) + "&")
            })) : "object" == typeof e && null !== e && jQuery.each(e, (function(e, t) {
                n += "attributes[" + attributeToString(e) + "]=" + attributeToString(t) + "&"
            }));
            var a = {
                type: "POST",
                url: "/cart/update.js",
                data: n,
                dataType: "json",
                success: function(e) {
                    "function" == typeof t ? t(e) : Shopify.onCartUpdate(e)
                },
                error: function(e, t) {
                    Shopify.onError(e, t)
                }
            };
            jQuery.ajax(a)
        }, Shopify.updateCartNote = function(e, t) {
            var n = {
                type: "POST",
                url: "/cart/update.js",
                data: "note=" + attributeToString(e),
                dataType: "json",
                success: function(e) {
                    "function" == typeof t ? t(e) : Shopify.onCartUpdate(e)
                },
                error: function(e, t) {
                    Shopify.onError(e, t)
                }
            };
            jQuery.ajax(n)
        }, jQuery.fn.jquery >= "1.4" ? Shopify.param = jQuery.param : (Shopify.param = function(e) {
            var t = [],
                n = function(e, n) {
                    n = jQuery.isFunction(n) ? n() : n, t[t.length] = encodeURIComponent(e) + "=" + encodeURIComponent(n)
                };
            if (jQuery.isArray(e) || e.jquery) jQuery.each(e, (function() {
                n(this.name, this.value)
            }));
            else
                for (var a in e) Shopify.buildParams(a, e[a], n);
            return t.join("&").replace(/%20/g, "+")
        }, Shopify.buildParams = function(e, t, n) {
            jQuery.isArray(t) && t.length ? jQuery.each(t, (function(t, a) {
                rbracket.test(e) ? n(e, a) : Shopify.buildParams(e + "[" + ("object" == typeof a || jQuery.isArray(a) ? t : "") + "]", a, n)
            })) : null != t && "object" == typeof t ? Shopify.isEmptyObject(t) ? n(e, "") : jQuery.each(t, (function(t, a) {
                Shopify.buildParams(e + "[" + t + "]", a, n)
            })) : n(e, t)
        }, Shopify.isEmptyObject = function(e) {
            for (var t in e) return !1;
            return !0
        }), Shopify && "object" == typeof Shopify && (Shopify.addValueToString = function(e, t) {
            return $.each(t, (function(t) {
                e = e.replace("{{ " + t + " }}", this)
            })), e
        }, Shopify.handleize = function(e) {
            return e.replace(/[-+!"#$€₹%&'* ,/:;<=>?@[\\\]_`{|}~()°^]+/g, "").toLowerCase().replace(/ς/, "σ")
        }, Shopify.handleizeArray = function(e) {
            for (var t = [], n = 0; n < e.length; n++) t[n] = Shopify.handleize(e[n]);
            return t
        }, Shopify.formatMoney = function(e, t) {
            "string" == typeof e && (e = e.replace(".", ""));
            var n = "",
                a = /\{\{\s*(\w+)\s*\}\}/,
                i = t || "${{amount}}";

            function o(e, t, n, a) {
                if (n = n || ",", a = a || ".", isNaN(e) || null === e) return 0;
                var i = (e = (e / 100).toFixed(t)).split(".");
                return i[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + n) + (i[1] ? a + i[1] : "")
            }
            switch (i.match(a)[1]) {
                case "amount":
                    n = o(e, 2);
                    break;
                case "amount_no_decimals":
                    n = o(e, 0);
                    break;
                case "amount_with_comma_separator":
                    n = o(e, 2, ".", ",");
                    break;
                case "amount_no_decimals_with_comma_separator":
                    n = o(e, 0, ".", ",");
                    break;
                case "amount_no_decimals_with_space_separator":
                    n = o(e, 0, " ");
                    break;
                case "amount_with_apostrophe_separator":
                    n = o(e, 2, "'")
            }
            return i.replace(a, n)
        }), window.theme = window.theme || {}, Position.prototype = $.extend({}, Position.prototype, {
            load: function() {
                var e, t = this;

                function n() {
                    e !== theme.current.is_desktop && (t.update(), e = theme.current.is_desktop)
                }
                $window.on("theme.resize.position", (function() {
                    n()
                })), n();
                var a = $(this.selectors.elements).filter("[data-js-position-onload]");
                this.append(a, this.settings.all)
            },
            update: function(e) {
                var t = e ? $("[" + this.settings.name + '="' + e + '"]') : $(this.selectors.elements).not("[data-js-position-onload]"),
                    n = theme.current.is_desktop ? this.settings.desktop : this.settings.mobile;
                this.append(t, n)
            },
            append: function(e, t) {
                var n = this;
                e.each((function() {
                    var e = $(this),
                        a = e.attr(n.settings.name),
                        i = $("[" + t + '="' + a + '"]');
                    i.length && !$.contains(i[0], e[0]) && (i.find("[" + n.settings.name + '="' + a + '"]').length ? e.remove() : e.appendTo(i))
                }))
            }
        }), theme.AssetsLoader.onPageLoaded((function() {
            theme.Position = new Position
        }));
        class Cookie {
            constructor() {
                jQuery.cookie = (e, t, n) => t ? this.set(e, t, n) : this.get(e)
            }
            get(e) {
                let t = document.cookie.match(new RegExp("(?:^|; )" + e.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)"));
                return t ? decodeURIComponent(t[1]) : void 0
            }
            set(e, t, n = {}) {
                (n = Object.assign(n, {
                    path: "/"
                })).expires instanceof Date && (n.expires = n.expires.toUTCString());
                let a = encodeURIComponent(e) + "=" + encodeURIComponent(t);
                for (let e in n) {
                    a += "; " + e;
                    let t = n[e];
                    !0 !== t && (a += "=" + t)
                }
                document.cookie = a
            }
            deleteCookie(e) {
                set(e, "", {
                    "max-age": -1
                })
            }
        }
        theme.AssetsLoader.onPageLoaded((function() {
            theme.Cookie = new Cookie
        }));
        class Countdown extends HTMLElement {
            constructor() {
                super(), setTimeout((() => {
                    this.displayType = this.classList.contains("countdown--type-02") ? 2 : 1, this.finalDate = new Date(this.dataset.date), this.start()
                }), 0)
            }
            start() {
                this.checkOverdueDate() && (this.display(), this.inrerval = setInterval((() => this.display()), 1e3))
            }
            display() {
                this.render(this.getRemainingTime())
            }
            checkOverdueDate() {
                if (this.getTotal() < 0) {
                    if (theme.isThemeDemo) {
                        const e = new Date;
                        return e.setDate(Math.max(e.getDate() + 3, this.finalDate.getDate())), e.setHours(this.finalDate.getHours()), e.setMinutes(this.finalDate.getMinutes() + 20), e.setSeconds(this.finalDate.getSeconds() - 1), this.finalDate = e, !0
                    }
                    return this.inrerval && clearInterval(this.inrerval), !1
                }
                return !0
            }
            getTotal() {
                return Date.parse(this.finalDate) - Date.parse(new Date)
            }
            getRemainingTime() {
                if (!this.checkOverdueDate()) return !1;
                const e = this.getTotal(),
                    t = Math.floor(e / 1e3 % 60),
                    n = Math.floor(e / 1e3 / 60 % 60),
                    a = Math.floor(e / 36e5 % 24);
                return {
                    days: Math.floor(e / 864e5),
                    hours: a,
                    minutes: n,
                    seconds: t
                }
            }
            render(e) {
                if (!e) return void this.parentNode.classList.add("d-none-important");
                let t = "";
                t += this.buildSectionHTML(e.days, theme.strings.countdown.days), t += this.buildSectionHTML(e.hours, theme.strings.countdown.hours, e.days, !0), t += this.buildSectionHTML(e.minutes, theme.strings.countdown.minutes, e.hours, !0), t += this.buildSectionHTML(e.seconds, theme.strings.countdown.seconds, e.minutes, !0), this.innerHTML = t
            }
            buildSectionHTML(e, t, n) {
                if (!e && !n) return "";
                let a = e.toString();
                if (1 === this.displayType) return !e && n && (a = "0"), `<span class="countdown__section">\n                      <span class="countdown__time">${a}</span>\n                      <span class="countdown__postfix">${t}</span>\n                      </span>`;
                if (2 === this.displayType) {
                    a.length < 2 && (a = `0${e}`);
                    let n = '<span class="countdown__section"><span class="countdown__time">';
                    for (var i = 0; i < a.length; i++) n += `<span>${a.charAt(i)}</span>`;
                    return n += `</span>\n                      <span class="countdown__postfix">${t}</span>\n                      </span>`, n
                }
            }
            disconnectedCallback() {
                this.inrerval && clearInterval(this.inrerval)
            }
        }

        function dynamicCheckout() {
            this.selectors = {
                template_dynamic_checkout: ".template-dynamic-checkout",
                dynamic_checkout: ".js-dynamic-checkout"
            }
        }
        theme.AssetsLoader.onPageLoaded((function() {
            customElements.define("countdown-element", Countdown)
        })), dynamicCheckout.prototype = $.extend({}, dynamicCheckout.prototype, {
            load: function(e) {
                const t = this,
                    n = $(e || document),
                    a = n.find(this.selectors.dynamic_checkout);
                if ($body.on("change", "[data-js-dynamic-checkout-confirmation]", (function() {
                        t.dynamicCheckoutUpdate($(this))
                    })), a.length) return void(Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init());
                const i = n.find(this.selectors.template_dynamic_checkout);
                i.length && (i.replaceWith($(i[0].content).find("[data-js-product-button-dynamic-checkout]")), i.remove()), $("[data-js-dynamic-checkout-confirmation]").each((function() {
                    t.dynamicCheckoutUpdate($(this))
                }));
                const o = $(this.selectors.dynamic_checkout);
                o.length && (this.checkCheckoutLoad(o), $window.on("scroll.checkCheckoutLoad", (function() {
                    t.checkCheckoutLoad(o)
                })))
            },
            dynamicCheckoutUpdate: function(e) {
                e.parents(this.selectors.dynamic_checkout).find("[data-js-dynamic-checkout-button-wrapper]")[e.is(":checked") ? "removeClass" : "addClass"]("disabled")
            },
            checkCheckoutLoad: function(e) {
                e[0].getBoundingClientRect().top < window.innerHeight + 300 && ($window.unbind("scroll.checkCheckoutLoad"), Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init())
            }
        }), theme.AssetsLoader.onPageLoaded((function() {
            theme.dynamicCheckout = new dynamicCheckout
        }));
        class Preloader {
            constructor() {
                this.$preloader = $("#theme-loader .js-preloader")
            }
            set(e, t = {}) {
                if ((e = $(e)).length && !e.find("> .js-preloader").length) {
                    var n, a = this.$preloader.clone(),
                        i = a.find("[data-js-preloader-spinner]"),
                        o = i.find("img");
                    !1 === t.bg && a.find("[data-js-preloader-bg]").remove(), !1 === t.spinner && i.remove(), !0 === t.fixed && (i.addClass("fixed"), n = 100 * (e.innerWidth() / 2 + e[0].getBoundingClientRect().left) / theme.current.width, i.css({
                        left: n + "%"
                    })), t.delay && e.addClass("preloading-element--delay"), t.blur ? (e.addClass("preloading-element preloading-element--blur"), i.remove()) : (e.addClass("preloading-element"), e[0].preloadTimeout = o.one("load", (() => {
                        e.addClass("preloading-element--process")
                    })), o.attr("src", o.attr("data-src"))), e.append(a), t.blur && (e[0].preloadTimeout = setTimeout((() => {
                        e.addClass("preloading-element--process")
                    }), 10))
                }
            }
            unset(e) {
                (e = $(e)).length && (e[0].preloadInterval && (clearTimeout(e[0].preloadTimeout), e[0].preloadInterval = null), e.find("> .preloader").remove(), e.removeClass("preloading-element preloading-element--blur preloading-element--process preloading-element--delay"))
            }
        }

        function Popups() {
            this.selectors = {
                popup: ".js-popup",
                button: ".js-popup-button",
                button_close: "[data-js-popup-close]",
                bg: "[data-js-popup-bg]"
            }, this.load()
        }

        function PopupQuickView() {
            this.settings = {
                popup_name: "quick-view",
                popup_size_guide_name: "size-guide"
            }, this.load()
        }

        function StoreListsEngine(e, t) {
            this.namespace = e, this.selectors = {
                button: ".js-store-lists-add-" + e,
                button_remove: ".js-store-lists-remove-" + e,
                button_clear: ".js-store-lists-clear-" + e,
                has_items: "[data-js-store-lists-has-items-" + e + "]",
                dhas_items: "[data-js-store-lists-dhas-items-" + e + "]"
            }, theme.customer ? (this.current_storage = e + "-customer-" + theme.customer_id, this.app_obj = {
                namespace: e,
                customerid: theme.customer_id,
                shop: theme.permanent_domain,
                domain: theme.host,
                iid: theme.lists_app.iid
            }) : this.current_storage = e + "-guest", this.load(t)
        }

        function StoreListsEnginePopup(e) {
            this.namespace = e, this.load()
        }

        function StoreLists() {
            this.namespaces = ["wishlist", "compare"], this.load()
        }

        function ProductOptions() {
            this.selectors = {
                options: ".js-product-options",
                options_attr: "[data-js-product-options]"
            }, this.afterChange = [], this.load()
        }
        theme.AssetsLoader.onPageLoaded((function() {
            theme.Preloader = new Preloader
        })), Popups.prototype = $.extend({}, Popups.prototype, {
            load: function() {
                var e = $(this.selectors.popup);
                if (e.length) {
                    var t = this;
                    $body.on("click", '[data-js-popup-button="message"]', (function() {
                        var e = $(this).parents("[data-js-product]"),
                            t = e.attr("data-json-product"),
                            n = +e.attr("data-product-variant-id");
                        t && (t = JSON.parse(t), $.each(t.variants, (function() {
                            if (this.id === n) return $("#ContactFormProductUrl").attr("value", theme.domain + "/products/" + t.handle + "?variant=" + n), $("#ContactFormProductSKU").attr("value", this.sku ? this.sku : "Empty"), !1
                        })))
                    })), $body.on("click", this.selectors.button, (function(e) {
                        var n = $(this),
                            a = n.attr("data-js-popup-button");
                        if (t.callByName(a, n)) return e.preventDefault(), !1
                    })), e.on("click", this.selectors.button_close, (function(e) {
                        var n = $(this),
                            a = n.parents("[data-js-popup-name]").attr("data-js-popup-name");
                        return t.closeByName(a, n), e.preventDefault(), !1
                    })), e.on("click", "[data-js-popup-name]:not([data-disable-bg-click])", (function(e) {
                        var n = $(e.target);
                        if (n[0].hasAttribute("data-js-popup-name")) {
                            var a = n.attr("data-js-popup-name");
                            t.closeByName(a, n)
                        }
                    })), setTimeout((function() {
                        e.find('[data-js-auto-call="true"]').each((function() {
                            t.callByName($(this).attr("data-js-popup-name"))
                        }))
                    }), 0)
                }
            },
            loadDynamicContent: function(e, t) {
                if (!t) return;
                const n = t.attr("data-js-popup-dynamic-id");
                if (!n) return;
                this.getByName(e).find("[data-js-popup-dynamic-insert]").html($(`[data-js-popup-dynamic-content="${n}"]`).html())
            },
            getByName: function(e) {
                return $(this.selectors.popup).find('[data-js-popup-name="' + e + '"]')
            },
            callByName: function(e, t) {
                var n = this,
                    a = $(this.selectors.popup),
                    i = $(this.selectors.bg),
                    o = a.find('[data-js-popup-name="' + e + '"]'),
                    r = void 0 !== o.attr("data-js-popup-ajax");

                function s() {
                    a.scrollTop(0), $body.addClass("popup-opened"), i.one("transitionend", (function() {
                        o.add(i).removeClass("animate"), o.trigger(e + ".call.after", [o, t || null])
                    })), o.add(i).addClass("animate"), setTimeout((function() {
                        o.add(i).addClass("visible"), "0s" === i.css("transition-duration") && i.trigger("transitionend")
                    }), 0), o[0].hasAttribute("data-js-popup-mobile-only") && $window.on("theme.changed.breakpoint.popups", (function() {
                        theme.current.is_mobile || n.closeByName(e)
                    }))
                }
                return !!o.length && ((!theme.current.is_desktop || !o[0].hasAttribute("data-js-popup-mobile-only")) && (theme.tooltips_enable && t && $(".tippy-popper").addClass("d-none-important"), i.unbind("transitionend"), o.trigger(e + ".call.before", [o, t || null]), this.loadDynamicContent(e, t), a.addClass("active"), a.find("[data-js-popup-name]").removeClass("show visible"), a.add(o).addClass("show"), theme.Global.fixBody(), r ? (o.addClass("is-process-loading"), theme.Preloader.set(a, {
                    fixed: !0,
                    delay: !0
                }), o.on("contentloaded", (function() {
                    o.removeClass("is-process-loading"), s(), theme.Preloader.unset(a)
                }))) : s(), $body.on("keyup.popups", (function(e) {
                    27 !== e.keyCode || $body.hasClass("product-gallery-fullscreen") || n.closeAll()
                })), a.attr("tabindex", 10).focus(), o.trigger(e + ".call.visible", [o, t || null]), !0))
            },
            closeByName: function(e, t, n) {
                var a = $(this.selectors.popup),
                    i = $(this.selectors.bg),
                    o = a.find('[data-js-popup-name="' + e + '"]');
                i.css("transition-duration");
                return o.length ? ($body.removeClass("popup-opened"), o.unbind("contentloaded").removeClass("is-process-loading"), i.unbind("transitionend"), $body.unbind("keyup.popups"), $window.unbind("theme.changed.breakpoint.popups"), o.trigger(e + ".close.before", [o, t || null]), theme.Preloader.unset(a), i.one("transitionend", (function() {
                    a.add(o).removeClass("show"), o.add(i).removeClass("animate"), theme.Global.unfixBody(), a.removeClass("active"), n && n(), a.attr("tabindex", 0), o.trigger(e + ".close.after", [o, t || null])
                })), o.add(i).addClass("animate"), i.hasClass("visible") && "0s" !== i.css("transition-duration") || i.trigger("transitionend"), o.add(i).removeClass("visible"), theme.tooltips_enable && t && $(".tippy-popper").removeClass("d-none-important"), !0) : (n && n(), !1)
            },
            closeAll: function() {
                var e = this,
                    t = $(this.selectors.popup + ".active").find("[data-js-popup-name]").filter(".show, .is-process-loading");
                return !!t.length && (t.each((function() {
                    e.closeByName(t.attr("data-js-popup-name"))
                })), !0)
            },
            addHandler: function(e, t, n, a) {
                a = a || "on", $body[a](e + "." + t, '[data-js-popup-name="' + e + '"]', (function(e, t, a) {
                    n(t, a)
                }))
            },
            removeHandler: function(e, t) {
                $body.unbind(e + "." + t)
            }
        }), theme.AssetsLoader.onPageLoaded((function() {
            theme.Popups = new Popups
        })), PopupQuickView.prototype = $.extend({}, PopupQuickView.prototype, {
            load: function() {
                var e = this,
                    t = [
                        ["styles", "plugin_slick"],
                        ["scripts", "plugin_slick"],
                        ["scripts", "product_page"]
                    ];
                theme.product.enable_sticky_gallery && t.push(["scripts", "sticky_sidebar"]), "2" != theme.product.page_layout && "3" != theme.product.page_layout && "4" != theme.product.page_layout || t.unshift(["scripts", "tabs"]), theme.Popups.addHandler(this.settings.popup_name, "call.visible", (function(n, a) {
                    var i = n.find("[data-js-quick-view]"),
                        o = a.parents("[data-js-product]");
                    i.html(""), theme.AssetsLoader.loadManually(t, (function() {
                        e.getProduct(o, (function(t) {
                            e.insertContent(i, t);
                            const a = i.find("product-gallery");
                            theme.LazyImage.update(), a.length && a[0].load(), theme.product.enable_sticky_gallery && theme.StickySidebar && theme.StickySidebar.reload(), n.trigger("contentloaded")
                        }))
                    }))
                })), theme.Popups.addHandler(this.settings.popup_name, "call.after", (function(t) {
                    theme.MultiCurrency && theme.MultiCurrency.update(), theme.Tooltip && theme.Tooltip.init({
                        appendTo: t[0]
                    }), t.find('[data-js-popup-button="size-guide"]').one("click.product-size-guide", (function() {
                        var n, a, i = theme.Popups.getByName(e.settings.popup_size_guide_name);
                        if (i.length && (n = t.find("[data-product-size-guide-content]"), a = i.find("[data-popup-size-guide-content]"), n.length)) {
                            a.children().addClass("d-none"), a.append(n.removeClass("d-none")), theme.Popups.addHandler(e.settings.popup_size_guide_name, "close.after", (function() {
                                (a = i.find("[data-popup-size-guide-content]")).find("[data-product-size-guide-content]").remove(), a.children().removeClass("d-none")
                            }), "one")
                        }
                    }))
                })), theme.Popups.addHandler(this.settings.popup_name, "close.after", (function(t) {
                    var n = t.find("[data-js-quick-view]");
                    e.ajax && e.ajax.abort(), n.html(""), theme.product.enable_sticky_gallery && theme.StickySidebar && theme.StickySidebar.reload(), t.find('[data-js-popup-button="size-guide"]').unbind("click.product-size-guide")
                }))
            },
            getProduct: function(e, t) {
                this.ajax && this.ajax.abort();
                var n = e.attr("data-product-handle"),
                    a = "";
                e.get(0).hasAttribute("data-qv-check-change") && e.find("[data-property][data-disable-auto-select]").length || (a = "?variant=" + e.attr("data-product-variant-id")), n && (this.ajax = $.ajax({
                    type: "GET",
                    url: "https://" + window.location.hostname + "/products/" + n + a,
                    data: {
                        view: "quick-view"
                    },
                    dataType: "html",
                    success: function(e) {
                        t(e)
                    }
                }))
            },
            insertContent: function(e, t) {
                e.html(t)
            }
        }), theme.AssetsLoader.onPageLoaded((function() {
            theme.PopupQuickView = new PopupQuickView
        })), StoreListsEngine.prototype = $.extend({}, StoreListsEngine.prototype, {
            load: function(e) {
                var t = this;
                if (theme.customer) {
                    var n, a, i, o, r = localStorage.getItem(this.current_storage),
                        s = r ? JSON.parse(r) : [],
                        u = localStorage.getItem(this.namespace + "-guest"),
                        c = u ? JSON.parse(u) : [],
                        l = [],
                        d = function(e) {
                            var t = {},
                                n = [],
                                a = 0;
                            for (a = 0; a < e.length; a++) $.each(e[a], (function(e, n) {
                                t[e + ""] = n
                            }));
                            return $.each(t, (function(e, t) {
                                var a = {};
                                a[e] = t, n.push(a)
                            })), n
                        },
                        p = function() {
                            t.getCustomerList((function(e) {
                                200 === e.status && (a = d(s), e.items && e.items.length && (l = d(e.items)), i = d(a.concat(l)), o = JSON.stringify(i), n = JSON.stringify(l), o !== JSON.stringify(a) ? (localStorage.setItem(t.current_storage, o), t.setCustomerList(o)) : o !== n && (localStorage.setItem(t.current_storage, n), t.setCustomerList(n)), t.updateHeaderCount(), t.checkProductStatus(), localStorage.removeItem(t.namespace + "-guest"))
                            }))
                        };
                    c.length ? e({
                        trigger: function(e) {
                            e && (s = s.concat(c)), p()
                        },
                        info: {
                            namespace: t.namespace,
                            count: c.length
                        }
                    }) : p()
                } else this.checkProductStatus();

                function f(e, n, a) {
                    var i = "[data-js-store-lists-product-" + t.namespace + "]",
                        o = theme.Popups.getByName(t.namespace);
                    n && (i += '[data-product-handle="' + n + '"]'), a && (i += '[data-product-variant-id="' + a + '"]'), $(i).each((function() {
                        var e = $(this);
                        $(e.parent('[class*="col"]').length ? e.parent() : e).remove()
                    })), e && void 0 !== typeof e && e.length && e.remove(), o.hasClass("d-none-important") || theme.StoreLists.popups[t.namespace].update(o)
                }
                $body.on("click", this.selectors.button, (function(e) {
                    var n = $(this);
                    n.attr("disabled", "disabled");
                    var a = n.parents("[data-js-product]"),
                        i = a.attr("data-product-handle"),
                        o = +a.attr("data-product-variant-id");
                    return "added" === n.attr("data-button-status") ? t.removeItem(o, i, (function(e) {
                        n.removeAttr("data-button-status"), n.removeAttr("disabled")
                    })) : t.addItem(o, i, (function(e) {
                        n.attr("data-button-status", "added"), n.removeAttr("disabled")
                    })), e.preventDefault(), !1
                })), $body.on("click", this.selectors.button_remove, (function() {
                    var e = $(this).parents("[data-js-product]"),
                        n = e.attr("data-product-handle"),
                        a = +e.attr("data-product-variant-id");
                    t.removeItem(a, n, (function() {
                        f(e, n, a)
                    }))
                })), $body.on("click", this.selectors.button_clear, (function() {
                    t.clear((function() {
                        f()
                    }))
                }))
            },
            setCustomerList: function(e, t) {
                theme.customer && $.ajax({
                    type: "POST",
                    url: "https://" + theme.lists_app.url + "/api/massadd",
                    data: $.extend({}, this.app_obj, {
                        purge: "yes",
                        items: e
                    }),
                    cache: !1,
                    success: function(e) {
                        t && t(e)
                    }
                })
            },
            getCustomerList: function(e) {
                theme.customer && $.ajax({
                    type: "POST",
                    url: "https://" + theme.lists_app.url + "/api/getlist",
                    data: this.app_obj,
                    cache: !1,
                    success: function(t) {
                        e && e(t)
                    }
                })
            },
            addCustomerItem: function(e, t, n) {
                theme.customer && $.ajax({
                    type: "POST",
                    url: "https://" + theme.lists_app.url + "/api/add",
                    data: $.extend({}, this.app_obj, {
                        key: e,
                        value: t
                    }),
                    cache: !1,
                    success: function(e) {
                        n && n(e)
                    }
                })
            },
            removeCustomerItem: function(e, t) {
                theme.customer && $.ajax({
                    type: "POST",
                    url: "https://" + theme.lists_app.url + "/api/delete",
                    data: $.extend({}, this.app_obj, {
                        key: e,
                        _method: "DELETE"
                    }),
                    cache: !1,
                    success: function(e) {
                        t && t(e)
                    }
                })
            },
            clearCustomerItem: function(e) {
                theme.customer && $.ajax({
                    type: "POST",
                    url: "https://" + theme.lists_app.url + "/api/massdelete",
                    data: $.extend({}, this.app_obj, {
                        _method: "DELETE"
                    }),
                    cache: !1,
                    success: function(t) {
                        e && e(t)
                    }
                })
            },
            addItem: function(e, t, n) {
                var a = localStorage.getItem(this.current_storage),
                    i = a ? JSON.parse(a) : [],
                    o = {};
                o[e] = t, i.push(o), localStorage.setItem(this.current_storage, JSON.stringify(i)), this.checkProductStatus(), this.updateHeaderCount(), this.addCustomerItem(e, t), n && n()
            },
            removeItem: function(e, t, n) {
                var a = localStorage.getItem(this.current_storage),
                    i = a ? JSON.parse(a) : [];
                $.each(i, (function(n) {
                    return e && this[e] && this[e] === t ? (i.splice(n, 1), !1) : e || this[Object.keys(this)[0]] !== t ? void 0 : (i.splice(n, 1), !1)
                })), localStorage.setItem(this.current_storage, JSON.stringify(i)), this.checkProductStatus(), $(this.selectors.has_items)[i.length > 0 ? "removeClass" : "addClass"]("d-none-important"), $(this.selectors.dhas_items)[i.length > 0 ? "addClass" : "removeClass"]("d-none-important"), this.updateHeaderCount(), this.removeCustomerItem(e), n && n()
            },
            clear: function(e) {
                localStorage.removeItem(this.current_storage), this.checkProductStatus(), $(this.selectors.has_items).addClass("d-none-important"), $(this.selectors.dhas_items).removeClass("d-none-important"), this.updateHeaderCount(), this.clearCustomerItem(), e && e()
            },
            checkProductStatus: function(e) {
                const t = $(e || "[data-js-product]");
                var n = localStorage.getItem(this.current_storage),
                    a = n ? JSON.parse(n) : [],
                    i = $();
                $.each(a, (function() {
                    $.each(this, (function(e, n) {
                        var a = t.filter('[data-product-handle="' + n + '"][data-product-variant-id="' + e + '"]');
                        a.length && (i = i.add(a))
                    }))
                })), t.not(i).find(this.selectors.button).removeAttr("data-button-status"), i.find(this.selectors.button).attr("data-button-status", "added")
            },
            updateHeaderCount: function(e) {
                var t = localStorage.getItem(this.current_storage),
                    n = t ? JSON.parse(t).length : 0;
                $("[data-js-" + this.namespace + "-count]").attr("data-js-" + this.namespace + "-count", n).html(n), e && e()
            }
        }), StoreListsEnginePopup.prototype = $.extend({}, StoreListsEnginePopup.prototype, {
            load: function() {
                var e = this;
                theme.Popups.addHandler(this.namespace, "call.visible", (function(t) {
                    e.update(t, (function() {
                        t.trigger("contentloaded")
                    }))
                })), theme.Popups.addHandler(this.namespace + "-full", "call.visible", (function(t) {
                    e.updateFull(t, (function() {
                        t.trigger("contentloaded")
                    }))
                }))
            },
            _resultToHTML: function(e, t, n) {
                for (var a = $($("#template-" + this.namespace + "-ajax")[0].content), i = $(document.createDocumentFragment()), o = 0; o < t.params.length; o++) $.each(t.params[o], (function(e, n) {
                    var o = null,
                        r = null;
                    if ($.each(t.products, (function() {
                            this.handle === n && (o = this)
                        })), o) {
                        $.each(o.variants, (function() {
                            if (+this.id == +e) return r = this, !1
                        })), r || (r = o.variants[0]);
                        var s = r.featured_image ? r.featured_image.src : o.featured_image,
                            u = a.clone(),
                            c = u.find(".product-store-lists"),
                            l = u.find(".product-store-lists__image img"),
                            d = u.find(".product-store-lists__title a"),
                            p = u.find(".product-store-lists__variant"),
                            f = u.find(".product-store-lists__price .price"),
                            h = u.find("a").not(".product-store-lists__remove");
                        c.attr("data-product-variant-id", e), c.attr("data-product-handle", n), h.attr("href", "/products/" + n + "?variant=" + e), d.html(o.title), l.attr("srcset", Shopify.resizeImage(s, "400x") + " 1x, " + Shopify.resizeImage(s, "800x") + " 2x, " + Shopify.resizeImage(s, "1200x") + " 3x"), "Default Title" !== r.title && p.html(r.title).removeClass("d-none-important"), theme.ProductPrice.insert(f, r.price, r.compare_at_price), i.append(u)
                    }
                }));
                e.html(""), e.append(i), n && n()
            },
            _getProducts: function(e, t) {
                var n, a = this,
                    i = [],
                    o = [],
                    r = 0;
                for (this.xhr && this.xhr.abort(); r < e.length; r++) $.each(e[r], (function() {
                    i.push(this)
                }));
                r = 0, n = Math.max(1, Math.ceil(i.length / 20)),
                    function r(s) {
                        var u = i.slice(20 * s, 20 * (s + 1));
                        a.xhr = $.ajax({
                            type: "GET",
                            url: "/collections/all",
                            cache: !1,
                            data: {
                                view: "products_by_handle",
                                constraint: u.join("+")
                            },
                            dataType: "html",
                            success: function(a) {
                                $.each(JSON.parse(a), (function() {
                                    o.push(this)
                                })), ++s < n ? r(s) : t({
                                    params: e,
                                    products: o
                                })
                            }
                        })
                    }(r)
            },
            update: function(e, t) {
                var n = this,
                    a = localStorage.getItem(theme.StoreLists.lists[this.namespace].current_storage),
                    i = a ? JSON.parse(a) : [],
                    o = e.find(".popup-" + this.namespace + "__content"),
                    r = e.find(".popup-" + this.namespace + "__empty"),
                    s = e.find(".popup-" + this.namespace + "__items");
                if (e.find("[data-js-popup-" + this.namespace + "-count]").html(theme.strings.general.popups[this.namespace].count.replace("{{ count }}", i.length)), o[i.length > 0 ? "removeClass" : "addClass"]("d-none-important"), r[i.length > 0 ? "addClass" : "removeClass"]("d-none-important"), i.length > 0) this._getProducts(i, (function(e) {
                    n._resultToHTML(s, e, t), theme.MultiCurrency && theme.MultiCurrency.update()
                }));
                else s.html(""), t && t()
            },
            updateFull: function(e, t) {
                var n = e.find(".popup-" + this.namespace + "-full__content");
                n.html("");
                var a = {
                    type: "GET",
                    data: {
                        view: this.namespace
                    },
                    cache: !1,
                    success: function(e) {
                        n.html(e), theme.LazyImage.update(), theme.MultiCurrency && theme.MultiCurrency.update(), t && t()
                    }
                };
                if (theme.customer) $.extend(a, {
                    url: "/cart"
                });
                else {
                    for (var i = localStorage.getItem(theme.StoreLists.lists[this.namespace].current_storage), o = i ? JSON.parse(i) : [], r = [], s = 0; s < o.length; s++) $.each(o[s], (function(e, t) {
                        r.push(t + "=" + e)
                    }));
                    r.join("+"), $.extend(!0, a, {
                        url: "/collections/all",
                        data: {
                            constraint: r
                        }
                    })
                }
                $.ajax(a)
            }
        }), StoreLists.prototype = $.extend({}, StoreLists.prototype, {
            lists: {},
            popups: {},
            load: function() {
                for (var e = [], t = 0; t < this.namespaces.length; t++) this.lists[this.namespaces[t]] = new StoreListsEngine(this.namespaces[t], (function(t) {
                    e.push(t)
                })), this.popups[this.namespaces[t]] = new StoreListsEnginePopup(this.namespaces[t]);
                if (e.length)
                    for (t = 0; t < e.length; t++) e[t].trigger(!0)
            },
            checkProductStatus: function() {
                $.each(this.lists, (function() {
                    this.checkProductStatus()
                }))
            },
            updateHeaderCount: function() {
                $.each(this.lists, (function() {
                    this.updateHeaderCount()
                }))
            }
        }), theme.AssetsLoader.onPageLoaded((function() {
            theme.StoreLists = new StoreLists
        })), ProductOptions.prototype = $.extend({}, ProductOptions.prototype, {
            load: function() {
                var e, t, n = this;

                function a(e, t) {
                    var a = t || $(this),
                        i = a.parents(n.selectors.options),
                        o = a.parents("[data-property]");
                    if (!(a.hasClass("disabled") || a.hasClass("active") && !o[0].hasAttribute("data-disable-auto-select"))) {
                        var r = o.find("[data-js-option-value]"),
                            s = a.parents("[data-js-product]"),
                            u = s.attr("data-json-product"),
                            c = [],
                            l = null;
                        r.removeClass("active"), a.filter("[data-js-option-value]").addClass("active"), o.removeAttr("data-disable-auto-select"), n._loadJSON(s, u, (function(e) {
                            var t = i.find("[data-js-option-value].active").add(i.find("option[data-value]:selected"));
                            $.each(t, (function() {
                                var e = $(this);
                                c.push(e.attr("data-value"))
                            })), i.find("[data-js-option-value]").removeClass("active"), $.each(e.variants, (function() {
                                if (c.join(" / ") === Shopify.handleizeArray(this.options).join(" / ")) return !this.available && theme.product.hide_options_without_availability_variants || (l = this), !1
                            })), !l && c.length > 1 && $.each(e.variants, (function() {
                                if (c[0] === Shopify.handleize(this.options[0]) && c[1] === Shopify.handleize(this.options[1])) {
                                    if (!this.available && (l || theme.product.hide_options_without_availability_variants)) return;
                                    if (l = this, this.available) return !1
                                }
                            })), l || $.each(e.variants, (function() {
                                if (c[0] === Shopify.handleize(this.options[0])) {
                                    if (!this.available && (l || theme.product.hide_options_without_availability_variants)) return;
                                    if (l = this, this.available) return !1
                                }
                            })), l || (l = n._getDefaultVariant(e)), n._updatePossibleVariants(s, {
                                update_variant: l,
                                json: e
                            }), $.each(l.options, (function(e, t) {
                                var n = i.find("[data-property]").eq(e);
                                n.find('[data-js-option-value][data-value="' + Shopify.handleize(t) + '"]').addClass("active"), n.filter("[data-js-option-select]").val(Shopify.handleize(t)).trigger("change", [!0])
                            })), n._switchVariant(s, {
                                update_variant: l,
                                json: e,
                                has_unselected_options: !!s.find("[data-property][data-disable-auto-select]").length
                            })
                        }))
                    }
                }
                $body.on("click", this.selectors.options + " [data-js-option-value]", a), $body.on("mouseenter", this.selectors.options + "[data-js-options-onhover] [data-js-option-value]", theme.debounce((function(e) {
                    a(0, $(e.target))
                }), 400)), $body.on("change", "[data-js-product] [data-js-option-select]", (function(e, t) {
                    if (!t) {
                        var n = $(this).find("option[data-value]:selected");
                        $(this).parents(".select").find("[data-js-select-dropdown]").removeAttr("data-dropdown-unselected"), a.call(n, e)
                    }
                })), $body.on("change", '[data-js-product-variants="control"]', (function() {
                    var e = $(this),
                        t = e.parents("[data-js-product], [data-js-product-clone]"),
                        a = !0,
                        i = !1;
                    t[0].hasAttribute("data-js-product-clone") && (t = $('[data-js-product-clone-id="' + t[0].getAttribute("data-js-product-clone") + '"]'), a = !1, i = !0);
                    var o = e.find("option:selected").attr("value"),
                        r = t.attr("data-json-product"),
                        s = null;
                    n._loadJSON(t, r, (function(e) {
                        $.each(e.variants, (function() {
                            if (+this.id == +o) return s = this, !1
                        })), n._switchVariant(t, {
                            update_variant: s,
                            json: e,
                            dontUpdateVariantsSelect: a,
                            updateProductOptions: i
                        })
                    }))
                })), theme.Global.responsiveHandler({
                    namespace: ".product.load-json",
                    element: $body,
                    delegate: "[data-js-product][data-js-product-json-preload]",
                    on_desktop: !0,
                    events: {
                        mouseenter: function() {
                            var a = $(this);
                            clearTimeout(e), e = setTimeout((function() {
                                a.attr("data-json-product") || (t = n._loadJSON(a, null, (function() {
                                    t = null
                                }), !1))
                            }), 300)
                        },
                        mouseleave: function() {
                            clearTimeout(e), t && (t.abort(), t = null)
                        }
                    }
                })
            },
            _loadJSON: function(e, t, n, a) {
                if (e[0].hasAttribute("data-js-process-ajax-loading-json")) e.one("json-loaded", (function() {
                    n && n(JSON.parse(e.attr("data-json-product")))
                }));
                else {
                    if (a = void 0 === a || a, !t) {
                        e.attr("data-js-process-ajax-loading-json", !0);
                        var i = e.attr("data-product-handle");
                        return $.ajax({
                            type: "GET",
                            url: theme.routes.root_url + "products/" + i,
                            data: {
                                view: "get_json"
                            },
                            cache: !1,
                            dataType: "html",
                            success: function(a) {
                                t = JSON.parse(a), e.attr("data-json-product", JSON.stringify(t)), n && n(t), e.trigger("json-loaded")
                            },
                            complete: function() {
                                e.removeAttr("data-js-process-ajax-loading-json")
                            }
                        })
                    }
                    n && n("object" == typeof t ? t : JSON.parse(t))
                }
            },
            switchByImage: function(e, t, n, a) {
                var i = this,
                    o = e.find("[data-js-product-image] img"),
                    r = e.attr("data-json-product"),
                    s = !1;
                this._loadJSON(e, r, (function(r) {
                    var u, c, l = r.images,
                        d = "by_id" === t ? +n : +o.attr("data-image-id");
                    $.each(l, (function(e) {
                        if (+this.id === d) return u = e, !1
                    })), (u || 0 === u) && ("prev" === t && 0 !== u ? u-- : "next" === t && u !== l.length - 1 && u++, $.each(r.variants, (function() {
                        if (this.featured_image && +this.featured_image.id == +l[u].id) {
                            if (theme.product.hide_options_without_availability_variants && !this.available) return;
                            return c = this, !1
                        }
                    })), c || ((c = i._getDefaultVariant(r)).featured_image = l[u]), i._updateOptions(e, {
                        update_variant: c,
                        json: r
                    }), i._switchVariant(e, {
                        update_variant: c,
                        json: r,
                        has_unselected_options: !!e.find("[data-property][data-disable-auto-select]").length
                    }), s = {
                        index: u,
                        image: l[u],
                        is_first: 0 === u,
                        is_last: u === l.length - 1
                    }), a(s)
                }))
            },
            _updatePossibleVariants: function(e, t) {
                var n, a, i = e.find(this.selectors.options_attr),
                    o = [],
                    r = [];
                if (t.update_variant.options.length > 1) {
                    function s(e = 0) {
                        e >= r.length || ($.each(o, (function() {
                            if (r[e].options[1] === this.options[1] && this.available) return r.splice(e, 1), --e, !1
                        })), s(++e))
                    }
                    $.each(t.json.variants, (function() {
                        if (Shopify.handleize(this.options[0]) === Shopify.handleize(t.update_variant.options[0])) {
                            if (!this.available) {
                                if (this.id !== t.update_variant.id && theme.product.hide_options_without_availability_variants) return;
                                r.push(this)
                            }
                            o.push(this)
                        }
                    })), s(), n = i.find("[data-property]").eq(1).find("[data-js-option-value]"), a = i.find("[data-property]").eq(1).filter("[data-js-option-select]").parents(".select").find("[data-value]"), n.addClass("disabled").removeClass("disabled-hidden"), a.attr("disabled", "disabled").removeAttr("data-disabled-hidden"), $.each(o, (function() {
                        n.filter('[data-js-option-value][data-value="' + Shopify.handleize(this.options[1]) + '"]').removeClass("disabled"), a.filter('[data-value="' + Shopify.handleize(this.options[1]) + '"]').removeAttr("disabled")
                    })), $.each(r, (function() {
                        n.filter('[data-js-option-value][data-value="' + Shopify.handleize(this.options[1]) + '"]').addClass("disabled-hidden"), a.filter('[data-value="' + Shopify.handleize(this.options[1]) + '"]').attr("data-disabled-hidden", "disabled")
                    })), t.update_variant.options.length > 2 && (o = [], r = [], $.each(t.json.variants, (function() {
                        if (Shopify.handleize(this.options[0]) === Shopify.handleize(t.update_variant.options[0]) && Shopify.handleize(this.options[1]) === Shopify.handleize(t.update_variant.options[1])) {
                            if (!this.available) {
                                if (this.id !== t.update_variant.id && theme.product.hide_options_without_availability_variants) return;
                                r.push(this)
                            }
                            o.push(this)
                        }
                    })), n = i.find("[data-property]").eq(2).find("[data-js-option-value]"), a = i.find("[data-property]").eq(2).filter("[data-js-option-select]").parents(".select").find("[data-value]"), n.addClass("disabled").removeClass("disabled-hidden"), a.attr("disabled", "disabled").removeAttr("data-disabled-hidden"), $.each(o, (function() {
                        n.filter('[data-js-option-value][data-value="' + Shopify.handleize(this.options[2]) + '"]').removeClass("disabled"), a.filter('[data-value="' + Shopify.handleize(this.options[2]) + '"]').removeAttr("disabled")
                    })), $.each(r, (function() {
                        n.filter('[data-js-option-value][data-value="' + Shopify.handleize(this.options[2]) + '"]').addClass("disabled-hidden"), a.filter('[data-value="' + Shopify.handleize(this.options[2]) + '"]').attr("data-disabled-hidden", "disabled")
                    })))
                }
            },
            _switchVariant: function(e, t) {
                t.update_variant.metafields = $.extend({}, t.json.metafields), $.each(t.json.variants_metafields, (function() {
                    +this.variant_id == +t.update_variant.id && (t.update_variant.metafields = $.extend(!0, t.update_variant.metafields, this.metafields))
                })), $.each(t.json.variants_quantity, (function() {
                    if (+this.id == +t.update_variant.id) return +this.quantity <= 0 && "continue" == this.policy && (t.update_variant.variant_pre_order = !0), !1
                })), this._updateContent(e, t)
            },
            _getDefaultVariant: function(e) {
                var t = {};
                return $.each(e.variants, (function() {
                    if (+this.id == +e.default_variant_id) return Object.assign(t, this), !1
                })), t
            },
            _updateContent: function(e, t) {
                var n = e.attr("data-js-product-clone-id"),
                    a = $('[data-js-product-clone="' + n + '"]');
                e.attr("data-product-variant-id", t.update_variant.id), e.add(a).find("[data-js-product-options]").attr("data-variant-was-chanched", !0), theme.StickySidebar && theme.StickySidebar.update("listener-enable"), this._updateFormVariantInput(e, t), this._updatePrice(e, a, t), this._updateTextLabelValue(e, a, t), this._updateLabelSale(e, t), this._updateLabelInStock(e, t), this._updateLabelPreOrder(e, t), this._updateLabelOutStock(e, t), this._updateLabelHot(e, t), this._updateLabelNew(e, t), this._updateAddToCart(e, a, t), this._updateDynamicCheckout(e, t), this._updateSKU(e, t), this._updateBarcode(e, t), this._updateAvailability(e, t), this._updateStockCountdown(e, t), this._updateGallery(e, t), this._updateLinks(e, t), this._updateHistory(e, t), this._updatePickupAvailable(e, t), theme.StoreLists.checkProductStatus(e), theme.ProductImagesNavigation.switch(e, t), t.dontUpdateVariantsSelect || this._updateVariantsSelect(e, t, !0), t.updateProductOptions && this._updateOptions(e, t), a.length && (this._updateVariantsSelect(a, t), this._updateOptions(a, t, e), theme.ProductImagesNavigation.switch(a, t)), theme.StickySidebar && theme.StickySidebar.update("listener-process"), theme.StickySidebar && theme.StickySidebar.update("listener-disable")
            },
            _updateOptions: function(e, t, n) {
                var a = this;
                e.each((function() {
                    var i, o = $(this),
                        r = o.find(a.selectors.options_attr);
                    r.length && (r.find("[data-js-option-value]").removeClass("active"), a._updatePossibleVariants(o, t), $.each(t.update_variant.options, (function(e, t) {
                        var n = r.find("[data-property]").eq(e);
                        n.find('[data-js-option-value][data-value="' + Shopify.handleize(t) + '"]').addClass("active"), n.filter("[data-js-option-select]").val(Shopify.handleize(t)).trigger("change", [!0])
                    }))), n && "enable" !== theme.product.variant_auto_select && ((i = e.find("[data-property]")).attr("data-disable-auto-select"), n.find("[data-property]").each((function(e, t) {
                        this.hasAttribute("data-disable-auto-select") || i.eq(e).removeAttr("data-disable-auto-select")
                    })))
                }))
            },
            _updateFormVariantInput: function(e, t) {
                e.find("[data-js-product-variant-input]").attr("value", t.update_variant.id)
            },
            _updateVariantsSelect: function(e, t, n) {
                var a = e.find("[data-js-product-variants]");
                a.length && !t.has_unselected_options && (a.val(t.update_variant.id), n && a.change())
            },
            _updateAddToCart: function(e, t, n) {
                var a = e.add(t).find("[data-js-product-button-add-to-cart]");
                if (a.length && !n.has_unselected_options)
                    if (n.update_variant.variant_pre_order) a.removeAttr("disabled").attr("data-button-status", "pre-order");
                    else if (n.update_variant.available) {
                    const e = a.attr("data-button-default-status");
                    e ? a.removeAttr("disabled").attr("data-button-status", e) : a.removeAttr("disabled data-button-status")
                } else a.attr("disabled", "disabled").attr("data-button-status", "sold-out")
            },
            _updateDynamicCheckout: function(e, t) {
                var n = e.find("[data-js-product-button-dynamic-checkout]");
                n.length && !t.has_unselected_options && (t.update_variant.available ? n.removeClass("d-none") : n.addClass("d-none"))
            },
            _updatePrice: function(e, t, n) {
                var a, i = e.add(t).find("[data-js-product-price]").parent(),
                    o = e.find("[data-js-product-price-sale-details]");
                i.length && theme.ProductPrice.insertFull(i, n.update_variant), o.length && ($.each(n.json.variants_price_sale_details, (function() {
                    +this.id == +n.update_variant.id && (a = this.details)
                })), o.html(a || "")[a ? "removeClass" : "addClass"]("d-none-important")), (i.length || o.length) && theme.MultiCurrency && theme.MultiCurrency.update()
            },
            _updateTextLabelValue: function(e, t, n) {
                var a = e.find("[data-section-container]"),
                    i = t.find("[data-section-container]");
                n.update_variant.option1 && a.eq(0).add(i.eq(0)).find("[data-label-value]").text(n.update_variant.option1), n.update_variant.option2 && a.eq(1).add(i.eq(1)).find("[data-label-value]").text(n.update_variant.option2), n.update_variant.option3 && a.eq(2).add(i.eq(2)).find("[data-label-value]").text(n.update_variant.option3)
            },
            _updateLabelSale: function(e, t) {
                var n = e.find("[data-js-product-label-sale]");
                if (n.length) {
                    var a = "",
                        i = t.update_variant.compare_at_price && t.update_variant.compare_at_price > t.update_variant.price;
                    if (n[i ? "removeClass" : "addClass"]("d-none-important"), i) {
                        var o = Math.ceil(100 - 100 * t.update_variant.price / t.update_variant.compare_at_price);
                        a += theme.strings.label.sale, a = Shopify.addValueToString(a, {
                            percent: o
                        })
                    }
                    n.html(a)
                }
            },
            _updateLabelInStock: function(e, t) {
                var n = e.find("[data-js-product-label-in-stock]");
                n.length && n[!t.update_variant.available || t.update_variant.variant_pre_order ? "addClass" : "removeClass"]("d-none-important")
            },
            _updateLabelPreOrder: function(e, t) {
                var n = e.find("[data-js-product-label-pre-order]");
                n.length && n[t.update_variant.variant_pre_order ? "removeClass" : "addClass"]("d-none-important")
            },
            _updateLabelOutStock: function(e, t) {
                var n = e.find("[data-js-product-label-out-stock]");
                n.length && n[t.update_variant.available ? "addClass" : "removeClass"]("d-none-important")
            },
            _updateLabelHot: function(e, t) {
                var n = e.find("[data-js-product-label-hot]");
                n.length && n[t.update_variant.metafields.labels && t.update_variant.metafields.labels.hot ? "removeClass" : "addClass"]("d-none-important")
            },
            _updateLabelNew: function(e, t) {
                var n = e.find("[data-js-product-label-new]");
                n.length && n[t.update_variant.metafields.labels && t.update_variant.metafields.labels.new ? "removeClass" : "addClass"]("d-none-important")
            },
            _updateSKU: function(e, t) {
                var n = e.find("[data-js-product-sku]");
                n.length && (n[t.update_variant.sku ? "removeClass" : "addClass"]("d-none-important"), n.find("span").html(t.update_variant.sku))
            },
            _updateBarcode: function(e, t) {
                var n = e.find("[data-js-product-barcode]");
                n.length && (n[t.update_variant.barcode ? "removeClass" : "addClass"]("d-none-important"), n.find("span").html(t.update_variant.barcode))
            },
            _updateAvailability: function(e, t) {
                var n = e.find("[data-js-product-availability]");
                if (n.length) {
                    var a = "",
                        i = 0;
                    $.each(t.json.variants_quantity, (function() {
                        if (+this.id == +t.update_variant.id) return i = +this.quantity, !1
                    })), t.update_variant.available ? (a += theme.strings.availability_value_in_stock, a = Shopify.addValueToString(a, {
                        count: i,
                        item: 1 === i ? theme.strings.layout.cart.items_count.one : theme.strings.layout.cart.items_count.other
                    })) : a += theme.strings.availability_value_out_stock, n.attr("data-availability", t.update_variant.available).find("span").html(a)
                }
            },
            _updateStockCountdown: function(e, t) {
                var n = e.find("[data-js-product-stock-countdown]"),
                    a = n.find("[data-js-product-stock-countdown-title]"),
                    i = n.find("[data-js-product-stock-countdown-progress]"),
                    o = +n.attr("data-min"),
                    r = 0;
                $.each(t.json.variants_quantity, (function() {
                    if (+this.id == +t.update_variant.id) return r = +this.quantity, !1
                })), a && a.html(Shopify.addValueToString(theme.strings.stock_countdown.title, {
                    quantity: '<span class="stock-countdown__counter">' + r + "</span>"
                })), i && i.width(r / (o / 100) + "%"), n.length && n[r > 0 && r < o ? "removeClass" : "addClass"]("d-none-important")
            },
            _updateGallery: function(e, t) {
                var n = e.find("[data-js-product-gallery].initialized");
                if (n.length) {
                    var a = t.update_variant.featured_media || t.json.media[0],
                        i = !!t.update_variant.option1 && t.update_variant.option1.replace('"', "");
                    n[0].goToSlideById(+a.id, i)
                }
            },
            _updateLinks: function(e, t) {
                var n = decodeURIComponent(window.location.origin) + "/products/" + t.json.handle + "?variant=" + t.update_variant.id;
                e.find('a[href*="products/' + t.json.handle + '"]').attr("href", n)
            },
            _updateHistory: function(e, t) {
                var n = e.find(this.selectors.options);
                if (!t.has_unselected_options && n.length && n[0].hasAttribute("data-js-change-history")) {
                    var a = window.location.href.split("?")[0] + "?variant=" + t.update_variant.id;
                    history.replaceState({
                        foo: "product"
                    }, a, a)
                }
            },
            _updatePickupAvailable: function(e, t) {
                if (!theme.product.show_pickup_available) return;
                const n = e.attr("data-product-handle"),
                    a = e.find("[data-js-pickup-available-container]");
                a.addClass("is-loading"), fetch(`${theme.routes.root_url}products/${n}/?variant=${t.update_variant.id}&view=variant_data`).then((e => e.text())).then((e => {
                    a.html($(e).find("[data-js-pickup-available-container]").html()).removeClass("is-loading")
                })).catch((e => {
                    console.error(e)
                }))
            }
        }), theme.AssetsLoader.onPageLoaded((function() {
            theme.ProductOptions = new ProductOptions
        }));
        class CartData {
            constructor() {
                this.rootURL = window.langify && "/" != window.langify.locale.root_url ? window.langify.locale.root_url + "/cart" : theme.routes.cart_url, this.currentData = {}, this.hasData = !1, theme.loadedCartData && this.setCurrentData(theme.loadedCartData), window.addEventListener("storage", (e => {
                    "cartCurrentData" === e.key && (this.setCurrentData(JSON.parse(localStorage.getItem("cartCurrentData"))), this.storageWasModified = !0)
                }))
            }
            setCurrentData(e) {
                return this.currentData = e, localStorage.setItem("cartCurrentData", JSON.stringify(this.currentData)), this.hasData = !0, this.currentData
            }
            updateData(e) {
                var t = this;
                return fetch(`${this.rootURL}.js`).then((e => e.json())).then((n => (t.setCurrentData(n), e))).catch((e => console.error("Error:", e)))
            }
            addItem(e) {
                return this.addItems([e])
            }
            addItems(e) {
                const t = {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        items: e
                    })
                };
                return fetch(`${this.rootURL}/add.js`, t).then((e => e.ok ? this.updateData(e) : e)).catch((e => console.error("Error:", e)))
            }
            changeItemById(e, t) {
                const n = {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        id: e,
                        quantity: t
                    })
                };
                return fetch(`${this.rootURL}/change.js`, n).then((e => e.json())).then((e => this.setCurrentData(e))).catch((e => console.error("Error:", e)))
            }
            changeItemByLine(e, t) {
                const n = {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        line: e,
                        quantity: t
                    })
                };
                return fetch(`${this.rootURL}/change.js`, n).then((e => e.json())).then((e => this.setCurrentData(e))).catch((e => console.error("Error:", e)))
            }
            removeItemById(e) {
                return this.changeItemById(e, 0)
            }
            removeItemByLine(e) {
                return this.changeItemByLine(e, 0)
            }
            getPageContent() {
                return fetch(`${this.rootURL}?view=ajax`, {
                    method: "GET"
                }).then((e => e.text())).catch((e => console.error("Error:", e)))
            }
            getPopupContent() {
                return fetch(`${this.rootURL}?view=popup`, {
                    method: "GET"
                }).then((e => e.text())).catch((e => console.error("Error:", e)))
            }
        }
        class CartViewer extends CartData {
            constructor() {
                super(), this.selectorPage = ".js-page-cart-ajax", this.selectorPopup = ".js-popup-cart-ajax", this.$counterDesktop = $("[data-js-cart-count-desktop]"), this.$counterMobile = $("[data-js-cart-count-mobile]"), this.$popup = $(".js-popup-cart-ajax"), this.$page = $(this.selectorPage), this.$freeShipping = $(".js-free-shipping")
            }
            updateCart() {
                return this.updateCartPopupContent().then((() => this.updateCartPageContent().then((() => {
                    this.updateCounter(), this.updateFreeShipping()
                }))))
            }
            updateCounter() {
                const e = this.currentData.item_count;
                this.$counterDesktop.attr("data-js-cart-count-desktop", e).html(theme.strings.header.cart_count_desktop.replace("{{ count }}", e)), this.$counterMobile.attr("data-js-cart-count-mobile", e).html(e)
            }
            updateCartPopupContent() {
                return this.$popup.length ? this.getPopupContent().then((e => {
                    this.$popup.html($(e).find(this.selectorPopup).html()), theme.MultiCurrency && theme.MultiCurrency.update(), theme.LazyImage.update()
                })) : new Promise((e => e()))
            }
            updateCartPageContent() {
                return this.$page.length ? this.getPageContent().then((e => {
                    this.$page.html($(e).find(this.selectorPage).html()), theme.LazyImage.update()
                })) : new Promise((e => e()))
            }
            updateFreeShipping() {
                if (this.$freeShipping.length) {
                    const e = this.currentData.total_price,
                        t = Math.max(theme.cart_free_shipping_value - e, 0);
                    this.$freeShipping.find("[data-js-progress]").css({
                        width: Math.min(e / (theme.cart_free_shipping_value / 100), 100) + "%"
                    }), this.$freeShipping.find("[data-js-text]").html(t > 0 ? theme.strings.cart.general.free_shipping_html.replace("{{ value }}", Shopify.formatMoney(t, theme.moneyFormat)) : theme.strings.cart.general.free_shipping_complete)
                }
            }
        }
        class CartController extends CartViewer {
            constructor() {
                super(), this.selectorButtonAdd = ".js-product-button-add-to-cart", this.selectorPopupButtonRemove = ".js-product-button-remove-from-cart", this.selectorPageInputQuantity = ".js-input-quantity-cart", this.popupController(), this.addToCartController(), this.removeFromCartPopupController(), this.changeQuantityCartPageController()
            }
            set storageWasModified(e) {
                this.updateCart()
            }
            popupController() {
                theme.Popups.addHandler("cart", "call.visible", (e => {
                    this.hasData ? e.trigger("contentloaded") : this.updateData().then((() => {
                        this.updateCartPopupContent().then((() => {
                            e.trigger("contentloaded")
                        }))
                    }))
                }))
            }
            addToCartController() {
                const e = this;
                $body.on("click", this.selectorButtonAdd, (function(t) {
                    const n = $(this),
                        a = n.attr("data-button-status");
                    if ("added" !== a && !n.hasClass("active")) {
                        const t = e.mergeWithDuplicateButtons(n),
                            i = n.parents("[data-js-product]");
                        if ("select" === a) e.disableButton(t), e.goToProductPage(i);
                        else {
                            const o = n.parents("form"),
                                r = e.serializeForm(o);
                            e.disableButton(t), e.addItem(r).then((o => {
                                if (o.ok) document.dispatchEvent(new CustomEvent("theme:cart::added", {
                                    detail: {
                                        button: n[0],
                                        product: i[0],
                                        data: r
                                    }
                                })), e.updateCart().then((() => {
                                    e.showPopup(), e.statusButtonAdded(t), setTimeout((() => e.enableButton(t, a)), 2e3)
                                }));
                                else if (422 === o.status) return o.json().then((n => {
                                    alert(n.description), e.enableButton(t, a)
                                }))
                            }))
                        }
                    }
                    t.preventDefault()
                })), $body.on("click", `[data-js-product-button-add-to-cart]:not(${this.selectorButtonAdd})`, (function() {
                    const t = $(this),
                        n = e.mergeWithDuplicateButtons(t);
                    setTimeout((() => e.disableButton(n)), 100)
                }))
            }
            removeFromCartPopupController() {
                const e = this;
                $body.on("click", this.selectorPopupButtonRemove, (function(t) {
                    const n = $(this);
                    if (!n.hasClass("active")) {
                        const t = e.mergeWithDuplicateButtons(n),
                            a = n.parents("[data-js-product]"),
                            i = a.attr("data-product-cart-line");
                        e.disableButton(t), document.dispatchEvent(new CustomEvent("theme:cart::removed", {
                            detail: {
                                button: n[0],
                                product: a[0],
                                data: {
                                    line: i
                                }
                            }
                        })), e.removeItemByLine(i).then((() => {
                            e.updateCart().then((() => {
                                e.enableButton(t)
                            }))
                        }))
                    }
                    t.preventDefault()
                }))
            }
            changeQuantityCartPageController() {
                const e = this;
                $body.on("change keyup custom.change", this.selectorPageInputQuantity, theme.debounce((function(t) {
                    const n = $(t.target),
                        a = Math.trunc(n.val()) || 1,
                        i = n.parents("[data-js-product]").attr("data-product-cart-line"),
                        o = n.attr("data-last-update-value");
                    o && +o === a || (n.attr("data-last-update-value", a), e.changeItemByLine(i, a).then((() => {
                        e.updateCart()
                    })))
                }), 700))
            }
            mergeWithDuplicateButtons(e) {
                const t = e.attr("data-js-button-add-to-cart-clone-id");
                return void 0 !== t && (e = e.add($(`[data-js-button-add-to-cart-clone="${t}"]`))), e
            }
            disableButton(e) {
                e.addClass("active").attr("disabled", "disabled")
            }
            statusButtonAdded(e) {
                e.each((function() {
                    const e = $(this),
                        t = e.outerWidth();
                    e.css({
                        "min-width": `${t}px`
                    })
                })), e.removeAttr("disabled").attr("data-button-status", "added")
            }
            enableButton(e, t) {
                e.removeAttr("data-button-status disabled style").removeClass("active"), t && e.attr("data-button-status", t)
            }
            showPopup() {
                theme.Popups.callByName("cart")
            }
            goToProductPage(e) {
                location.href = "/products/" + e.attr("data-product-handle")
            }
            serializeForm(e, t = {
                quantity: 1
            }) {
                return e.serializeArray().forEach((e => {
                    ["id", "quantity", "selling_plan", "purchase_option"].includes(e.name) ? t[e.name] = e.value : -1 !== e.name.indexOf("properties") && "" !== e.value && (t.properties = t.properties || {}, t.properties[e.name.replace("properties[", "").replace("]", "")] = e.value)
                })), e.serializeArray().forEach((e => {
                    -1 !== e.name.indexOf("selling_plan_") && (t[e.name] = e.value, "onetime" === e.value && (t.selling_plan = void 0))
                })), t
            }
        }
        theme.AssetsLoader.onPageLoaded((function() {
            theme.Cart = new CartController
        }))
    }(jQueryTheme);